let en = {
  translation: {
    legacy_timeline_repair: {
      title: "Quick update needed",
      body: "This training was built before the new timeline. Its videos and audio clips don't follow the new structure yet, so scenes can run short and exported videos can lose their sound.",
      note: "Takes a few seconds. Nothing else in your training changes.",
      videos: "Video",
      videos_plural: "Videos",
      audios: "Audio clip",
      audios_plural: "Audio clips",
      scenes: "Scene affected",
      scenes_plural: "Scenes affected",
      repair: "Update now",
      later: "Not now",
      running: "Updating…",
      retry: "Try again",
      preparing: "Getting ready…",
      progress: "Checking media files… {{done}} / {{total}}",
      saving: "Saving…",
      error: "The update couldn't finish. Check your connection and try again.",
    },
    unknownPlugin: "This element isn't supported in this version ({{id}})",
    help: {
      title: "Help & guides",
      nav: "Help",
      search_placeholder: "Search features…",
      no_results: "No guides match.",
      video_soon: "Video coming soon",
    },
    shortcuts: {
      title: "Keyboard shortcuts",
      trigger_label: "Keyboard shortcuts (press ?)",
      foot_hint: "Press ? any time to open or close this list.",
      click: "Click",
      section_general: "General",
      section_editing: "Editing",
      section_canvas: "Selection & arrangement",
      section_scenes: "Scene list",
      help_open: "Show or hide this list",
      esc_close: "Close the open dialog, panel or menu",
      preview: "Preview the course",
      print_pdf: "Print the course or save it as PDF",
      undo: "Undo",
      redo: "Redo",
      redo_alt: "Redo (alternative)",
      copy: "Copy the selected element (with nothing selected, copy the whole scene)",
      cut: "Cut the selected element",
      paste: "Paste a copied element or scene, or an image or text from the clipboard",
      duplicate: "Duplicate the selected element",
      delete_box: "Delete the selected element(s), or the selected clip on the timeline",
      select_all: "Select every element on the current scene",
      multi_select: "Add or remove an element from the selection (Shift + click works too)",
      clear_selection: "Clear a multi-element selection",
      move_box: "Nudge the selected element (1% of the scene per press)",
      resize_aspect: "Hold while resizing an element to lock or unlock its aspect ratio",
      scenes_toggle_select: "Add or remove a scene from the selection",
      scenes_range_select: "Select every scene between the last clicked one and this one",
      scenes_clear_select: "Clear the scene selection",
    },
    aideaChat: {
      buildNotice: {
        frozen: "Editing is frozen while scenes are being generated — you can preview.",
        progress: "Scene {{n}} of {{total}} ready",
        ready: "Your training is ready — you can edit now.",
        readyMessage:
          "Your training is ready — {{count}} scene built. Ask me to change anything: narration, visuals, a new scene.",
        readyMessage_plural:
          "Your training is ready — {{count}} scenes built. Ask me to change anything: narration, visuals, a new scene.",
        paused: "Scene 1 is ready — take a look.",
        pausedLine:
          "Continue with {{count}} more scene (≈{{credits}} credits), or improve scene 1 with a note.",
        pausedLine_plural:
          "Continue with {{count}} more scenes (≈{{credits}} credits), or improve scene 1 with a note.",
        continue: "Continue",
        improve: "Improve scene 1",
        improvePlaceholder: "What should change in scene 1?",
        send: "Rebuild scene 1",
        cancel: "Cancel",
        pauseFailed: "That didn't work — try again.",
        pauseBusy: "Too many requests — wait a moment.",
        pauseNoCredits: "Not enough credits for the remaining scenes — top up and try again.",
        improving: "Rebuilding scene 1 with your note…",
        composerWait: "You can write here again when the build pauses or finishes.",
        askPlaceholder: "Ask a question or describe a change to scene 1",
        chatThinking: "Thinking…",
        chatFailed:
          "I couldn't read that message. Do you want to rebuild scene 1 with it as a note, or just ask?",
        continueAsk: "Ready to move on?",
        continueConfirm: "Continue building the remaining scenes?",
        rebuildWith: "Rebuild scene 1 with: “{{note}}”",
        rebuildCost: "This rebuilds scene 1 and uses credits again.",
        rebuild: "Rebuild",
        rebuildThisNote: "Rebuild with this note",
        justAsk: "Just ask",
        optionSelect: "Select",
        optionSelected: "Selected",
        requested: "Requested",
        recommended: "Recommended",
        seeAll: "See all",
        seeAllTitle: "Choose a style or format for scene 1",
        tabStyles: "Styles",
        tabFormats: "Formats",
        pickLoading: "Loading…",
        pickFailed: "Couldn't load the list — try again.",
        pickEmpty: "Nothing to show here.",
        pickConfirm: "Select {{name}}",
        variantN: "Variant {{n}}",
        close: "Close",
        rebuildIn: "Rebuild scene 1 in {{name}}",
        rebuildStyleAll: "The remaining scenes will follow this style too.",
        noScene: "The build couldn't create any scene.",
        noSceneVoice:
          "The voice service is unavailable right now — pick another voice and try again.",
        noSceneAgent: "The design agent is unavailable right now — try again in a moment.",
        noSceneGeneric: "Something went wrong while building — try again.",
      },
      buildBrief: {
        title: "Course brief",
        objectives: "Learning objectives",
        themes: "Themes",
        scenes: "Scenes and narration",
        loading: "Loading your course recipe…",
        fallback: "Your course is being built — the recipe will appear here.",
        recipe: "Your recipe",
        recipeKeys: {
          flow: "Flow",
          format: "Visual format",
          style: "Image style",
          language: "Language",
          length: "Length",
          sceneCount: "Scenes",
          voice: "Voice",
          brand: "Brand",
        },
        minutes: "{{count}} minute",
        minutes_plural: "{{count}} minutes",
        sceneCount: "{{count}} scene",
        sceneCount_plural: "{{count}} scenes",
        sceneN: "Scene {{n}}",
      },
      tekno3: {
        composerNotEmpty: "Composer not empty",
        chipTextMotions: "Add text motions",
        chipVideoMotion: "Add a video motion",
        chipTextMotionsPrompt: "Add text motions to this scene",
        chipVideoMotionPrompt: "Add a video motion to this scene",
        quick: "Review scene",
        running: "tekno3 is reviewing this scene… this can take up to a minute.",
        found: "tekno3 found {{count}} issue.",
        found_plural: "tekno3 found {{count}} issues.",
        clean: "tekno3 found no issues — this scene looks good.",
        applyAll: "Apply all fixes ({{count}})",
        fix: "Fix",
        recheck: "Re-check",
        close: "Close",
        retry: "Try again",
        undo: "Undo",
        applied: "Applied {{count}} fix — one Undo reverts it.",
        applied_plural: "Applied {{count}} fixes — one Undo reverts them.",
        skipped: "{{count}} fix couldn't be applied.",
        skipped_plural: "{{count}} fixes couldn't be applied.",
        undone: "Fixes undone.",
        undoStale: "The scene changed since — use Undo in the editor (Ctrl+Z) instead.",
        at: "at {{sec}}s",
        frameAlt: "Show the scene at {{sec}}s",
        severity: { high: "High", med: "Medium", low: "Low" },
        category: {
          contrast: "Contrast",
          overflow: "Text overflow",
          safe_area: "Outside the safe area",
          overlap: "Overlap",
          min_font: "Font too small",
          reading_speed: "Reading speed",
          bible: "Style guide",
          timeline: "Timing",
          media: "Media",
          hierarchy: "Hierarchy",
          layout: "Layout",
          typography: "Typography",
          colour_contrast: "Colour contrast",
          imagery: "Imagery",
          motion_timing: "Motion timing",
          content_fit: "Content fit",
          accessibility: "Accessibility",
          other: "Other",
        },
        err: {
          failed: "The review didn't work — try again.",
          busy: "tekno3 is busy — wait a moment and try again.",
          tooLarge: "This scene is too large to send for review.",
          notFound: "This scene can't be reviewed — save the course and try again.",
          timeout: "The review is taking too long — try again in a moment.",
        },
      },
      buildWait: {
        stages: {
          plan: "Planning the course",
          style: "Choosing the style and design",
          voice: "Recording the narration voice",
          scene: "Building scene 1 · visuals and layout",
          ready: "Scene 1 ready",
          pause: "Paused for your review",
          rest: "Building the remaining scenes",
        },
        stagesTitle: "AI work stages",
        mindmap: "Mind map",
        mindmapPreparing: "Preparing mind map…",
        mindmapClose: "Back to progress",
        progress: "Scene {{done}}/{{total}}",
        progressDot: "Scene {{n}}: {{title}}",
        agents: {
          planner: { name: "Planner", a: "outlining scenes…", b: "shaping the story…" },
          art: { name: "Art director", a: "picking palette…", b: "matching the style…" },
          narrator: { name: "Narrator", a: "recording voice…", b: "timing the narration…" },
          designer: { name: "Designer", a: "laying out scene 1…", b: "placing visuals…" },
        },
        wait: {
          title: "While you wait",
          slide: "{{n}} of {{total}}",
          narration: "Narration · scene {{n}}",
          flows: "Another Aidea flow",
          models: "Models at work",
          quote: "Worth a thought",
          kind: {
            narration: "Show the narration",
            flows: "Show other Aidea flows",
            models: "Show the models at work",
            quotes: "Show a quote",
          },
          roles: {
            drafter: "Drafter (recipe, style)",
            narrator: "Narrator",
            planner: "Planner",
            sceneBuilder: "Scene builder",
            motion: "Motion",
          },
          effort: { low: "low", medium: "medium", high: "high" },
        },
      },
      build: {
        title: "Building your training",
        titleDone: "Your training",
        sceneReady: "Scene {{n}} is ready",
        sceneFailed: "Scene {{n}} could not be built — I'll continue with the rest",
        done: "Your training is ready — {{count}} scenes",
        none: "I couldn't build any scene. Go back to the chat and try again.",
        stoppedBudget: "Team budget exceeded — contact your admin",
        stoppedHold: "Build stopped: couldn't reserve credits. Try again.",
        stoppedByUser: "Build stopped. The scenes already built are kept.",
        stop: "Stop",
        stopConfirm: "Stop the build? Finished scenes are kept.",
        stopYes: "Yes, stop",
        stopNo: "Keep building",
        stopping: "Stopping after the current scene…",
        stopFailed: "Couldn't stop the build.",
        stoppedBalance: "The build stopped: not enough credits for the next scene.",
        expired: "This build has finished",
        expiredEmpty:
          "This build has ended and no scene was saved. Go back to the chat in the console to start it again.",
        balanceCta: "Check credits",
        connIssue: "Connection problem — retrying…",
        chatClosed: "Chat closed for this course",
        loadingChat: "Loading the conversation…",
        noToken:
          "Waiting for your session — I'll connect to the build as soon as you're signed in.",
        saveLocked: "Building — saving unlocks when the build finishes",
        preview: "Show",
        watch: "Watch from the start",
        showAgain: "Show scene {{n}} again",
        ghost: "(building)",
        canvas: {
          scene: "Building scene {{n}} of {{total}}",
          phase: {
            style_bible: "Setting the visual style",
            plan: "Planning the scene",
            generate: "Generating images and media",
            compose: "Composing the layout",
            review: "Reviewing the design",
            fix: "Polishing",
            saved: "Ready",
          },
        },
        step: {
          waiting: "Preparing the build…",
          narration: "Scene {{n}} · generating voice and images",
          images: "Scene {{n}} · images ready",
          video: "Scene {{n}} · animating a moment",
          motion: "Scene {{n}} · designing motion graphics",
          saving: "Scene {{n}} · placing it in the editor",
        },
        stepName: {
          narration: "narration",
          images: "images",
          video: "video",
          motion: "motion",
          saving: "saving",
        },
        phase: {
          style_bible: "Designing the course look…",
          plan: "Scene {{n}} · planning the beats",
          generate: "Scene {{n}} · generating images and motion",
          compose: "Scene {{n}} · composing the scene",
          review: "Scene {{n}} · checking a preview",
          fix: "Scene {{n}} · polishing the details",
        },
        status: "Preparing scene {{n}} — {{step}}",
        hint: "Each scene takes about 2–4 minutes",
        thumb: "Show image {{n}} in the preview",
        note: {
          plan_ready: "Motion plan ready",
          plan_failed: "No motion graphics for this scene",
          video_ready: "Video moment ready",
          video_failed: "Keeping the still image",
        },
      },
      assistant: "Aidea Assistant",
      newThread: "New Thread",
      newConversation: "New conversation",
      courseBuild: "Course build",
      empty: "Empty",
      messages: "{{count}} message",
      messagesPlural: "{{count}} messages",
      greetingTitle: "Hello there!",
      greetingSubtitle: "How can I help you today?",
      placeholder: "Message Aidea…",
      hint: "Aidea can make mistakes. Enter to send, Shift+Enter for a new line.",
      suggestions: {
        infographicTitle: "Create an infographic scene",
        infographicPrompt: "Create an infographic scene that summarizes the key points.",
        imageTitle: "Generate an image",
        imagePrompt: "Generate an image illustrating the main concept.",
        narrationTitle: "Update narration",
        narrationPrompt: "Update the narration for this scene.",
        avatarTitle: "Add avatar",
        avatarPrompt: "Add a talking avatar to present this scene.",
        videoTitle: "Generate video",
        videoPrompt: "Generate a video clip for this scene.",
        motionTitle: "Animate this scene (Motion)",
        motionPrompt: "Add motion graphics to this scene.",
      },
      motionEdit: {
        chip: "Edit",
        running: "Editing the scene...",
        cancelled: "Cancelled — the scene is unchanged.",
        failed: "The edit could not be made — the scene is unchanged.",
        done: "Done. The same moment, before and after:",
      },
      motion: {
        appliedFromTray: "Approved from the job tray — the plan was applied to the scene.",
        declinedFromTray: "Declined in the job tray — the scene is unchanged.",
        confirm:
          "Design on-screen text, scrims and icons for this scene from its images and narration.",
        summary: "Design motion graphics for this scene from its image and narration.",
        summary_plural:
          "Design motion graphics for this scene from its {{count}} images and narration.",
        cost: "≤{{credits}} credits",
        chip: "Motion",
        design: "Design motion graphics",
        cancel: "Cancel",
        cancelled: "Cancelled — nothing was designed.",
        designing: "Designing motion graphics… this can take 1–3 minutes. You can keep working.",
        ready: "Motion plan ready — {{count}} elements. Add them to the scene?",
        apply: "Apply to scene",
        applied: "Added {{count}} elements to the scene. One Undo removes them all.",
        undo: "Undo",
        failed: "Couldn't design the motion graphics. Please try again.",
        sceneMissing: "That scene no longer exists.",
        noImages: "This scene has no images yet. Add a background image first.",
        noTraining: "Open this training from your library first, then try again.",
        insufficientBalance: "You don't have enough credits for this. Top up and try again.",
        timeout: "This is taking longer than expected. Please try again in a few minutes.",
        densityLabel: "On-screen text",
        densityKey: "Key phrases",
        densityFull: "All text",
        graphicsLabel: "Graphics",
        graphicsMinimal: "Minimal",
        graphicsBalanced: "Balanced",
        graphicsRich: "Rich",
        textLabel: "Text in the images",
        textAuto: "Aidea decides",
        textExtract: "Animate it",
        textAdd: "Add new text",
        iconsLabel: "Icons",
        iconsAuto: "Aidea decides",
        iconsYes: "Yes",
        iconsNo: "No",
        someKept: "Some images kept their text",
        adjusted: "{{count}} item adjusted for readability.",
        adjusted_plural: "{{count}} items adjusted for readability.",
      },
      redesign: {
        chip: "Redesign",
        summary: "Redesign this scene in the {{format}} format (variant {{variant}}).",
        cost: "≤{{credits}} credits",
        run: "Redesign scene",
        cancel: "Cancel",
        cancelled: "Cancelled — the scene was not changed.",
        running: "Redesigning the scene… this can take a few minutes. You can keep working.",
        done: "The scene was redesigned. Undo history was reset because the new version came from the server.",
        failed: "Couldn't redesign the scene. Please try again.",
        sceneMissing: "That scene no longer exists.",
        noTraining: "Open this training from your library first, then try again.",
        busy: "Another build is running for this course. Wait for it to finish, then try again.",
        unsupported: "This scene can't be redesigned in a new format.",
        insufficientBalance: "You don't have enough credits for this. Top up and try again.",
        timeout: "This is taking longer than expected. Please check the scene in a few minutes.",
        saveFailed:
          "Couldn't save your latest changes first, so the redesign was not started. Save and try again.",
        tooLarge: "This scene is too large to redesign.",
      },
      formats: {
        chip: "Scene formats",
        loading: "Finding formats…",
        current: "Current",
        currentLine: "This scene is in:",
        variant: "Variant {{n}}",
        redesign: "Redesign in this format",
        sent: "Requested",
        redesignMessage:
          'Redesign this scene in the "{{name}}" format (format: {{slug}}, variant {{variant}}).',
        empty: "No format suggestions available for this scene.",
        failed: "Couldn't load format suggestions.",
      },
    },
    scene: "Scene",
    Delete: "Delete",
    Edit: "Edit",
    Copy: "Copy",
    Duplicate: "Duplicate",
    Show: "Show",
    Hide: "Hide",
    Lock: "Lock",
    Unlock: "Unlock",
    layerOrder: {
      bringToFront: "Bring to Front",
      forward: "Forward",
      backward: "Backward",
      sendToBack: "Send to Back",
    },
    HtmlContentAdd: "Add HTML Content",
    AddAnswer: "Add Answer",
    Design: "Design",
    Simulator: "Simulator",
    bgPreset: {
      transparent: "Transparent",
      dark: "Dark",
      navy: "Navy",
      white: "White",
      gray: "Gray",
    },
    All: "All",
    Videos: "Videos",
    Audios: "Audios",
    Skip: "Skip",
    No: "No",
    PleaseWait: "Please wait...",
    AnimationEntrance: "Entrance",
    AnimationExit: "Exit",
    ScreenTraining: "Screen Training",
    CustomHtmlContent: "Custom HTML Content",
    DownloadMP4: "Download MP4",
    SharedUsers: "Shared Users",
    NoUsersAddedYet: "No users added yet",
    InvitedOnly: "Invited only",
    TTS: {
      AddedToMyFiles: "Your generated sound has been added to 'My Files'.",
      AccessPreviousSounds:
        "You can access your previously generated sounds here or delete unused ones.",
    },
    EditImage: {
      processing: "Editing image…",
    },
    timeline: {
      mediaLoadFailed: "Media failed to load",
      mediaRetry: "Try again",
      addTrack: "Add Track",
      WaitingForInteractive: "Timeline waiting for interactive element",
      SkipInteractive: "Skip interactive and continue timeline",
    },
    ScreenTrainingUseReadyTemplate: "Use ready screen training template",
    PickCustomColor: "Pick custom color",
    SeekToStart: "Seek to start",
    Pause: "Pause",
    ShowMediaAssets: "Show Media Assets",
    ZoomOut: "Zoom out",
    ZoomReset: "Reset zoom (100%)",
    ZoomIn: "Zoom in",
    HideAll: "Hide all",
    TimelineRowImages: "Images",
    TimelineRowVideos: "Videos",
    TimelineRowAudios: "Audios",
    TimelineRowTexts: "Texts",
    ShowAll: "Show all",
    LockAll: "Lock all",
    UnlockAll: "Unlock all",
    SplitClipSourceSame: "Split clip — same source",
    EntranceAnimation: "Entrance animation",
    ExitAnimation: "Exit animation",
    SplitAtPlayhead: "Split at playhead",
    AlignToPrevious: "Align to previous element",
    AlignToNext: "Align to next element",
    OpenPanel: "Open panel",
    ClosePanel: "Close panel",
    SplitAtPlayheadHint: "Cuts the clip in two at the playhead",
    CutAndDelete: "Cut & delete",
    CutAndDeleteHint: "Removes everything before the playhead and snaps the rest to the start",
    CutPlayheadOutsideHint: "Move the playhead inside the clip first",
    OpenInVideoDirector: "Open in Video Director",
    PasteHtmlContentHere: "<div>Paste your HTML content here...</div>",
    FontCategory: {
      System: "System",
      Accessible: "Accessible",
      Handwriting: "Handwriting",
      Other: "Other",
      Custom: "Custom",
    },
    InteractiveKind: {
      MCQ: "Multiple Choice",
      VisualImage: "Image",
    },
    InteractiveCategory: {
      Questions: "Questions",
      Media: "Media",
    },
    ElementType: {
      TextCard: "Text Card",
      ImageCard: "Image Card",
      VideoCard: "Video Card",
      FlipCard: "Flip Card",
      TrueFalse: "True / False",
      MCQ: "Multiple Choice",
    },
    ClickToAddAnimation: "click to add animation",
    ItemProps: {
      AlignLeft: "Left",
      AlignCenter: "Center",
      AlignRight: "Right",
      Kind: {
        VisualLabel: "Image Label",
        VisualImage: "Image",
        TrueFalse: "True / False",
        YesNo: "Yes / No",
        FlipCard: "Flip Card",
        MCQ: "Multiple Choice",
        MultipleAnswer: "Multiple Answer",
        FillInBlank: "Fill in the Blank",
        DragDrop: "Drag & Drop",
        Matching: "Matching",
        Ordering: "Ordering",
        BranchingQuestion: "Branching Question",
        EndScreen: "End Screen",
        DialogCards: "Dialog Cards",
        MemoryGame: "Memory Game",
        DragTheWords: "Drag the Words",
        FindTheWords: "Find the Words",
        ImageHotspots: "Hotspots",
        QuestionSet: "Question Set",
        PersonalityQuiz: "Personality Quiz",
        CoursePresentation: "Course Presentation",
        SpeakTheWords: "Speak the Words",
        ImageSequencing: "Image Sequencing",
        SingleChoiceSet: "Single Choice Set",
        DragQuestion: "Drag Question",
        Essay: "Open-ended Essay",
        ShortLabel: "Label",
      },
      Action: {
        ShowItem: "Show element",
        HideItem: "Hide element",
        Resume: "Continue (timeline)",
        Complete: "Complete interaction",
        None: "None",
        ResumeLabel: "Continue",
        ResumeHint: "Resume timeline",
        CompleteLabel: "Complete",
        CompleteHint: "End interaction",
        ShowItemLabel: "Show Element",
        ShowItemHint: "Makes the selected item visible",
        HideItemLabel: "Hide Element",
        HideItemHint: "Hides the selected item",
        JumpSceneLabel: "Go to Scene",
        JumpSceneHint: "Jump to specified scene",
      },
      SelectPlaceholder: "— Select —",
      AddAction: "+ Add Action",
      AnswerActions: "Answer Actions",
      OnCorrect: "✓ If correct",
      OnWrong: "✗ If wrong",
      ClickActions: "Click Actions",
      OnClick: "👆 On click",
      OnCorrectShort: "If correct",
      OnWrongShort: "If wrong",
      OnClickShort: "On click",
      PromptDefault: "Question / Description",
      Text: "Text",
      FontSize: "Font Size",
      Color: "Color",
      Alignment: "Alignment",
      Bold: "Bold",
      ImageUrl: "Image URL",
      ObjectFit: "Fit",
      AltText: "Alt Text",
      AltTextPlaceholder: "Accessibility description",
      Question: "Question",
      CorrectAnswer: "Correct Answer",
      True: "True",
      False: "False",
      TrueLabel: "'True' Label",
      FalseLabel: "'False' Label",
      Yes: "Yes",
      No: "No",
      YesLabel: "'Yes' Label",
      NoLabel: "'No' Label",
      Options: "Options",
      Add: "+ Add",
      CorrectAnswerTitle: "Correct answer",
      AcceptedAnswers: "Accepted Answers (comma-separated)",
      CaseSensitive: "Case sensitive",
      FrontFace: "Front Face",
      BackFace: "Back Face",
      Title: "Title",
      Subtitle: "Subtitle",
      ShowScore: "Show score",
      QuestionInstruction: "Question / Instruction",
      PlaceholderText: "Placeholder Text",
      MinWordCount: "Min. Word Count",
      ComplexNote: "Additional settings for this element type are managed from the Workflow tab.",
      AddClickAction: "Add action on click",
      AddCorrectAction: "Add action for correct answer",
      AddWrongAction: "Add action for wrong answer",
      InteractionPanel: "Interaction panel",
      Interaction: "Interaction",
      Trigger: "Trigger",
      ActionLabel: "Action",
      Target: "Target",
      NoDisplayableItems: "No displayable items",
      Scene: "Scene",
      SelectScene: "— Select scene —",
      NoScenesFound: "No scenes found",
      GoToScene: "Go to scene",
    },
    filter_by_scene: "Filter by scene",
    all_files: "All Files",
    no_scene_media: "No media in this scene",
    Tools: "Tools",
    PointerEvents: "Pointer Events",
    Crop: "Crop",
    Border: "Border",
    RemoveBackground: "Remove Background",
    ChromaKey: "Chroma Key",
    PickColor: "Pick color",
    ClickToPickColor: "Click the image to pick the colour to remove",
    ConfirmRemoveBg: "Confirm",
    ClearPickedColor: "Clear colour",
    RemoveBgHint: "Confirm without picking a colour to auto-remove the background",
    ImageAdjustments: "Adjust",
    WhiteBalance: "White balance",
    Temperature: "Temperature",
    Tint: "Tint",
    Light: "Light",
    Brightness: "Brightness",
    Contrast: "Contrast",
    Color: "Color",
    Vibrance: "Vibrance",
    Saturation: "Saturation",
    Invert: "Invert",
    Texture: "Texture",
    Blur: "Blur",
    // Shared by every tool panel's reset button (Renk ayarları / Filtreler /
    // Yapı / Kırp), so it stays generic — tr and es already read this way.
    ResetAdjustments: "Reset settings",
    Tolerance: "Tolerance",
    BorderWidth: "Border width",
    BorderStyle: "Border style",
    BorderColor: "Border color",
    BorderRadius: "Border radius",
    QuickBorder: "Quick border",
    None: "None",
    Sharp: "Sharp",
    Rounded: "Rounded",
    Soft: "Soft",
    Pill: "Pill",
    Circle: "Circle",
    Dashed: "Dashed",
    Dotted: "Dotted",
    Padding: "Padding",
    Left: "Left",
    Right: "Right",
    Top: "Top",
    Bottom: "Bottom",
    Reset: "Reset",
    BackgroundColor: "Background color",
    Confirm: "Confirm",
    Opacity: "Opacity",
    Cropping: "Cropping...",
    DragToCrop: "Drag to select a region to crop",
    CropFailed: "Crop failed",
    RestoreOriginalImage: "Restore image to original",
    RestoreOriginalImageHint: "Undo the crop and bring back the full original image",
    Free: "Free",
    AspectRatio: "Aspect Ratio",
    JobFailed: "Operation failed",
    JobTimedOut: "Operation timed out",
    Filters: "Filters",
    FilterGroupNatural: "Natural",
    FilterGroupWarm: "Warm",
    FilterGroupCold: "Cold",
    FilterFresh: "Fresh",
    FilterVivid: "Vivid",
    FilterFlint: "Flint",
    FilterLuna: "Luna",
    FilterSky: "Sky",
    FilterNoir: "Noir",
    FilterTropic: "Tropic",
    FilterSun: "Sun",
    FilterLatte: "Latte",
    FilterBronze: "Bronze",
    FilterSand: "Sand",
    FilterGrape: "Grape",
    FilterIce: "Ice",
    FilterPolar: "Polar",
    FilterNight: "Night",
    FilterMist: "Mist",
    FilterOcean: "Ocean",
    FilterSteel: "Steel",
    FilterRetro: "Retro",
    FilterGroupVivid: "Vivid",
    FilterGroupSoft: "Soft",
    FilterGroupVintage: "Vintage",
    FilterScandinavian: "Scandinavian",
    FilterNordic: "Nordic",
    FilterAstro: "Astro",
    FilterArctic: "Arctic",
    FilterTundra: "Tundra",
    FilterSaturated: "Saturated",
    FilterRural: "Rural",
    FilterEffort: "Effort",
    FilterArya: "Arya",
    FilterHarsh: "Harsh",
    FilterAura: "Aura",
    FilterEla: "Ela",
    FilterDreamy: "Dreamy",
    FilterRose: "Rose",
    FilterCloud: "Cloud",
    FilterVinto: "Vinto",
    FilterFade: "Fade",
    FilterOld: "Old",
    FilterNostalgic: "Nostalgic",
    FilterDream: "Dream",
    FilterIntensity: "Intensity",
    FilterGroupMono: "Mono",
    FilterGroupColorBurst: "Color burst",
    FilterClassic: "Classic",
    FilterInk: "Ink",
    FilterPitchBlack: "Pitch black",
    FilterFilm: "Film",
    FilterNewspaper: "Newspaper",
    FilterBlackboard: "Blackboard",
    FilterLimitless: "Limitless",
    FilterHeatwave: "Heatwave",
    FilterAmethyst: "Amethyst",
    FilterMinty: "Minty",
    FilterHollyhock: "Hollyhock",
    FilterPoster: "Poster",
    FilterGroupCinematic: "Cinematic",
    FilterTeal: "Teal",
    FilterNoirBlue: "Noir blue",
    FilterAmber: "Amber",
    FilterThriller: "Thriller",
    FilterWestern: "Western",
    FilterEpic: "Epic",
    FilterGroupPastel: "Pastel",
    FilterPastelPink: "Pink",
    FilterPastelBlue: "Blue",
    FilterPastelMint: "Mint",
    FilterPastelLavender: "Lavender",
    FilterPastelPeach: "Peach",
    FilterPastelPowder: "Powder",
    FilterGroupNeon: "Neon",
    FilterCyber: "Cyber",
    FilterElectric: "Electric",
    FilterNeonMagenta: "Magenta",
    FilterAcid: "Acid",
    FilterPlasma: "Plasma",
    FilterLaser: "Laser",
    NarrationDraft: {
      Badge: "Draft",
      GeneratingInfo:
        "The voice is being generated in the background. You can switch scenes; it will wait here as a draft when ready.",
      ReadyInfo:
        "An edited text and voice are waiting as a draft. Approve this scene or discard the draft.",
      EditedInfo:
        "The text changed after the voice was generated. Regenerate the voice to approve it.",
      Approve: "Approve",
      ApproveHint: "Apply to this scene only",
      SaveAll: "Save all",
      SaveAllWaitGenerating: "Save all is available once the voice being generated is ready.",
      ApproveAllPartial:
        "{{ready}}/{{total}} drafts ready; the others are still generating or their text changed.",
      ShowOriginal: "Show original",
      ShowDraft: "Show draft",
      Discard: "Discard draft",
      SceneHasDraft: "This scene has an unsaved narration draft",
    },
    NarrateScope: {
      Title: "Where should we apply this voice?",
      Description: "Do you want to apply this voice only to this scene, or to all scenes?",
      ThisScene: "This scene only",
      ThisSceneDesc: "The voice is saved to this scene only.",
      AllScenes: "All scenes",
      AllScenesDesc: "This voice is applied to all scenes and every scene is re-narrated.",
      AllScenesDescCount: "This voice is applied to {{count}} scenes and each one is re-narrated.",
      Recommended: "Recommended",
      NarrateAllCheckbox: "Narrate all scenes",
      ConfirmTitle: "Narrate all scenes",
      ConfirmDesc:
        "This voice will be applied to all scenes and every scene will be re-narrated. Are you sure you want to continue?",
      ConfirmDescCount:
        "This voice will be applied to {{count}} scenes and each one will be re-narrated. Are you sure you want to continue?",
      ConfirmButton: "Yes, narrate",
      Applying: "Starting...",
      StartedTitle: "Narration started",
      Started: "Narration started ({{count}} scenes). It will finish in the background.",
      NoScenes: "No scenes with narration text were found.",
      Error: "Narration could not be started. Please try again.",
      Progress: "Narrating... {{progress}}%",
      DoneTitle: "Narration",
      Done: "{{count}} scenes were re-narrated.",
      PartialDone: "{{success}} scenes updated, {{failed}} failed.",
      Failed: "Narration failed.",
      Timeout: "The operation timed out.",
    },
    AnimateScope: {
      AnimateSceneButton: "Animate selected",
      AnimateAllButton: "Animate all ({{count}})",
      ConfirmDescCount:
        "This will animate {{count}} infographic images across all scenes ({{alreadyAnimated}} already have an animation).",
      ConfirmSceneDescCount: "This will animate {{count}} infographic images in this scene.",
      WarningNotRevertable: "This cannot be undone once started.",
      WarningCancelCharges: "Cancelling still bills clips already in progress.",
      Applying: "Starting...",
      AlreadyAnimatedBadge: "Already animated",
      StartButton: "Start",
      NoImages: "No infographic images were found in this training.",
      ProgressOf: "{{done}} of {{total}} done",
      CancelButton: "Cancel",
      CancelConfirm:
        "This will stop the batch. Clips already in progress still finish and are billed.",
      ResumeButton: "Resume",
      ResetButton: "Reset all",
      ApplyButton: "Apply to scenes",
      ApplyingAll: "Applying...",
      PreviewButton: "Preview",
      ItemRunning: "Animating…",
      ItemFailed: "Failed",
      BlockedTitle: "A bulk animation is in progress",
    },
    AnimatorPanel: {
      Retry: "Retry",
      ApplyToScene: "Apply to this scene",
      NotAnimated: "Not animated",
      SelectForAnimate: "Select for animation",
      NoAnimatableImages: "No images to animate in this scene",
      SceneProgress: "{{animated}}/{{total}}",
      SourceInfographic: "Infographic",
      SourceAllImages: "All images",
      UnsupportedFormatReason: "Unsupported format",
      RevertButton: "Revert",
      RevertToImage: "Revert to image",
      RevertConfirm: "Revert to the original image?",
      RevertNotFound: "Original image not found — can't revert this one.",
      UnsavedNotice: "Unsaved changes aren't in this list yet — save to include them.",
      RefreshList: "Refresh list",
      SaveAndRefresh: "Save and refresh",
      SaveError: "Couldn't save your changes. The list below is still your last saved version.",
      AnimateButton: "Animate",
      ReanimateButton: "Re-animate",
      BackToPanel: "Back",
      ProviderLabel: "Model",
      AppliedBadge: "Applied",
      NarrationLabel: "Narration",
      Play: "Play",
      Pause: "Pause",
      NoNarration: "No narration for this scene",
      TimeRange: "{{start}}–{{end}} sec",
      WholeScene: "whole scene",
      PredictedDuration: "{{sec}}s animation",
    },
    activity_log: {
      menu_label: "Activity History",
      title: "Activity History",
      hint: "Breakdown of the credits spent on this course.",
      total_spent: "Total spent",
      total_count: "Transactions",
      col_date: "Date",
      col_operation: "Operation",
      col_user: "User",
      col_amount: "Credits",
      empty: "No credit activity for this course yet.",
      error: "Could not load the records.",
      retry: "Try again",
      refresh: "Refresh",
    },
    localDraft: {
      title: "Local work found",
      body: "Unsaved local work was found for this training ({{savedAt}}). Do you want to see it?",
      serverNewer:
        "The server has a newer save than this local copy. If you open the local work and save, you will get a conflict warning.",
      open: "Open local work",
      useServer: "Continue with the server version",
      discardTitle: "Delete local work?",
      discardBody:
        "The local copy will be permanently deleted and the server version will be used.",
      discard: "Delete local work",
      keep: "Keep it",
      loadedNotice: "Local work loaded — remember to save.",
      targetRemovedNotice: "The original image was removed — the video was added as a new element.",
      quotaWarning: "Local backup could not be saved: browser storage is full.",
    },
    navbar: {
      credits: "credits",
      creditsInfo: {
        title: "Remaining credit",
        body: "This is the total remaining credit of the organization this course is charged to. It shows the whole account's available balance, not what this course alone has cost.",
        bodyMember:
          "This is what is left of your own share in the {{team}} team this month. The limit resets on {{date}}.",
        bodyTeam:
          "This is what the {{team}} team can still spend this month, shared with the other people in the team. The limit resets on {{date}}.",
      },
      autosave: {
        label: "Autosave",
        prompt:
          "Turn on autosave for this session? Saves automatically every 2 minutes when there are unsaved changes.",
        enable: "Enable",
        notNow: "Not now",
        pulseTooltip: "Unsaved changes — click to save",
      },
    },
    appModal: {
      showScene: "Show scene",
      showPanel: "Show panel",
    },
    authRequired: {
      title: "You need to sign in again",
      description: "Your session has expired or could not be verified. Sign in again to continue.",
      loopDescription: "Too many sign-in attempts — please refresh or try again shortly.",
      authenticate: "Authenticate",
      hardRefresh: "Hard refresh",
      goBack: "Go back to the training",
      serverErrorTitle: "Couldn't load the editor",
      serverErrorDescription: "The server is temporarily unavailable. Refresh to try again.",
      runtimeErrorTitle: "Connection problem",
      runtimeErrorDescription:
        "Couldn't reach the server. Please check your connection and try again.",
      crashTitle: "The editor hit an error",
      crashDescription:
        "A rendering error occurred — this is not a sign-in problem. Refresh to try again; if it keeps happening, share the message below.",
    },
    serverErrorToast: {
      message: "Server error — please wait a moment and try again.",
    },
    styleClipboard: {
      copy: "Copy style",
      copied: "Style copied",
      title: "Copied style",
      ready: "Ready to apply",
      hint: "Select the elements to apply it to",
      apply: "Apply",
      chip_box: "Box",
      chip_text: "Text",
      chip_image: "Image adjustments",
      kind_text: "Text",
      kind_image: "Image",
      kind_video: "Video",
      kind_other: "Element",
      details: "Show copied style",
      details_hide: "Hide details",
      group_box: "Box",
      group_text: "Text",
      group_pose: "Pose",
      group_image: "Image adjustments",
      group_animation: "Effect",
      row_background: "Background",
      row_border: "Border",
      row_radius: "Corners",
      row_padding: "Padding",
      row_opacity: "Opacity",
      row_filter: "Filter",
      row_font: "Font",
      row_size: "Size",
      row_weight: "Style",
      row_align: "Alignment",
      align_left: "Left",
      align_center: "Center",
      align_right: "Right",
      align_justify: "Justify",
      value_on: "On",
      row_color: "Color",
      row_highlight: "Highlight",
      row_rotation: "Rotation",
      row_flip: "Flip",
      row_preset: "Preset",
      row_intensity: "Intensity",
      row_entry: "Entrance",
      row_exit: "Exit",
      value_none: "None",
      value_default: "Default",
      value_transparent: "Transparent",
      value_flip_h: "Horizontal",
      value_flip_v: "Vertical",
      value_delay: "delay",
      chip_pose: "Pose",
      chip_animation: "Effect",
      clear: "Clear copied style",
      applied: "Style applied to {{n}} element(s)",
      applied_skipped:
        "Style applied to {{n}} element(s) · {{skipped}} skipped as a different kind of element",
    },
    aideaSmartElements: "Aidea Smart Elements",
    aideaSmartElementsProcessing: "Decomposing image...",
    aideaSmartElementsFailed: "Could not decompose this image",
    aideaSmartElementsNoSubjects: "No subjects detected in this image",
    aideaSmartElementsUngroup: "Ungroup",
    colorPicker: {
      color: "Color",
      alpha: "Opacity: {{value}}%",
      preview: "Preview",
      save: "Save",
    },
    knollingView: {
      title: "Media Assets",
      categories: "Categories",
      currentSceneOnly: "Current Scene Only",
      all: "All",
      videos: "Videos",
      images: "Images",
      audios: "Audios",
      noMedia: "No media assets found.",
      preview: "Preview",
      goToScene: "Go to Scene",
      play: "Play",
      pause: "Pause",
    },
    InsufficientBalance: {
      Title: "Insufficient Balance",
      Description: "Your credits are depleted. Please contact us for new credits.",
      RequestedAmount: "Requested credits",
      CurrentBalance: "Current balance",
      ContactUs: "Contact Us",
      Close: "Close",
      UnitMinutes: "minutes",
      UnitCredits: "credits",
      MessageLabel: "Your message",
      MessagePlaceholder: "Type your message here...",
      Send: "Send",
      Sending: "Sending...",
      SubmitError: "Something went wrong sending your message. Please try again.",
      MessageSentDescription: "Your request has been delivered. We'll get back to you soon.",
      TeamTitle: "Your team budget is used up",
      TeamDescription:
        "{{team}} has used up this month's credit budget for this. It renews on {{date}} — ask your organization admin if you need more before then.",
      TeamRemaining: "Team budget left",
      YourTeam: "Your team",
      Failed: "Credit check failed",
    },
    Layers: "Layers",
    Elements: "Elements",
    Assessments: "Assessments",
    // === Task 19 (rename Değerlendirmeler -> Etkileşim) ===
    Interactive: "Interactive",
    Library: "Library",
    Audio: "Knowledge Base",
    aiToolsMenu: "AI Tools",
    AddImage: "Add Image",
    ReferenceImages: "Reference Images",
    LoadingCourseReferenceImages: "Loading the training's reference images...",
    UploadFromComputer: "Upload from Computer",
    SelectFromLibrary: "Select from Library",
    AddTagPlaceholder: "Add tag...",
    AddVideo: "Add Video",
    AddSound: "Add Sound",
    SaveAndAdd: "Save and Add",
    AddAvatar: "Add Avatar",
    AddPdf: "Add PDF",
    SoundSound: "Sound",
    GenerateImage: "Generate Image",
    GenerateInfographicImage: "Generate Infographic Image",
    MotionizeScene: "Create Motion from Scene",
    MotionizeBlocked: "This scene contains",
    MotionizeBlockedTail: "— a scene may hold only its narration and images",
    MotionizeWorking: "Turning the scene into animation...",
    ReviewMotionScene: "Generated motion scene",
    MotionizeHint:
      "The scene's narration and images are used to generate an animated scene drawn entirely in code. The images are not reproduced — they tell the model what the scene is about. Motion lands on the narration's word timings.",
    MotionizeReferences: "Reference images",
    GenerateNewScene: "Generate New Scene",
    InfographicScene: "Infographic Scene",
    Animator: "Animator",
    "AI Agent": "AI Agent",
    QuestionGenerator: {
      Title: "Quiz Generator",
      TabSingle: "Single Scene",
      TabCombined: "Multiple Narrations",
      TabInteractive: "Interactive",
      IncludeScene: "Include in question",
      CombinedNarrations: "Selected Narrations",
      SelectScenesHint: "Select at least one scene from the list.",
      QuestionType: "Question Type",
      MultipleChoice: "Multiple Choice",
      MultipleAnswer: "Multiple Answer",
      FreeResponse: "Free Response",
      FillInBlank: "Fill in the Blank",
      Matching: "Matching",
      Ordering: "Ordering",
      SelectScenes: "Select Scenes",
      QuestionCount: "questions",
      UseThisScene: "Generate from this scene",
      EnableSceneHint: "Turn on the scene's switch to generate questions from it.",
      Review: "Generated questions",
      GeneratingQuestions: "Generating questions...",
      NoQuestionsGenerated: "No questions were generated.",
      ErrorOccurred: "An error occurred",
      CorrectMark: "Correct",
      History: "History",
      NoHistory: "No past questions.",
      PendingApproval: "Pending approval",
      Added: "Added",
      AddedForScene: "Questions added to this scene",
      AlreadyInTraining: "Already in training",
      ApproveThisQuestion: "Approve this question",
    },
    InteractiveScenario: {
      Type: {
        VisualText: "Text Card",
        VisualImage: "Image Card",
        VideoCard: "Video Card",
        FlipCard: "Flip Card",
        TrueFalse: "True / False",
        MCQ: "Multiple Choice",
      },
      ButtonStyle: {
        Primary: "Primary",
        Secondary: "Secondary",
        Success: "Success",
        Danger: "Danger",
      },
      Label: {
        Buttons: "Buttons",
        Content: "Content",
        Image: "Image",
        Description: "Description",
        ImageClickAction: "Image click action",
        Video: "Video",
        Autoplay: "Autoplay",
        FrontFace: "Front Face",
        BackFace: "Back Face",
        BackgroundColor: "Background color",
        FrontFaceBackground: "Front face background",
        BackFaceBackground: "Back face background",
        TextColor: "Text color",
        FrontFaceTextColor: "Front face text color",
        BackFaceTextColor: "Back face text color",
        FlipAction: "Action triggered on flip",
        ActionButtonOptional: "Action button (optional)",
        CorrectAnswer: "Correct answer:",
        CorrectActions: "Correct Actions",
        IncorrectActions: "Incorrect Actions",
        BackActions: "Back Actions",
        Title: "Title",
        Start: "START",
        SceneTitle: "Scene Title",
        Background: "Background",
        Pattern: "Pattern",
        HiddenStarts: "Starts hidden",
        VisibleStarts: "Starts visible",
        Hidden: "Hidden",
        SceneCountSuffix: "scenes",
        StartTitleCase: "Start",
        ElementCountSuffix: "element",
        ClickToFlip: "Click to flip",
      },
      Action: {
        SelectFromLibrary: "Select from Library",
        AddButton: "+ Add Button",
        ChangeImage: "Change Image",
        AddImage: "Add Image",
        RemoveImage: "Remove image",
        AddChoice: "+ Add Choice",
        AddElement: "+ Add Element",
        MakeStart: "Make Start",
        AddAction: "+ Add Action",
        AddScene: "Add Scene",
        DeleteScene: "Delete this scene",
        DeleteAction: "Delete action",
        OK: "OK",
      },
      Placeholder: {
        ButtonLabel: "Button label",
        OrEnterUrl: "or enter URL…",
        ImageDescriptionOptional: "Image description (optional)",
        VideoDescriptionOptional: "Video description (optional)",
        Title: "Title",
        Text: "Text",
        Question: "Question",
        TrueLabel: "True",
        FalseLabel: "False",
        TrueLabelDetailed: "True label",
        FalseLabelDetailed: "False label",
        ExplanationOptional: "Explanation (optional)",
        ChoiceText: "Choice text",
        ElementTitle: "Element title",
        AlertMessage: "Notification message",
        Value: "Value",
        AddImageHint: "Add image",
        AddVideoHint: "Add video",
      },
      Default: {
        Button: "Button",
        Title: "Title",
        Text: "Text",
        Continue: "Continue",
        FrontTextHint:
          "Write a hint or question on the front. The user flips the card to see the answer.",
        BackTitle: "Answer",
        BackTextHint: "Write the explanation or correct answer on the back.",
        QuestionHint: "Write your question here. The user selects True or False to answer.",
        MCQQuestionHint: "Write your question here. Mark the correct option below.",
        ExplanationHint: "Write the explanation for the correct answer here.",
        Choice1: "First option",
        Choice2: "Second option",
        Choice3: "Third option",
        NewScene: "New Scene",
        NewScenario: "New Scenario",
      },
      Badge: {
        VisualText: "Narration & Action Card",
        VisualImage: "Image Card",
        VideoCard: "Video Card",
        FlipCard: "Flip Card",
        TrueFalse: "True / False",
        MCQ: "Multiple Choice Question",
      },
      ActionType: {
        Navigate: "Go to Scene",
        SetElementVisibility: "Show/Hide Element",
        Alert: "Notification",
        SetVariable: "Update Variable",
        EndScenario: "End Scenario",
      },
      ActionOperator: {
        Set: "Set (=)",
        Add: "Add (+=)",
        Subtract: "Subtract (-=)",
        Toggle: "Toggle",
      },
      Visibility: {
        Show: "Show",
        Hide: "Hide",
        Toggle: "Toggle",
      },
      Option: {
        True: "True",
        False: "False",
        SelectScene: "— select scene —",
        SelectElement: "— select element —",
        SelectVariable: "— variable —",
      },
      Empty: {
        Title: "No scenario found",
        Description: "Create a new scenario for this element",
        Create: "Create Scenario",
        NoElementsInScene: "No elements in this scene",
        AddElementFromPanel: "Add an element from the right panel",
        NoScenesYet: "No scenes yet",
        StartByAddingFirstScene: "Start by adding the first scene",
        AddElementFromTopHint: "Add an element from above and position it on the canvas.",
      },
      EndScreen: {
        Title: "Interactive scenario completed",
        Restart: "Restart",
      },
    },
    SceneAudioVoice: "Scene Audio",
    NarratorSettings: "Narrator Settings",
    OrganizationStyle: "Organization Style",
    UsedPromptInCourse: "Custom Style Used in This Course",
    Generate: "Generate",
    Regenerate: "Regenerate",
    Generating: "Generating...",
    WriteYourNarration: "Write your narration...",
    GenerateSceneHint: "(Adds a fully ready new scene after the selected scene)",
    ImageText: "Image Text",
    WriteImageText: "Write the text you want to convert to an image...",
    GenerateImageHint: "(Adds only 1 infographic image to the current scene)",
    GenerateScene: "Generate Scene",
    GenerateFromNarration: "Generate From Narration",
    GenerateFromNarrationHint:
      "(Existing visuals in your scene will be replaced with new ones. If you don't want to lose them, please work on an empty scene.)",
    GenerateFromNarrationNewHint: "(Added as a new scene right after the current one.)",
    ApplyToCurrentScene: "Add to current scene",
    CreateAsNewScene: "Create as new scene",
    ReviewGeneratedImages: "Generated images",
    GeneratingScene: "Generating scene...",
    GeneratingImage: "Generating image...",
    ToCurrentScene: "current scene",
    AsNewScene: "new scene",
    Approve: "Approve",
    Close: "Close",
    Discard: "Discard",
    Play: "Play",
    Pause: "Pause",
    NoSoundInScene: "No sound found in this scene.",
    RestoreNarrationText: "Restore narration text",
    CreateEmptySceneAndSound: "(First create an empty scene and sound)",
    CreateAudio: "Create Audio",
    CreatingAudio: "Creating Audio...",
    AIGenerate: "AI Generate",
    ChooseFromLibrary: "Choose from library",
    UploadMyImage: "Upload my image",
    ImageEdit: {
      Scope: "Scope",
      RemoveAllText: "Remove All Text",
      RemoveSelectedText: "Remove Selected Text",
      TranslateAllText: "Translate All Text",
      TranslateSelectedText: "Translate Selected Text",
      TargetTexts: "Target Texts",
      TargetTextPlaceholder: "Text (e.g. SALE)",
    },
    // The two generative tabs of Add Image: a 3D object and a motion graphic
    // from a prompt.
    SceneVisual: {
      Output: "Output",
      OutputMotion: "Standard",
      OutputGif: "GIF",
      OutputWebp: "WebP",
      OutputMp4: "MP4",
      AiEdit: "Edit with AI",
      AiEditHint: "Write what should change. It is applied to the current motion graphic.",
      AiEditHintLoop:
        "Write what should change. It is applied to the animation and the {{format}} is rendered again.",
      AiEditPlaceholder: "E.g. make the circle smaller · make the text red · darken the background",
      AiEditRunning: "Applying the change",
      AiEditRunningMeta:
        "This can take a few minutes — you can close this window; it is applied to the box when done.",
      AiEditApply: "Apply",
      AiEditUnavailable:
        "This image cannot be edited with AI (no source). You can generate a new motion graphic.",
      ToVideo: "Convert to MP4 / WebP",
      ToVideoHint:
        "The motion is converted as it is, at its own length, and added to the scene. No model is used and no credits are charged.",
      ToVideoMp4Hint: "Added as a video with autoplay on. Plays in sync with the timeline.",
      ToVideoWebpHint:
        "Added as an image that plays once and holds its last frame. It does not follow the timeline playhead: it keeps playing on its own when you pause or scrub.",
      ToVideoRunning: "Converting to video",
      ToWebpRunning: "Converting to WebP",
      ToVideoRunningMeta:
        "This can take a few minutes — you can close this window; it is added to the scene when done.",
      ToVideoApply: "Convert",
      ToVideoUnavailable: "This box cannot be converted to a video.",
      Generate: "Generate",
      Regenerate: "Generate again",
      GeneratingMeta:
        "The model is writing — this can take a few minutes; you can close the dialog.",
      InputRequiredTitle: "A description is needed",
      InputRequired: "Write what you want to see, or use the scene's narration.",
      NarrationPlaceholder: "This scene's narration…",
      StyleBrief: "Style direction (optional)",
      StyleBriefPlaceholder: "Palette, mood, typography — e.g. dark ground, teal accent, plain",
      Model: "Model",
      ModelAuto: "Automatic (Sonnet 5.5)",
      ModelSonnet: "Sonnet 5.5",
      ModelOpus: "Opus 5.5",
      ModelDeepseekFlash: "DeepSeek V4.1 Flash",
      Orientation: "Orientation",
      Duration: "Length (s)",
      DurationPlaceholder: "e.g. 15",
      ThreeD: {
        Tab: "3D Object",
        Title: "3D object",
        Placeholder: "What should be modelled? e.g. a four-chambered human heart that opens up",
        Generating: "Building the 3D object…",
        Hint: "The camera, the labelled points and the meaningful interactions are derived from what you write.",
      },
      Motion: {
        GifHint:
          "The animation makes one full cycle in this time and loops forever (at most {{max}} s). It is added to the scene as an image.",
        GifDurationRequired: "For a {{format}}, enter a length between 2 and {{max}} seconds.",
        DurationRequiredTitle: "Length needed",
        DurationRequired: "Enter how many seconds the motion runs (between 2 and {{max}}).",
        DurationHint:
          "If the motion finishes sooner, its final picture keeps looping for the rest of the time.",
        Tab: "Motion Graphic",
        Title: "Motion graphic",
        Placeholder:
          "What should move? e.g. a three-stage process appearing in order, with the last stage emphasised",
        Generating: "Building the motion graphic…",
        Hint: "The model builds the order of events from your text; you set the length.",
      },
    },
    ImageHistory: {
      Tab: "Activity Log",
      AudioTab: "Audio Activity Log",
      AvatarTab: "Avatar Activity Log",
      CurrentBalance: "Current Balance",
      MonthlySpending: "Monthly Spending",
      TrainingImageSpending: "Image Spending",
      TrainingVideoSpending: "Video Spending",
      TrainingAudioSpending: "Audio Spending",
      TrainingAvatarSpending: "Avatar Spending",
      TrainingSpending: "Total Spending",
      Credits: "Credits",
      Preview: "Preview",
      TaskName: "Task Name",
      Name: "Name",
      Scene: "Scene",
      Model: "Model",
      DateTime: "Date & Time",
      Prompt: "Prompt",
      Narration: "Narration",
      Category: "Type",
      CategoryImage: "Image",
      CategoryVideo: "Video",
      CategoryAudio: "Voice Over",
      CategoryAvatar: "Avatar",
      Status: "Status",
      Amount: "Amount",
      Completed: "Completed",
      Empty: "No images generated yet",
      EmptyVideo: "No videos generated yet",
      EmptyAudio: "No audio generated yet",
      EmptyAvatar: "No avatars generated yet",
      EmptyAny: "No items generated yet",
      Play: "Play",
      ShowAll: "All Activities",
      ShowOnlyThis: "Filtered",
      View: "View",
      LoadError: "Failed to load history",
      AddFailed: "Could not add it to the scene; please try again.",
      NoOrganization: "Organization not found",
      Close: "Close",
      DefaultNameImage: "AI Generated Image",
      DefaultNameVideo: "AI Generated Video",
      DefaultNameNarration: "AI Generated Narration",
      DefaultNameAvatar: "AI Generated Avatar",
    },
    CreditEstimate: {
      Button: "Credits",
      Tooltip: "Show credit cost for this operation",
      Title: "Credit Estimate",
      Cost: "This operation",
      Balance: "Your balance",
      Sufficient: "Sufficient balance",
      Insufficient: "Insufficient balance",
      MultiProvider: "providers total",
      Loading: "Loading",
      Duration: "Duration",
      Failed: "Credit check failed",
    },
    TopLeft: "Top Left",
    TopCenter: "Top Center",
    TopRight: "Top Right",
    BottomLeft: "Bottom Left",
    BottomCenter: "Bottom Center",
    BottomRight: "Bottom Right",
    Center: "Center",
    BoldWhiteWithShadow: "Bold White (Shadow)",
    BoldBlackWithShadow: "Bold Black (Shadow)",
    LargeWhiteBold: "Large White Bold",
    MediumWhiteRegular: "Medium White Regular",
    SmallWhiteItalic: "Small White Italic",
    SmallGrayItalic: "Small Gray Italic",
    BoldYellowWithShadow: "Bold Yellow (Shadow)",
    Custom: "Custom",
    CustomStyle: "Custom Style",
    Style: "Style",
    StyleDisabledNote: "(Disabled - using style reference image)",
    CustomCardLabel: "Custom",
    ChangeImage: "Change Image",
    MoreStyles: "More styles",
    EditPhoto: "Edit Photo",
    MerlinAI: "Aidea Wizard AI",
    Merlin: "Aidea Wizard",
    MerlinVideoTranscribe: "Transcribe",
    ViewTranscript: "View transcript",
    MerlinVideoNarration: "Formal Narration",
    MerlinVideoVoiceover: "Voice-over",
    MerlinComingSoon: "Coming soon",
    Sestek: "Sestek",
    DefaultOption: "Default",
    NarrationStyle: "Narration Style",
    NarrationSound: "Narration Voice",
    NarrationStyleNone: "None (voice verbatim)",
    NarrationFailed: "Narration generation failed.",
    NarrationTextPlaceholder: "Type the text to voice…",
    NarrationReady: "Narration ready.",
    GenerateAgain: "Generate again",
    NoVoicesFound: "No voices found.",
    PleaseEnterNarrationText: "Please enter the narration text.",
    MerlinVideoTranscribing: "Transcribing video…",
    MerlinVideoTranscribeFailed: "Transcription failed. Click to dismiss.",
    TranscribeRetry: "Try again",
    TranscribeStart: "Start transcription",
    TranscribeEmptyHint:
      "No transcript yet for this video. Start one — it runs in the background and appears here when it's ready.",
    TranscribeStartedHint:
      "Transcription started. It runs in the background — the transcript will appear here when it's ready.",
    TranscriptionVideoTooLong:
      "This video is too long to transcribe. The maximum is {{maxMinutes}} minutes.",
    TranscriptionVideoTooLarge:
      "This video is too large to transcribe. The maximum is {{maxMB}} MB.",
    TranscriptModal_Title: "Transcript",
    TranscriptModal_Save: "Save",
    TranscriptModal_Saving: "Saving…",
    TranscriptModal_Copy: "Copy",
    TranscriptModal_Copied: "Copied",
    MerlinNarrationNeedsTranscript: "Transcribe the video first",
    TranscriptModal_Close: "Close",
    ChangeTool: "Change Tool",
    Collapse: "Collapse",
    AspectRatioLock: "Lock aspect ratio",
    AspectRatioLockHint:
      "Keeps proportions while resizing. Hold Shift while dragging a handle to temporarily switch it on or off.",
    OptionalEnhancements: "Optional Enhancements",
    TextInVideo: "Text in Video",
    TextInImage: "Text in Image",
    OverlayText: "Overlay Text",
    ClickToUploadOrDragDrop: "Click to upload or drag and drop",
    PNGJPGOrWEBPMax10MB: "PNG, JPG, or WEBP (max 100MB)",
    WritePrompt: "Write Prompt",
    FromNarration: "From Narration",
    RawPrompt: "Continue with Direct Prompt",
    NoBalance: "You don't have enough credits for this operation.",
    EnrichTexts: "AI Enrich",
    Enriching: "Enriching...",
    EnrichMyPrompt: "✨ Enrich my prompt",
    SceneNarration: "Scene Narration",
    EditToHighlightKeyVisuals: "Edit to highlight key visuals",
    DescribeSceneNarration: "Describe the scene narration...",
    EachSentenceBecomesScene:
      "Each sentence becomes a scene. Remove what doesn't need visual support.",
    TipRemoveParts:
      "Tip: Remove parts that don't need visual support. Keep the sentences describing what should be shown.",
    GenerateImagePromptFromNarration: "Generate Image Prompt from Narration",
    AIWillUse: "AI will use",
    AIVoice: "AI Narration Voice",
    AvatarNarration: "Avatar Narration",
    FromLibrary: "From Library",
    RecordMyVoice: "Record My Voice",
    SoundModalTitle: "Sound",
    AvatarModalTitle: "Avatar",
    FromLibraryComingSoon: "No sounds found in the library.",
    RecordMyVoiceComingSoon: "Voice recording will be available soon.",
    CreateNewNarration: "Create New Narration",
    RestorePreviousNarration: "Restore deleted audio",
    DeletedAudio: "deleted",
    RestoreDeletedAudio: "Restore",
    GenerateVoice: "Generate Voice",
    RegenerateVoice: "Regenerate Voice",
    SelectNarrator: "Select Narrator",
    CreateAvatar: "Create Avatar",
    CreatingAvatar: "Creating...",
    OnlyAvailableForAidea: "Only available for Aidea provider",
    AzureKeepVoiceComingSoon: "Azure Avatar lip-sync with narration voice will be available soon.",
    UploadMyFile: "Upload Your File",
    SoundTabTooltip: {
      ai: "Turn your text into a natural narration voice with AI.",
      avatar: "Create an avatar to present your text.",
      library: "Choose from your saved sounds.",
      record: "Record your own voice and use it as the narration.",
      upload: "Upload an audio file from your device (mp3, wav, etc.).",
    },
    FileSizeLimit: {
      TooLarge: "File is too large. You can upload up to {{max}} MB.",
    },
    AddSoundUpload: {
      DropTitle: "Click to upload or drag and drop",
      DropSubtitle: "MP3, WAV, or M4A (max 100MB)",
      Remove: "Remove",
      SoundSettings: "Sound Settings",
      StartTime: "Start Time",
      FinishTime: "Finish Time",
      Volume: "Volume",
      ErrorInvalidType: "Only MP3, WAV, or M4A files can be uploaded.",
      ErrorTooLarge: "File is too large. The maximum size is 500MB.",
    },
    SceneAudio: {
      Title: "Narration Audio",
      ErrorRequestFailed: "Request failed",
      ErrorPrefix: "Error",
      NoTrainingAudio: "No narration audio saved for this training.",
      NoSceneAudio: "No narration audio found.",
      Collapse: "Collapse",
      Expand: "Expand",
      HideText: "Hide text",
      ShowText: "Show text",
      Pause: "Pause",
      Play: "Play",
      Video: "Video",
      ViewScene: "View scene",
      Edit: "Edit",
      Delete: "Delete",
      AddAudio: "Add audio",
    },
    Mindmap: {
      Title: "Mindmap",
      Open: "Open mindmap",
      OpenHint: "Opens in a new tab",
      Loading: "Loading...",
      Empty: "No mindmap was generated for this training.",
      EmptyHint: "Mindmaps are only produced for courses built from documents.",
      Error: "Could not load the mindmap.",
    },
    ImgTextToImage: {
      TabStyleLibrary: "Style Library",
      TabTraditionalMode: "Traditional Mode",
      Provider: {
        Flux: "Flux – 1.1 Pro",
        GeminiNano: "Gemini – 3.1 Flash Image",
        Grok: "Grok",
        GPTImage: "GPT-image-1.5",
      },
      WaitMessage: "Please wait...",
    },

    SelectVoice: "Select voice",
    Voice1: "Voice 1",
    Voice2: "Voice 2",
    Voice3: "Voice 3",
    Voice4: "Voice 4",
    Voice5: "Voice 5",
    Voice6: "Voice 6",
    Voice7: "Voice 7",
    Voice8: "Voice 8",
    UsingProjectVoice: "✓ Using project voice",
    SavedVoiceLoaded: "✓ Saved voice loaded",
    VoiceGenerated: "✓ Voice generated",
    OwnVoice: "Own Voice",
    VoiceText: "Voice Text",
    VoiceTags: "Voice Tags",
    EstimatedVoiceDuration: "Estimated voice duration",
    UseSlideNotes: "Use slide notes",
    Minutes: "min",
    Seconds: "sec",
    Chars: "chars",
    chars: "chars",
    DefaultVoiceText:
      "Welcome to Ada Lovelace Test 01 training. In this module we will examine the psychological foundations of user behavior.",
    ProjectVoice: "Project voice:",
    Carlos: "Carlos",
    ElevenLabs: "ElevenLabs",
    Hulya: "Hülya",
    German: "German",
    Speed: "1.0x",
    FemaleWarmTurkish: "Female · Warm · Turkish",
    ChangeNarrator: "Audio Narration",
    AIVoices: "AI Voices",
    BringYourOwnVoice: "Clone Voice",
    Service: "Service",
    LanguageNames: {
      Turkish: "Turkish",
      English: "English (US)",
      EnglishUK: "English (UK)",
      Spanish: "Spanish",
      French: "French",
      German: "German",
      Chinese: "Chinese",
      Azerbaijani: "Azerbaijani",
      Arabic: "Arabic",
      Russian: "Russian",
      Japanese: "Japanese",
      Portuguese: "Portuguese (BR)",
      Italian: "Italian",
      Dutch: "Dutch",
      Polish: "Polish",
      Korean: "Korean",
      Hindi: "Hindi",
      Multilingual: "Multilingual",
    },
    AccentLanguage: "Accent / Language",
    AccentAuto: "Automatic",
    Voice: "Voice",
    Voices: "Voices",
    SampleLanguage: "Sample Language",
    CloneYourVoice: "Clone Your Voice",
    CloneVoiceDescription: "Upload an audio sample to clone your voice",
    VoiceName: "Voice Name",
    EnterVoiceName: "Enter voice name",
    AudioFile: "Audio File",
    ChooseFile: "Choose File",
    NoFileChosen: "No file chosen",
    CloneVoice: "Clone Voice",
    PleaseSelectAudioFile: "Please select a valid audio file",
    DropFileHere: "Drop your audio file here",
    DragDropOrClick: "Drag & drop your audio file here",
    BrowseFiles: "Browse Files",
    Uploading: "Uploading...",
    UploadError: {
      Failed: "File could not be uploaded.",
      TooManyRequests:
        "Too many uploads are running at once. Try again once the in-progress uploads finish.",
      Unauthorized: "You are not authorized for this action. Please sign in again.",
      TooLarge: "The file exceeds the server limit.",
      ServerError: "The file could not be uploaded due to a server error.",
    },
    YourClonedVoices: "Your Cloned Voices",
    NoClonedVoices: "No cloned voices yet. Upload an audio sample to clone your voice.",
    ClonedVoice: "Cloned",
    ConfirmDeleteVoice: "Are you sure you want to delete this voice?",
    VoiceClonedSuccessfully: "Voice cloned successfully!",
    VoiceDeletedSuccessfully: "Voice deleted successfully!",
    PleaseSelectClonedVoice: "Please select a cloned voice",
    Success: "Success",
    UploadFile: "Upload File",
    UploadVoiceFile: "Upload Voice File",
    RecordWithMicrophone: "Record with Microphone",
    StartRecording: "Start Recording",
    StopRecording: "Stop Recording",
    Recording: "Recording...",
    RecordingSample: "Recording Sample",
    ReadThisText: "Read this text:",
    RecordingInstruction: "Click 'Start Recording' button to begin recording your voice sample.",
    NextSample: "Next Sample",
    FinishRecording: "Finish Recording",
    MicrophonePermissionDenied: "Microphone permission denied. Please allow microphone access.",
    MicrophoneErrorMessage: "Microphone error. Please check your microphone.",
    RecordingText1:
      "Hello, this is a test of my voice. I am reading this text to create a voice clone. The technology behind voice cloning is fascinating. This sample will help create an accurate representation of my voice.",
    RecordingText2:
      "The quick brown fox jumps over the lazy dog. This sentence contains every letter of the alphabet. Voice cloning requires diverse speech samples. Multiple recordings help improve accuracy and naturalness.",
    RecordingText3:
      "I enjoy reading books and listening to music in my free time. These activities help me relax and unwind after a long day. Learning new things is one of my favorite hobbies. I believe continuous growth is essential for personal development.",
    RecordingText4:
      "Technology is changing the way we communicate with each other. Artificial intelligence is becoming more integrated into our daily lives. Voice assistants are now common in many households. The future of human-computer interaction is evolving rapidly.",
    RecordingText5:
      "Every morning I wake up feeling refreshed and energized for the day ahead. A good night's sleep is crucial for maintaining health and productivity. I try to maintain a consistent sleep schedule throughout the week. Regular exercise also helps me stay alert and focused.",
    RecordingText6:
      "Artificial intelligence is revolutionizing many industries around the world. From healthcare to finance, AI is making significant impacts. Machine learning algorithms are becoming more sophisticated each day. The potential applications seem limitless and exciting.",
    RecordingText7:
      "I like to travel and explore new places around the world. Meeting people from different cultures is an enriching experience. Every journey teaches me something valuable about life. Travel broadens perspectives and creates lasting memories.",
    RecordingText8:
      "Learning new skills helps us grow and develop as individuals. Whether it's a language, instrument, or technical skill, practice is key. Consistent effort over time leads to mastery. The journey of learning itself is rewarding and fulfilling.",
    RecordingText9:
      "Good communication is essential for building strong relationships with others. Listening actively is just as important as speaking clearly. Understanding different perspectives helps resolve conflicts peacefully. Empathy and respect form the foundation of meaningful connections.",
    RecordingText10:
      "I believe in working hard and staying positive through challenges. Success often comes from persistence and determination. Maintaining a growth mindset helps overcome obstacles. Every setback is an opportunity to learn and improve.",
    PlayRecording: "Play Recording",
    ResetRecording: "Reset Recording",
    SoundSettings: "Sound Settings",
    StartTimeOnSlide: "Start Time on Slide",
    SoundVolume: "Sound Volume",
    ZeroPercent: "0%",
    HundredPercent: "100%",
    SceneOf: "Scene {{current}} of {{total}}",
    SceneEndTime: "End time on scene",
    Generating: "Generating...",
    Loading: "Loading...",
    Google: "Google",
    NoVoicesAvailable: "No voices available",
    SelectProvider: "Select a provider",
    SelectLanguage: "Select a language",
    PleaseSelectProvider: "Please select a provider",
    PleaseSelectLanguage: "Please select a language",
    PleaseSelectVoice: "Please select a voice",
    PleaseSelectNarrator: "Please pick a narrator before generating the voiceover.",
    Gender: "Gender",
    SelectGender: "Select Gender",
    AllGenders: "All",
    AllProviders: "All",
    Male: "Male",
    Female: "Female",
    ChangeVoice: "Change voice",
    ListenPreview: "Listen to the generated preview",
    Of: "of",
    NoVoicesFound: "No voices found",
    PleaseGenerateVoiceFirst: "Please generate voice first",
    PleaseUploadFileFirst: "Please upload a file first",
    WhatVoiceShouldAvatarUse: "What voice should the avatar use?",
    KeepMyNarrationVoice: "Keep my narration voice",
    UseSceneAudio: "Use scene audio",
    LipSyncToHulya: "Lip-sync to Hülya",
    UseADifferentVoice: "Use a different voice",
    HeyGen: "HeyGen",
    Azure: "Azure",
    AzureVideo: "Azure Video",
    Aidea: "Aidea",
    Tavus: "Tavus",
    Synthesia: "Synthesia",
    GoogleAvatars: "Google Avatars",
    StockAvatars: "Stock Avatars",
    ChooseFromBuiltInAvatars: "Choose from built-in avatars",
    CreateNewAvatar: "Create New Avatar",
    UploadVideoOrRecord: "Upload video or record",
    ComingSoon: "Coming Soon",
    SeeAllAvatars: "See All Avatars",
    ShowLess: "Show Less",
    VoiceProvider: "Voice Provider",
    SelectVoiceProvider: "Select voice provider",
    LipsyncProvider: "Lipsync Provider",
    LipsyncAuto: "Auto",
    LipsyncCustom: "Custom",
    AvatarAspectRatio: "Aspect Ratio",
    AvatarAspectSquare: "Square (1:1)",
    AvatarAspectWide: "Landscape (16:9)",
    // Avatar tab redesign (two-step layout)
    AvatarStepSubtitle: "Make an avatar to narrate your scene",
    AideaAvatarLibrary: "Aidea Avatar Library",
    AideaAvatarLibraryMeta: "Ready presenters from Aidea & partners",
    CreateYourOwn: "Create your own",
    CreateYourOwnMeta: "Generate with AI, or upload a video or photo",
    AvatarSourceChange: "Change",
    AvatarPickGenderHint: "Pick a gender first",
    AvatarSelectFirstHint: "Select or create an avatar first",
    AvatarShuffleIdentity: "Random name & title",
    Shuffle: "Random",
    AvatarPlaySample: "Play sample",
    AvatarDelete: {
      Button: "Delete avatar",
      Title: "Delete avatar",
      Desc: "Are you sure? Your saved avatar “{{name}}” will be deleted completely, along with every record created for it. This cannot be undone. Videos already added to scenes are not affected.",
      Cancel: "Cancel",
      Confirm: "Yes, delete",
      Deleting: "Deleting...",
      ErrorNotDeletable: "This avatar cannot be deleted.",
      ErrorGeneric: "The avatar could not be deleted, please try again.",
    },
    VoiceDelete: {
      Button: "Delete voice",
      Title: "Delete cloned voice",
      Desc: "Are you sure? Your cloned voice “{{name}}” will be deleted. This cannot be undone. Narrations already added to scenes are not affected.",
    },
    All: "All",
    SeeAllCount: "See all {{num}}",
    AvatarIdentity: "Identity",
    AvatarNameShort: "Name",
    GenerationMethod: "Generation method",
    GenerateWithPrompt: "Generate with Prompt",
    GenerateWithPromptMeta: "Describe your avatar free-form",
    GenerateWithGuide: "Generate with Guide",
    GenerateWithGuideMeta: "Answer a few quick questions",
    UseYourOwnMedia: "Use your own media",
    UseYourOwnMediaMeta: "Upload a video or a photo",
    DescribeYourAvatar: "Describe your avatar",
    Suggestions: "Suggestions",
    AvatarSuggestAge: "age",
    AvatarSuggestEthnicity: "ethnicity",
    AvatarSuggestProfession: "profession",
    AvatarSuggestHairColor: "hair color",
    AvatarSuggestFacial: "facial features",
    AvatarSuggestClothing: "clothing",
    AvatarSuggestBackground: "background",
    AvatarSuggestPose: "sitting / standing",
    AvatarSuggestHands: "hands visible",
    GeneratePersonaPreview: "Generate persona preview",
    VoiceAndNarration: "Voice & narration",
    VoiceAndNarrationSub: "Edit the narration text and choose the voice",
    UseSceneAudio: "Use scene audio",
    UseSceneAudioMeta: "Narrate with this scene's existing audio",
    GenerateNewVoice: "Generate new voice / Edit scene audio",
    GenerateNewVoiceMeta: "Pick an AI voice to read the narration",
    EditText: "Edit text",
    AudioTags: "Audio tags",
    GenerateVoicePreview: "Generate voice preview",
    GenerateVoicePreviewFull: "Generate full",
    GenerateVoicePreviewShort: "Generate 5s preview",
    VoicePreviewNotEnoughText: "Not enough text for a 5-second preview. Please enter more text.",
    GeneratingVoicePreview: "Generating…",
    AvatarGenerateFirst: "Please generate your avatar first (Generate persona preview).",
    AvatarCompleteFieldsHint: "Please complete the required selections first.",
    AvatarVideoGenerating: "Generating avatar video…",
    AvatarVideoGeneratingHint: "This may take a few minutes. Please keep this window open.",
    GenerateVoicePreviewHint: "Reads the narration text with the selected voice",
    StopPreview: "Stop preview",
    DeletePreview: "Delete preview",
    LipSync: "Lip sync",
    Engine: "Engine",
    AvatarRendersForScene: "Avatar renders for {{scene}} · {{duration}}",
    AvatarRendersForSceneNoDuration: "Avatar renders for {{scene}}",
    // "Natural talking video" (Omni / Seedance + ElevenLabs STS) — add_sound_modal/talking_avatar
    TalkingAvatar: {
      Beta: "Beta",
      SceneHasJob: "This scene has a natural talking video job",
      Method: {
        Title: "Generation method",
        Lipsync: "Lip sync",
        LipsyncMeta: "The avatar video is lip-synced to the voice you pick",
        Talking: "Natural talking video",
        TalkingMeta:
          "Video and speech are generated together; the voice is converted to the voice you pick",
      },
      Step: {
        Title: "Text & voice",
        Sub: "What the avatar says and the voice it speaks with",
        Locked: "Pick or create an avatar first",
      },
      Text: {
        Label: "Narration text",
        Placeholder: "Type what the avatar should say…",
        Meter: "~{{est}} s / {{max}} s · {{words}} words · ~{{segments}} segments",
        MeterEmpty: "Up to {{max}} s of speech",
        SummaryBase: "~{{seconds}} s · {{words}} words · {{segments}} segments",
        SummaryBaseSingle: "~{{seconds}} s · {{words}} words",
        SummaryCredit: "~{{credits}} credits",
        WarnMax: "You are close to the model limit (max {{max}} s).",
        OverMax: "The text is too long for this model (max {{max}} s); please shorten it.",
        Warn: "You are close to the model's limit.",
        Over: "The text is too long for this model; please shorten it.",
        FetchScene: "Fetch Scene Text",
        NoSceneText: "No narration text was found in this scene.",
      },
      Voice: {
        Title: "Voice",
        ProviderFilter: "Provider",
        GenderFilter: "Gender",
        ChangeVoice: "Change voice",
        Count: "{{shown}} / {{total}} voices",
        Hint: "The speech in the video is converted to the selected voice.",
        HintAudioDriven: "The narration is voiced with this voice; the avatar speaks along to it.",
        ProviderElevenLabs: "ElevenLabs",
        ProviderAzure: "Azure",
        ProviderUnconfigured: "not configured",
        ProviderUnpriced: "no price set",
        Neutral: "Neutral",
        GenderMismatchFemale:
          "The selected voice is female and the avatar is male. The avatar will speak with this voice.",
        GenderMismatchMale:
          "The selected voice is male and the avatar is female. The avatar will speak with this voice.",
        All: "All",
        Female: "Female",
        Male: "Male",
        Loading: "Loading voices…",
        Empty: "No voices found.",
        LoadError: "Voices could not be loaded.",
        Play: "Play sample",
        Stop: "Stop",
        Select: "Select a voice",
        Change: "Change",
        Close: "Close",
      },
      Model: {
        Label: "Model",
        Loading: "Loading models…",
        Unavailable: "This model is not available right now",
        Unpriced: "No price is defined for this model",
        AudioDrivenHint:
          "The voice is generated first with the voice you pick, then the avatar speaks to it in one take (up to {{minutes}} min)",
        SeedanceNotAiAvatar:
          "Seedance works only with AI-generated avatars. Choose Omni for this avatar.",
        SeedanceAvatarRejected: "This character can't be used with this model. Choose Omni.",
        LoadError: "Models could not be loaded.",
        Retry: "Retry",
      },
      Aspect: {
        Label: "Aspect ratio",
        Wide: "Landscape (16:9)",
        Tall: "Portrait (9:16)",
        Square: "Square (1:1)",
        Cropped: "generated as 16:9 and cropped to a square",
      },
      Language: "Spoken language",
      Advanced: "Advanced settings",
      Credit: {
        Line: "~{{credits}} credits · {{segments}} segments · ~{{seconds}} s",
        Loading: "Estimating credits…",
        Insufficient: "Your balance looks too low for this job.",
        Error: "Credit estimate unavailable.",
      },
      Missing: {
        Title: "To create",
        Model: "pick an available model",
        Avatar: "pick an avatar",
        AvatarUploading: "wait for the avatar upload to finish",
        AvatarUploadFailed: "the avatar upload failed — upload it again",
        Text: "enter the narration text",
        TextOver: "shorten the text",
        TextPart: "split the long sentences",
        Voice: "pick a voice",
        Aspect: "pick a supported aspect ratio",
        ActiveJob: "wait for this scene's job to finish",
      },
      Processing: {
        Title: "Generating avatar video…",
        Note: "You can close this window; when it is done it waits for approval in the Activity panel.",
        Background: "Continue in background",
        Unknown:
          "The job status could not be read for a while. You can also follow it in the Activity panel.",
        Refresh: "Refresh status",
        Unreachable:
          "This job's status cannot be reached (the job was not found or does not belong to this account). You can check it in the Activity panel.",
        Dismiss: "Hide / Back to settings",
        DismissConfirm:
          "The job keeps running in the background; when it is done you can add it from the Activity panel.",
        DismissConfirmYes: "Hide",
        DismissCancel: "Cancel",
      },
      Job: {
        SeedancePortraitHint:
          "Preparing the character for Seedance; the first time can take a few minutes.",
      },
      Result: {
        Title: "Avatar Video Created",
        Preview: "Preview: the video is added muted; the scene plays the converted voice.",
        Target: "Narration sound",
        NewSound: "Add as a new sound",
        Split: "split",
        ReplaceNote:
          "The selected narration is replaced with this voice; the video is added muted.",
        AddNote: "The voice is added as a new narration; the video is added muted.",
        SplitNote:
          "This narration is split on the timeline; all of its pieces are replaced by one sound.",
        BgRemovalFailed:
          "The background could not be removed; the video is added with its background.",
        CropFailed: "The square crop failed; the video is delivered in 16:9.",
        WebmSafari: "Transparent video (WebM) may not play in Safari.",
        Regenerate: "Regenerate",
        AddToScene: "Add to Scene",
        Adding: "Adding…",
        AddFailed: "Could not add it to the scene; please try again.",
        Fetching: "Fetching the result…",
        FetchFailed:
          "The result could not be fetched yet. Try again, or hide this and add it from the Activity panel.",
        RetryFetch: "Fetch the result again",
      },
      History: {
        NoResult: "This job's result could not be obtained; it was not added to the scene.",
      },
      Failed: {
        Title: "The video could not be created",
        CreditNote: "Failed jobs are not charged.",
        Back: "Back to settings",
        SwitchToVeo: "Switch to Omni",
        PickVoice: "Pick another voice",
        PickModel: "Pick another model",
      },
      Errors: {
        TEXT_TOO_LONG:
          "The text is too long for this model (~{{est}} s / max {{max}} s). Please shorten it.",
        TEXT_PART_TOO_LONG:
          "Part of the text is too long to be spoken in one segment; split the long sentences.",
        VOICE_NOT_ALLOWED:
          "This voice cannot be used. Pick one of the listed ElevenLabs, organization or Azure voices.",
        VOICE_PROVIDER_UNAVAILABLE:
          "This voice provider is not available right now; pick another voice.",
        AVATAR_REJECTED_SEEDANCE: "This avatar cannot be used with Seedance, pick Omni",
        AVATAR_REJECTED: "The selected model rejected this avatar; try a different avatar.",
        CONTENT_FILTERED: "The text or the avatar was blocked by the provider's content filter.",
        VOICE_DRIFT:
          "The voice conversion did not line up with the video; try again or pick another voice.",
        PROVIDER_FAILED:
          "The video provider could not finish the job; try again later or with another model.",
        PRICE_LIST_MISSING: "No price is defined for this model; pick another model.",
        TOO_MANY_ACTIVE: "At most 3 natural talking videos can be generated at the same time.",
        MODEL_UNAVAILABLE: "This model is not available right now; pick another model.",
        AVATAR_NOT_ALLOWED:
          "This avatar cannot be used; pick one from the library or one you uploaded.",
        TEXT_EMPTY: "The narration text is empty; please enter some text.",
        RATIO_UNSUPPORTED: "The selected model does not support this aspect ratio.",
        INVALID_REQUEST: "The submitted details are not valid.",
        Generic: "The video could not be created; please try again.",
      },
    },
    AvatarName: "Avatar Name",
    AvatarNamePlaceholder: 'e.g. "Kemal"',
    TitleRole: "Title / Role",
    TitleRolePlaceholder: 'e.g. "CEO" or "Trainer"',
    HarryBusiness: "Harry - Business",
    MaleGestures: "Male - Gestures",
    NarrationText: "Narration Text",
    FetchSceneText: "Fetch Scene Text",
    NoNarrationTextFoundInScene: "No narration text was found in this scene.",
    Back: "Back",
    InfographicEngine: {
      label: "Aidea Engine",
      subtitle: "(visual behavior engine selection)",
      engine1_label: "Aidea Engine 1",
      engine1_description: "Generates infographic visuals in a consistent, standard style.",
      engine2_label: "Aidea Engine 2",
      engine2_description:
        "Generates visually rich infographics with varied, dynamic styles across slides; creates more visuals per scene.",
      engine3_label: "Aidea Engine 3",
      engine3_description:
        "Produces a clean, clear style with minimal text in visuals, conveying content largely through imagery.",
      engine5_label: "Aidea Engine 5",
      engine5_description:
        "Produces a clean, focused style with fewer, bolder, well-spaced elements — at most 6 objects per visual — and minimal, punchy labels.",
      engine6_label: "Aidea Engine 6 (Editable text)",
      engine6_description:
        "Every heading and line on the picture becomes its own editable text box with its icon, animated in as the narration speaks it.",
      engine7_label: "Aidea Engine 7 (Characters)",
      engine7_description:
        "Uses the course's fixed cast — new visuals show the same characters with the same face, hair and outfit.",
      engine8_label: "Aidea Engine 8 (Characters, no text)",
      engine8_description:
        "Uses the same cast as Engine 7, with almost no visible text in the visuals.",
      engine9_label: "Aidea Engine 9 (Text-dense)",
      engine9_description:
        "Lets the learner read the substance of what they hear: a headline and its items in the narration's own words, each placed on the visual where it belongs — beside its part, at its step node, at its place on the map.",
      provider_locked:
        "The provider is fixed for character narration, because visuals are generated from the character reference sheets.",
    },
    DefaultNarrationText:
      "Welcome to Ada Lovelace Test 01 training. In this module we will examine the psychological foundations of user behavior.",
    UseTextFromAIVoice: "Use text from AI Voice",
    EnterTextToBeSpokenByAvatar: "Enter the text to be spoken by the avatar...",
    TransparentBackground: "Transparent Background",
    RemoveAvatarBackground: "Remove avatar background",
    // Avatar Narration - additional keys
    Time: "00:00 / 00:00",
    Avatar: "Avatar",
    Model: "Model",
    CreateFromText: "Create from Text",
    CreateFromSceneAudio: "Create from Scene Audio",
    SelectedAudio: "Selected Audio:",
    SceneAudioLabel: "Scene Audio",
    Preview: "Preview:",
    NoAudioFoundInScene: "No audio found in this scene.",
    NoElementInScene: "No elements in this scene yet",
    AvatarVideoCreated: "Avatar Video Created",
    AddToScene: "Add to Scene",
    AddedToScene: "Added to the scene",
    AddAgain: "Add again",
    Provider: "Provider",
    Language: "Language",
    Voice: "Voice",
    Loading: "Loading",
    Gender: "Gender",
    SourceVideo: "Source Video",
    Uploading: "Uploading...",
    UploadVideo: "Upload Video",
    VideoFormats: "MP4, MOV · 10s–60s",
    RecordVideo: "Record Video",
    UseYourWebcam: "Use your webcam",
    StartRecording: "Start Recording",
    StopRecording: "Stop Recording",
    SourcePhoto: "Source Photo",
    UploadPhoto: "Upload Photo",
    PhotoFormats: "JPG, PNG · Min 512px",
    TakePhoto: "Take Photo",
    StopCamera: "Stop Camera",
    UseYourCamera: "Use your camera",
    CapturePhoto: "Capture Photo",
    CameraAccessDenied: "Camera access denied.",
    FailedToUploadPhoto: "Failed to upload photo",
    FailedToUploadPhotoRetry: "Failed to upload photo. Please try again.",
    SourceTypeVideo: "Video",
    SourceTypePhoto: "Photo",
    SourceTypeAI: "With AI",
    SourceAI: "Generate with AI",
    AnimateProvider: "Animate Provider",
    AnimateProviderHint: "The selected provider will be used to animate the photo.",
    SaveAndUseAvatar: "Create & Use Avatar",
    AvatarCreatingVideo: "Creating\u2026",
    AvatarCreatingPhoto: "Animating\u2026",
    AvatarCreatingAi: "Generating\u2026",
    AvatarAiMode: "Mode",
    AvatarAiModePrompt: "Prompt",
    AvatarAiModeProperties: "Custom",
    AvatarAiStyle: "Style",
    AvatarAiPose: "Pose",
    AvatarAiPoseSeated: "Seated",
    AvatarAiPoseStanding: "Standing",
    AvatarAiStyleRealistic: "Realistic",
    AvatarAiStyleCartoon: "Cartoon",
    AvatarAiStyleAnime: "Anime",
    AvatarAiStyleAnimation: "Animated",
    AvatarAiStyle3D: "3D Animation",
    AvatarAiStyleIllustration: "Illustration",
    AvatarAiPromptLabel: "Describe your avatar",
    AvatarAiPromptPlaceholder:
      'e.g. "A 30-year-old Mediterranean woman, shoulder-length wavy brown hair, hazel eyes, friendly smile, wearing a navy business jacket, plain studio background."',
    AvatarAiEthnicity: "Ethnicity / heritage",
    AvatarAiEthnicityPlaceholder: 'e.g. "Mediterranean", "East Asian"',
    AvatarAiFacialFeatures: "Facial features",
    AvatarAiFacialFeaturesPlaceholder: 'e.g. "oval face, almond eyes, straight nose"',
    AvatarAiAgeRange: "Age range",
    AvatarAiHairColor: "Hair color",
    AvatarAiHairStyle: "Hair style",
    AvatarAiEyeColor: "Eye color",
    AvatarAiSkinTone: "Skin tone",
    AvatarAiFaceShape: "Face shape",
    AvatarAiBodyType: "Body type",
    AvatarAiExpression: "Expression",
    AvatarAiClothing: "Clothing style",
    AvatarAiAccessories: "Accessories",
    AvatarAiAccessoriesPlaceholder: 'e.g. "glasses, watch"',
    AvatarAiOptionOther: "Other",
    AvatarAiOptionOtherPlaceholder: "Type your own…",
    AvatarAiAgeCustomPlaceholder: "e.g. 30 (min 25)",
    AvatarAiBackground: "Background / setting",
    AvatarAiEnvironment: "Environment",
    AvatarAiProvider: "AI Provider",
    AvatarAiProviderGemini: "Gemini",
    AvatarAiProviderGeminiFast: "Gemini Fast",
    AvatarAiProviderGrok: "Grok",
    AvatarAiContentFilterError:
      "Content not suitable. Please soften your prompt or selections and try again.",
    AvatarAiProcessing: "Generating your AI avatar…",
    AvatarAiStageQueued: "Queued…",
    AvatarAiStagePromptRefine: "Refining prompt…",
    AvatarAiStageGenerating: "Generating video (this may take a few minutes)…",
    AvatarAiStageFinalizing: "Finalizing…",
    AvatarAiPreviewTitle: "Generated avatar preview",
    AvatarAiRefinedPrompt: "Refined prompt",
    AvatarAiUseThis: "Use this avatar",
    AvatarAiGenerateAnother: "Generate another",
    AvatarAiCategory: "Category",
    AvatarAiCategoryEducational: "Educational",
    AvatarAiCategoryProfessional: "Professional",
    AvatarAiCategoryMarketing: "Marketing",
    AvatarAiCategoryTraining: "Training",
    AvatarAiCategoryPresentation: "Presentation",
    AvatarAiAgeTeen: "Teen (13–19)",
    AvatarAiAgeYoungAdult: "Young adult (20–29)",
    AvatarAiAgeAdult: "Adult (30–49)",
    AvatarAiAgeMiddleAged: "Middle-aged (50–65)",
    AvatarAiAgeSenior: "Senior (65+)",
    AvatarAiHairColorBlack: "Black",
    AvatarAiHairColorBrown: "Brown",
    AvatarAiHairColorBlonde: "Blonde",
    AvatarAiHairColorRed: "Red / Auburn",
    AvatarAiHairColorGray: "Gray",
    AvatarAiHairColorWhite: "White",
    AvatarAiHairColorOther: "Other / Dyed",
    AvatarAiHairStyleShort: "Short",
    AvatarAiHairStyleMedium: "Medium",
    AvatarAiHairStyleLong: "Long",
    AvatarAiHairStyleCurly: "Curly",
    AvatarAiHairStyleWavy: "Wavy",
    AvatarAiHairStyleStraight: "Straight",
    AvatarAiHairStylePonytail: "Ponytail",
    AvatarAiHairStyleBald: "Bald",
    AvatarAiEyeColorBrown: "Brown",
    AvatarAiEyeColorBlue: "Blue",
    AvatarAiEyeColorGreen: "Green",
    AvatarAiEyeColorHazel: "Hazel",
    AvatarAiEyeColorGray: "Gray",
    AvatarAiEyeColorAmber: "Amber",
    AvatarAiSkinFair: "Fair",
    AvatarAiSkinLight: "Light",
    AvatarAiSkinMedium: "Medium",
    AvatarAiSkinOlive: "Olive",
    AvatarAiSkinTan: "Tan",
    AvatarAiSkinDark: "Dark",
    AvatarAiSkinDeep: "Deep",
    AvatarAiFaceOval: "Oval",
    AvatarAiFaceRound: "Round",
    AvatarAiFaceSquare: "Square",
    AvatarAiFaceHeart: "Heart",
    AvatarAiFaceOblong: "Oblong",
    AvatarAiFaceDiamond: "Diamond",
    AvatarAiBodySlim: "Slim",
    AvatarAiBodyAthletic: "Athletic",
    AvatarAiBodyAverage: "Average",
    AvatarAiBodyCurvy: "Curvy",
    AvatarAiBodyHeavy: "Heavy",
    AvatarAiExpressionSmile: "Smile",
    AvatarAiExpressionNeutral: "Neutral",
    AvatarAiExpressionSerious: "Serious",
    AvatarAiExpressionFriendly: "Friendly",
    AvatarAiExpressionProfessional: "Professional",
    AvatarAiClothingBusinessSuit: "Business",
    AvatarAiClothingBusinessCasual: "Business casual",
    AvatarAiClothingSmartCasual: "Smart casual",
    AvatarAiClothingCasual: "Casual",
    AvatarAiClothingMedical: "Medical",
    AvatarAiClothingSafetyIndustrial: "Safety / industrial",
    AvatarAiClothingAcademic: "Academic",
    AvatarAiClothingFormal: "Formal",
    AvatarAiClothingTraditional: "Traditional",
    AvatarAiClothingAthletic: "Athletic",
    AvatarAiAccessoryGlasses: "Glasses",
    AvatarAiAccessoryWatch: "Watch",
    AvatarAiAccessoryEarrings: "Earrings",
    AvatarAiAccessoryTie: "Tie",
    AvatarAiAccessoryHeadscarf: "Headscarf",
    AvatarAiAccessoriesMeta: "optional · pick any",
    AvatarAiOptionalMeta: "optional",
    BuildYourAvatar: "Build your avatar",
    AvatarSuggestFaceShape: "face shape",
    AvatarSuggestMood: "mood",
    AvatarSuggestLighting: "lighting",
    AvatarAiBackgroundPlain: "Plain / neutral",
    AvatarAiBackgroundStudio: "Studio",
    AvatarAiBackgroundOffice: "Office",
    AvatarAiBackgroundOutdoor: "Outdoor",
    AvatarAiBackgroundClassroom: "Classroom",
    AvatarAiBackgroundGradient: "Soft gradient",
    AvatarAiEnvModernStudio: "Modern minimalist studio",
    AvatarAiEnvCorporateOffice: "Corporate office",
    AvatarAiEnvHomeOffice: "Home office",
    AvatarAiEnvClassroom: "Classroom",
    AvatarAiEnvLibrary: "Library",
    AvatarAiEnvWarehouse: "Warehouse",
    AvatarAiEnvLab: "Lab",
    AvatarAiEnvCafe: "Cafe",
    AvatarAiEnvOutdoorUrban: "Outdoor — urban",
    AvatarAiEnvOutdoorNature: "Outdoor — nature",
    AvatarAiAdditionalDetails: "Additional details",
    AvatarAiAdditionalDetailsPlaceholder:
      "Anything else worth describing (mood, lighting, props, vibe)\u2026",
    InvalidVideoFormat: "Please upload a valid video file (mp4, webm, mov, etc.)",
    AvatarNameRequired: "Please enter an avatar name.",
    PleaseUploadVideo: "Please upload a video first.",
    PleaseUploadPhoto: "Please upload a photo first.",
    AvatarCreatedSuccess: "Avatar created successfully.",
    AvatarCreationFailed: "Avatar creation failed.",
    AvatarCreationHint:
      "Face must be clearly visible with good lighting. Saved avatars are reusable across all projects.",
    PleaseSelectSceneAudio: "Please select scene audio.",
    VoiceProfileNotFound:
      "Voice profile not found. Please configure voice settings in training settings.",
    FailedToUploadVideo: "Failed to upload video",
    FailedToUploadVideoRetry: "Failed to upload video. Please try again.",
    FailedToFetchVoices: "Failed to fetch TTS voices",
    FailedToLoadVoicesRetry: "Failed to load voices. Please try again.",
    Use: "Use",
    Grid: "Grid",
    YouDontHaveAnyRecordedScenes: "You don't have any saved scenes.",
    WriteYourSceneName: "Write your scene name",
    YouCanSeeTheScenesYouHaveRecorded:
      "You can see the scenes you have recorded in 'Saved Scenes' in the lower left corner of the screen.",
    YouMustEnterASceneName: "You must enter a scene name",
    CheckTheSubscriptionInformation: "Check the subscription information",
    TypeTheTextYouWantToVoiceover: "Type the text you want to voiceover",
    Create: "Create",
    YouMustEnterAVoiceoverText: "You must enter a Voiceover Text!",
    DefineTheImageYouWantToCreate: "Define the image you want to create",
    YouMustEnterAPromptText: "You must enter a prompt text!",
    YouCanProceedUsingTheFollowingOptionsToCreateImagesWithAI:
      "You can proceed using the following options to create images with Artificial Intelligence.",
    TheImageYouCreatedHasBeenAddedToMyFiles: "The image you created has been added to 'My Files'",
    YouCanAccessTheImagesYouHavePreviouslyCreatedHereOrDeleteTheImagesYouDoNotUse:
      "You can access the images you have previously created here or delete the images you do not use.",
    ToMakeVoiceoveWithAIYouCanproceedUsingTheFollowingOptions:
      "To make a voiceover with AI, you can proceed using the following options",
    AiPromptText: "Prompt Text",
    AiService: "Service",
    AiLanguage: "Language",
    AiSound: "Sound",
    AiText: "Text",
    AiDimension: "Dimension",
    AiQuality: "Quality",
    AiStyle: "Style",
    ImprovePrompt: "Improve prompt with Artificial Intelligence",
    Lipsyncing: "Lipsyncing",
    BackgroundRemoval: "Background Removal",
    AdvancedSettings: "Advanced Settings",
    GeminiGuideTitle: "Gemini TTS Voice Director Guide",
    GeminiGuideColType: "Feature Type",
    GeminiGuideColCommand: "Command (Tag)",
    GeminiGuideColEffect: "What it does",
    GeminiGuideColExample: "Example Usage",
    GeminiGuideExampleText: "Example Text:",
    GeminiDirective: {
      Emotion: { type: "Emotion", effect: "Makes the voice energetic and cheerful." },
      Style: { type: "Style", effect: "Turns the voice into a mysterious whisper." },
      Time: { type: "Time", effect: "Adds a natural pause for the specified duration." },
      Speed: { type: "Speed", effect: "Speeds up the speech (for important alerts, etc.)." },
      Pitch: { type: "Pitch", effect: "Lowers the voice to make it sound more authoritative." },
      Scene: { type: "Scene", effect: "Provides a clean, echo-free studio environment." },
    },
    youtube: "Youtube",
    youtube_search_button: "Search",
    youtube_search_placeholder: "Search on Youtube...",
    add_to_scene: "Add to Scene",
    save: "Save",
    save_as: "Save As",
    import: "Import",
    export: "Export",
    export_to_lms: "Export to LMS",
    language: "Language",
    sign_out: "Sign out",
    preview: "Preview",
    ai_studio: "AI Studio",
    ai_studio_tooltip: "Open AI Studio",
    elements: "Elements",
    smart_elements: "Smart Elements",
    basic_elements: "Elements",
    click_menu: "Click Menu",
    sounds_panel: "Sounds",
    shapes_panel: "Shapes",
    logo_intro_panel: "Intro",
    ShapeSettings: {
      tab_fill: "Fill",
      tab_stroke_color: "Line colour",
      tab_stroke_style: "Line style",
      tab_radius: "Corner radius",
      tab_shadow: "Shadow",
      tab_text: "Text box",
      fill_none: "No fill",
      fill_solid: "Solid colour",
      fill_gradient: "Gradient",
      main_color: "Main colour",
      second_color: "Second colour",
      angle: "Angle",
      color: "Colour",
      width: "Width",
      dash: "Type",
      dash_solid: "Solid",
      dash_dashed: "Dashed",
      dash_dotted: "Dotted",
      start_cap: "Start cap",
      end_cap: "End cap",
      cap_none: "None",
      cap_arrow: "Arrow",
      cap_circle: "Circle",
      line_cap: "Line ends",
      line_cap_butt: "Flat",
      line_cap_round: "Round",
      radius: "Radius",
      radius_full: "Full",
      shadow_soft: "Soft",
      shadow_medium: "Medium",
      shadow_strong: "Strong",
      blur: "Blur",
      text_placeholder: "Type text inside the shape…",
      font: "Font",
      font_default: "Default",
      size: "Size",
      bold: "Bold",
      italic: "Italic",
      padding: "Padding",
      shadow_none: "None",
      align: "Alignment",
      align_left: "Left",
      align_center: "Centre",
      align_right: "Right",
      valign: "Vertical alignment",
      valign_top: "Top",
      valign_middle: "Middle",
      valign_bottom: "Bottom",
    },
    ShapesPanel: {
      count: "{{count}} shapes",
      empty: "No shapes match your search",
      back: "Back",
    },
    sounds_all: "All",
    sounds_sfx: "Sound Effects",
    sounds_music: "Music",
    sounds_jingles: "Jingles",
    sounds_back: "Back",
    sounds_dur_short: "Short",
    sounds_dur_medium: "Medium",
    sounds_dur_long: "Long",
    sound_add_cue: "Add as click sound",
    sound_add_scene: "Add as scene sound",
    sounds_my_effects: "My Effects",
    sound_fx_new: "Create Effect",
    sound_fx_prompt_ph:
      "Effect description (e.g. heavy wooden door slamming in an empty stone hall)",
    sound_fx_enrich: "Enrich with AI",
    sound_fx_system_ph: "System prompt (empty = default sound-design guidance)",
    sound_fx_duration: "Duration (s)",
    sound_fx_influence: "Prompt influence",
    sound_fx_low: "Low",
    sound_fx_mid: "Medium",
    sound_fx_high: "High",
    sound_fx_count: "Count",
    sound_fx_loop: "Loop",
    sound_fx_generate: "Generate Effect",
    sound_fx_generating: "Generating…",
    sound_fx_error: "Effect generation failed",
    sound_fx_empty: "No effects yet",
    sound_fx_empty_hint: "Create your first effect above",
    auto: "auto",
    other: "Other",
    SmartElements_Groups_Text: "Text",
    SmartElements_Groups_Lists: "Lists",
    SmartElements_Groups_Layout: "Layout",
    SmartElements_Groups_DataMedia: "Data & Media",
    SmartElements_Groups_UI: "UI",
    SmartElements_Types_heading: "Heading",
    SmartElements_Types_eyebrow: "Eyebrow",
    SmartElements_Types_footer: "Footer",
    SmartElements_Types_quote: "Quote",
    SmartElements_Types_bullet_list: "Bullet List",
    SmartElements_Types_card_grid: "Card Grid",
    SmartElements_Types_timeline: "Timeline",
    SmartElements_Types_stat_group: "Stats",
    SmartElements_Types_hero: "Hero",
    SmartElements_Types_section: "Section",
    SmartElements_Types_two_column: "Two Column",
    SmartElements_Types_comparison: "Comparison",
    SmartElements_Types_chart: "Chart",
    SmartElements_Types_image: "Image",
    SmartElements_Types_divider: "Divider",
    SmartElements_Types_badge: "Badge",
    SmartElements_Types_cta_button: "CTA Button",
    SmartElements_Types_icon_block: "Icon Block",
    SmartElements_Types_flip: "Flip Card",
    SmartElements_Types_dragBuild: "Drag & Build",
    SmartElements_Types_reveal: "Reveal Panel",
    SE_sample_heading: "Heading",
    SE_sample_eyebrow: "Eyebrow Label",
    SE_sample_footer: "Footer note",
    SE_sample_bullet_title: "Key Points",
    SE_sample_bullet_point: "Point {{n}}",
    SE_sample_card_title: "Feature Cards",
    SE_sample_card_item_title: "Card {{n}}",
    SE_sample_card_item_body: "Description {{n}}",
    SE_sample_timeline_title: "Timeline",
    SE_sample_timeline_step: "Step {{n}}",
    SE_sample_timeline_step_body: "Description",
    SE_sample_stat_label: "Metric {{n}}",
    SE_sample_quote_text: "Your quote here.",
    SE_sample_quote_author: "Author Name",
    SE_sample_hero_heading: "Hero Title",
    SE_sample_hero_body: "Supporting subtitle text",
    SE_sample_2col_left_title: "Left Column",
    SE_sample_2col_right_title: "Right Column",
    SE_sample_2col_body: "Content here",
    SE_sample_comp_option: "Option {{letter}}",
    SE_sample_comp_feature: "Feature {{n}}",
    SE_sample_section_heading: "Section Title",
    SE_sample_section_body: "Section content",
    SE_sample_badge: "Badge",
    SE_sample_cta: "Get Started",
    SE_sample_icon_title: "Feature",
    SE_sample_icon_body: "Description",
    SE_sample_flip_front_title: "Question",
    SE_sample_flip_front: "Click the card to see the answer.",
    SE_sample_flip_back_title: "Answer",
    SE_sample_flip_back: "Write the explanation here.",
    SE_sample_drag_prompt: "Match each item to its group.",
    SE_sample_drag_token: "Item {{n}}",
    SE_sample_drag_zone: "Group {{n}}",
    SE_sample_reveal_title: "Dosage interaction",
    SE_sample_reveal_text: "Combining these two drugs raises the risk of...",
    PluginNames_BasicText: "Rich Text",
    PluginNames_RichText: "Rich Text",
    PluginNames_DataTable: "Table",
    PluginNames_GraficaD3: "Graphic",
    PluginNames_EnrichedPlayer: "Video Player",
    PluginNames_HotspotImages: "Image",
    PluginNames_AudioCue: "Audio Cue",
    PluginNames_HtmlContent: "HTML Content",
    PluginNames_EnrichedAudio: "Audio Player",
    PluginNames_EnrichedPDF: "PDF Viewer",
    PluginNames_OneClick: "Click",
    PluginNames_Characters: "Characters",
    PluginNames_ScormPackage: "SCORM Package",
    PluginNames_Shapes: "Shapes",
    PluginNames_ShapeOverlay: "Shape Overlay",
    PluginNames_VectorShape: "Shape",
    PluginNames_VirtualTour: "Google Map",
    PluginNames_Visor3D: "Visor 3D",
    PluginNames_Webpage: "Web Content",
    PluginNames_MultipleChoice: "Multiple Choice",
    PluginNames_MultipleAnswer: "Multiple Answer",
    PluginNames_TrueFalse: "True/False",
    PluginNames_FillInBlank: "Fill In Blank",
    PluginNames_FreeResponse: "Free Response",
    PluginNames_Matching: "Matching",
    PluginNames_Ordering: "Rating",
    PluginNames_Rating: "Rating",
    PluginNames_DragDrop: "Drag Drop",
    PluginNames_InputText: "User Input",
    PluginNames_AtomicBoxPlugin: "AI Content Element",
    PluginNames_GuideMultiInput: "Screen Training Multi-Input",
    PluginNames_GuideTagDisplay: "Screen Training Tag Display",
    ai: "AI",
    ai_images: "Image",
    ai_sounds: "Sound",
    ai_avatars: "Avatar",
    text: "Text",
    data: "Data",
    basic: "Basic",
    multimedia: "Multimedia",
    objects: "Objects",
    assessments: "Assessments",
    components: "Components",
    library: "Library",
    upload_files: "Upload Files",
    my_files: "My Files",
    org_files: "Org Files",
    brand_files: "Brand",
    BrandPanel: {
      font_pick: "Pick a Google font…",
      font_adding: "Adding…",
      kind_logo: "Logos",
      kind_photo: "Photos",
      kind_graphic: "Graphics",
      kind_icon: "Icons",
      kind_chart: "Charts",
      kind_font: "Fonts",
      uploading: "Uploading",
      no_results: "No results",
      empty_kind: "None yet",
      primary: "Primary",
      make_primary: "Set as main logo",
      back: "Back",
      no_brands: "No brands yet",
      no_brands_hint: "Brands are created on the Brand Templates page of the console.",
      font_not_placeable: "Fonts cannot be added to the scene yet",
      apply_position_all: "Update position on all scenes",
      rightclick_hint:
        "Click to add to this scene. Right-click it on the canvas → “Update position on all scenes” to use the same spot everywhere.",
      new_category: "New category",
      category_name_placeholder: "Category name",
      rename: "Rename",
      delete_category: "Delete category",
      delete_category_confirm: "and its {{count}} files will be deleted.",
      colors: "Colors",
      colors_unit: "colors",
      colors_hint:
        "Click a color: it goes to the selected text or shape — with nothing selected, to the scene background.",
      colors_empty: "No brand colors yet",
      color_applied_text: "Applied to the text",
      color_applied_shape: "Applied to the shape",
      color_applied_background: "Applied to the scene background",
      color_unsupported: "This element can't take a color",
      color_pick: "Pick a color",
      color_hex: "Hex code",
      color_primary: "Primary Color",
      color_secondary: "Secondary Color",
      color_accent: "Accent Color",
      color_apply: "Apply",
      color_invalid: "Enter a hex color like #40cfde",
      delete_color_set: "Delete color set",
      color_set_new: "New color set",
      color_set_name: "Color set name",
      color_set_default: "Color set {{n}}",
      color_sets_unit: "color sets",
      color_clear: "Remove color",
      color_empty: "Empty",
    },
    BoxContextMenu: {
      apply_font_all_scenes: "Apply this font to all scenes",
    },
    OrgFiles: "Org Files",
    ClonedVoices: "Clone Voice",
    CourseVideo: "Course Videos",
    Transcription: "Transcription",
    AnimatedImage: "Animated Image",
    TimelineAnimatedImage: "Video Image",
    icons: "Icons",
    animations: "Animations",
    characters: "Characters",
    search: "Search",
    all: "All",
    image: "Image",
    audio: "Audio",
    video: "Video",
    csv: "CSV",
    pdf: "PDF",
    delete: "Delete",
    files: "files",
    loading: "Loading...",
    no_files_found: "No Files Found",
    load_more: "Load More",
    no_trainings_found: "No trainings found",
    unassigned_files: "Unassigned Files",
    show_list_view: "List View",
    show_grouped_view: "Grouped View",
    files_load_error: "Failed to load files",
    listen: "Listen",
    download: "Download",
    file: "File",
    cancel: "Cancel",
    close: "Close",
    more_filters: "More filters",
    collapse: "Collapse",
    try_other_search: "Try a different search.",
    searching: "Searching…",
    youtube_search: "Search on YouTube",
    youtube_search_hint: "Type and press Enter.",
    library_ai: "AI",
    library_details: "Details",
    library_video_drafts: "Video drafts",
    library_video_drafts_empty: "No video drafts yet",
    library_type: "Type",
    library_date: "Date",
    library_duration: "Duration",
    library_provider: "Model",
    library_prompt: "Prompt",
    library_copy_prompt: "Copy prompt",
    library_director: "Video Director",
    library_logline: "Logline",
    library_shot: "Shot",
    library_more: "More",
    library_less: "Less",
    library_open_in_director: "Open in Director",
    library_project_unavailable: "Project not available",
    delete_file_title: "Delete file",
    delete_file_confirm_prefix: "Are you sure you want to delete ",
    delete_file_confirm_suffix: "? This action cannot be undone.",
    animation_fade: "Fade",
    animation_flip: "Flip",
    animation_pinwheel: "Pinwheel",
    animation_roll: "Roll",
    animation_rotate: "Rotate",
    animation_stretch: "Stretch",
    animation_zoom: "Zoom",
    animation_pan: "Pan",
    lipsync_title: "Lipsyncing",
    lipsync_select_narration: "Select Narration Sound",
    lipsync_choose_audio: "Choose an audio track from the scene to sync with your video",
    lipsync_select_audio_video_error: "Please select an audio and ensure video is available",
    lipsync_success_message:
      "Lipsyncing completed successfully! The video has been updated with the new lipsynced version.",
    lipsync_background_removal: "Background Removal",
    lipsync_generating: "Generating...",
    lipsync_generate: "Generate",
    error: "Error",

    AudioPanel: {
      Audio: "Knowledge Base",
      SceneSounds: "Scene Sounds",
      DocumentSummary: "Summary",
      DocumentTitles: "Document Titles",
      Outline: "Document Outline",
      Mindmap: "Mindmap",
      NarrationTexts: "Narration Texts",
      Loading: "Loading...",
      NoSummaryAvailable: "No summary available",
      NoOutlineAvailable: "No course outline available",
      NoNarrationTexts: "No narration text saved for this training.",
      ErrorLoadingData: "Error loading data",
      ErrorPrefix: "Error",
      AllocatedScenes: "scenes",
      CourseInfo: "Document Information",
      Sections: "Sections",
      CopyAll: "Copy All",
      SlideNotes: "Slide notes",
      Copied: "Copied!",
    },

    Animation: {
      Animation: "Effect",
      FirstPositionX: "First Position X",
      FirstPositionY: "First Position Y",
      LastPositionX: "Last Position X",
      LastPositionY: "Last Position Y",
      Firstwidth: "First Width",
      FirstHeight: "First Height",
      Lastwidth: "Last Width",
      LastHeight: "Last Height",
      FirstOpacity: "First Opacity",
      LastOpacity: "Last Opacity",
      FirstDuration: "First Duration(sec)",
      LastDuration: "Last Duration(sec)",
      add_animation: "Add Animation",
      add_animation_shortcuts: "Add Animation",
      position_add: "Add Position",
      edit_animation: "Edit Animation",
      First_Position: "First Position",
      Last_Position: "Last Position",
      PositionX: "Position X",
      PositionY: "Position Y",
      Opacity: "Opacity",
      Width: "Width",
      Height: "Height",
      Duration: "Duration(second)",
      animation_reset: "Animation Reset",
      PositionNumber: "Position Number",
      MiddlePositionX: "Middle Position X",
      MiddlePositionY: "Middle Position Y",
      Middlewidth: "Middle Width",
      MiddleHeight: "Middle Height",
      MiddleOpacity: "Middle Opacity",
      MiddleDuration: "Middle Duration(sec)",
      Middle_Position: "Middle Position",
      ShowAnimation: "Animation Properties",
    },
    "16/9": "Switch to 16:9",
    "4/3": "Switch to 4:3",
    Accept: "Accept",
    Animations: "Animations",
    Alignment: "Alignment",
    Advanced: "Advanced",
    Aspect_ratio: "Aspect ratio",
    Auto: "Automatic",
    AddStartAnimation: "Add Start Animation",
    AddEndAnimation: "Add End Animation",
    EditAnimation: "Edit Animation",
    AddMiddleAnimation: "Add Middle Animation",

    background: {
      background: "Background",
      background_color: "Change color",
      background_image: "Background image",
      background_zoom: "Background zoom ",
      reset_background: "Restore background",
      background_input_url: "URL Image",
      cover: "Cover page",
      repeat: "Repeat image",
      centered: "Centered image",
      fit: "Fit image",
      background_opacity: "Background Opacity ",
    },
    Block: "Block",
    Question: "Question",
    Answer: "Answer",
    Feedback: "Feedback",
    TrueFeedback: "True Feedback",
    FalseFeedback: "False Feedback",
    Element: "Element",
    Option: "Option",
    Breadcrumb: "Breadcrumb",
    Cancel: "Cancel",
    save_as_modal: "Save As",
    save_as_modal_aspect_ratio: "Aspect ratio",
    save_as_modal_ratio_change_warning:
      "Same content will be saved at {{ratio}} aspect ratio. When the aspect ratio changes, scene elements may not fit perfectly.",
    TrainingName: "Training Name",
    TrainingDescription: "Description",
    SoundLoading: "Sound Loading...",
    SoundLoaded: "Sound Loaded",
    AudioName: "Audio Name: ",
    EnterAudioName: "Enter audio name",
    upload_sound_record: "Save Audio",
    Upload: "Upload",
    Cancel: "Cancel",
    clipboard: {
      copy: "Copy",
      cut: "Cut",
      copyPaste: "Copy & Paste",
      paste: "Paste",
      duplicate: "Duplicate",
      to: "to",
      msg: "These actions are not available. Use the keyboard shortcuts:",
      zoomIn: "Zoom In",
      zoomOut: "Zoom Out",
      zoomReset: "Reset to 100%",
    },
    configuration: "Configuration",
    confirm_changes: "Confirm changes",
    Container_: "Container",
    contained_view: "Contained View",
    oneclick_view: "OneClick View",
    CONTAINED_VIEWS: "CONTAINED VIEWS",
    contained_view_popover: "This view links from:",
    contained_view_nowhere: "Nowhere",
    col_dist: "Column distribution",
    col_number: "Number of columns",
    content: "Content",
    COURSE: "DOCUMENT",
    course: "Document",
    course_title: "Lesson Title",
    "create new document": "Create new page",
    "create new folder": "Create new section",
    "create new slide": "Create new slide",
    delete_contained_canvas: "Delete contained view.",
    delete_container: "Delete block",
    delete_page: "Delete Page",
    delete_section: "Delete Section",
    delete: "Delete",
    display: "Display",
    display_page: "Hide/Show Slide",
    dropbox_msg: "Click here in order to browse your dropbox files",
    dropbox_msg_alt: "Choose another file",
    document: "Document",
    DuplicateNavItem: "Duplicate view",
    edit_text: "Edit text",
    fitToScreen: "Fit to Screen",
    exitModal: {
      Body: "Do you really want to exit from Aideapro Studio?",
      cancel: "Cancel",
      leave_without_changes: "Leave without changes",
      save_and_exit: "Save and Exit",
      Title: "Exit from Aideapro Studio",
    },
    unsavedChangesGuard: {
      title: "Unsaved changes",
      body: "You have unsaved changes. What would you like to do before you leave?",
      stay: "Stay",
      leaveWithoutSaving: "Leave without saving",
      saveAndLeave: "Save and leave",
      saving: "Saving…",
      saveError: "Couldn't save your changes. Please try again.",
    },
    staleTraining: {
      message:
        "This training was saved in another tab or by another person. Reload before saving so you don't overwrite their changes.",
      reload: "Reload",
    },
    saveConflict: {
      title: "This training changed elsewhere",
      body: "Someone or something else saved a newer version of this training since this tab loaded it. Choose whether to keep working with your version or load the other one.",
      currentUpdatedAt: "Other version saved at: {{when}}",
      cancel: "Cancel",
      reload: "Discard my changes and reload",
      reloading: "Reloading…",
      overwrite: "Overwrite with my version",
      overwriting: "Saving…",
    },
    empty: {
      cv_empty: "You have not created any contained view yet.",
    },
    EmptyPresentation: "This document is empty",
    error: {
      exporting: "There was an error when performing the operation",
      generic: "There was an error",
      importing: "There was an error when performing the operation",
      reaching_server: "Can't reach server",
      searching: "There was an error while searching",
      deleting: "There was an error while deleting",
      mandatory: "Please complete the current stage to advance to the next stage!",
      mandatorytwo: "To pass this scene, you need to complete the previous scenes!",
      mandatoryCompleted:
        "When mandatory is closed, the default watched time is {{seconds}} seconds. Scenes passed before this time elapses may not be marked as watched.",
      warning: "Caution",
      networkError: "Network error. Please try again.",
      organizationIdNotFound: "Organization ID not found in token. Please login again.",
      failedToCloneVoice: "Failed to clone voice.",
      failedToDeleteVoice: "Failed to delete voice.",
      failedToGenerateAudio: "Failed to generate audio.",
      serviceError: "Service Error",
      systemError: "System Error",
      file_not_selected: "No file selected",
    },
    Evaluation: "Evaluation",
    Exercises: "Exercises",
    TimeLine: "TimeLine",
    Library: "Library",
    Exporting: "Saving...",
    FileDialog: "File",
    FileInput: {
      Message: "Drag or select a file",
      MessageMulti: "Drag & drop files here",
      ClickHint: "or click to browse — you can select multiple files",
      Drag: "Drag",
      Drag_2: " a file or ",
      Click: "click",
      Click_2: " to browse",
    },
    FileModal: {
      APIProviders: {
        MyFiles: "My files",
        Animations: "Animations",
        Shapes: "Shapes",
        Characters: "Characters",
        AIAvatarsText: "AI Avatars",
        MyFilesTitle: "Files uploaded to this document",
        UploadFiles: "Upload Files",
        UploadFilesTitle: "Import file from your PC...",
        UploadNewFile: "Upload new file",
        no_files: "No files found with the specified search criteria",
        results: "Results",
        searching: "Searching...",
        error: "We couldn't upload your file",
        errorHint:
          "Please try again. If it keeps happening, click the info icon to send the details to the Aidea team.",
        errorDetailsTitle: "Show technical details",
        errorReportTitle: "Technical details",
        errorReportIntro:
          "Sorry for the trouble. Please copy the text below and send it to the Aidea team so we can help.",
        copyReport: "Copy details",
        copied: "Copied!",
        warning_allowed: "This file is not compatible with the content you are editing",
        warning_forbidden: "This file is not allowed in this version of Aideapro Studio",
        warning_too_large: "File cannot be larger than {{max}}MB",
        uploaded: "File uploaded to library successfully",
        addToScene: "Add to Scene",
        addAllToScene: "Add All to Scene",
        addingToScene: "Adding to scene…",
        upload: "Upload file",
        clear: "Clear",
        search: "Search",
        confirm_delete: "Are you sure you want to delete this file?",
        confirm_delete_all: "Are you sure you want to delete all file?",
        delete_all: "Delete All",
        library: "Library",
        AIAvatars: {
          Description:
            "Create AI-powered avatar videos with text-to-speech and lip-sync technology",
          SelectAvatar: "Select Avatar",
          SelectAvatarForEditing: "Select Avatar for Editing",
          SelectedAvatar: "Selected Avatar",
          PreviewVideo: "Preview",
          EditExisting: "Edit Existing Avatar Videos",
          EditDescription:
            "In edit mode, you can modify previously generated avatar videos. Select a video below to edit its parameters and regenerate.",
          NoExistingVideos: "No existing videos to edit",
          CreateSomeVideosFirst: "Create some avatar videos first",
          ScriptText: "Script Text",
          ScriptPlaceholder: "Enter the text you want your avatar to speak...",
          ScriptHint: "Maximum 4096 characters. Use <break time='500ms'/> for pauses.",
          VoiceService: "Voice Service",
          Language: "Language",
          Voice: "Voice",
          Create: "Create",
          CreateMode: "Create Mode",
          EditMode: "Edit Mode",
          Processing: "Processing...",
          Regenerate: "Regenerate",
          PleaseWait: "Please wait...",
          JobStatus: "Processing avatar video...",
          VideoGenerated: "Generated avatar video has been added to your files.",
          AccessPrevious: "You can access previously generated avatars from 'My Files' section.",
          ErrorNoText: "You must enter text for the avatar",
          ErrorTextTooShort: "Tavus requires at least 45 characters of text.",
          ErrorNoAvatar: "You must select an avatar",
          LoadingAvatars: "Loading avatars...",
          NoAvatarsAvailable: "No avatars available",
          FailedToLoadAvatars: "Failed to load avatars",
          ErrorLoadingAvatars: "Error loading avatars",
          ProviderType: "Provider Type",
          Gender: "Gender",
          AllGenders: "All Genders",
          Male: "Male",
          Female: "Female",
          ProviderTypes: {
            AI: "AI",
            Human: "Human",
          },
          Avatars: "avatars",
          NoAvatarsMatch: "No avatars match the selected filters",
          NoVoicesAvailable: "No voices available",
          EnableTransparentBackground: "Enable transparent background",
          VideoNotSupported: "Your browser does not support video playback.",
          NoPreviewVideo: "No preview video",
          PlayVoiceSample: "Play voice sample",
          Step1SelectAvatar: "Select Avatar",
          Step2Settings: "Avatar Settings",
          Next: "Next",
          Back: "Back",
          // Aidea specific
          SourceType: "Source Type",
          SelectSourceType: "Select Source Type",
          StockAvatar: "Stock Avatar",
          UploadVideo: "Clone from Video",
          ImageToVideo: "Clone from Image",
          ImageProvider: "Image Provider",
          SelectProvider: "Select Provider",
          ClickToUploadVideo: "Click to upload video",
          ChangeVideo: "Change Video",
          SupportedFormats: "Supported: MP4, MOV, AVI",
          UploadingVideo: "Uploading video...",
          ClickToUploadImage: "Click to upload image",
          ChangeImage: "Change Image",
          SupportedImageFormats: "Supported: JPG, PNG",
          UploadingImage: "Uploading image...",
          AudioSource: "Audio Source",
          SelectAudioSource: "Select Audio Source",
          UploadAudio: "Upload Audio",
          TextToSpeech: "Text to Speech",
          ClickToUploadAudio: "Click to upload audio file",
          ChangeAudio: "Change",
          UploadingAudio: "Uploading audio...",
          SelectedSource: "Selected Source",
          UploadedVideo: "Uploaded Video",
          ErrorNoSourceType: "Please select a source type",
          ErrorNoVideo: "Please upload a video",
          ErrorNoProvider: "Please select a provider",
          ErrorNoImage: "Please upload an image",
          ErrorNoAudioSource: "Please select audio source",
          ErrorNoAudio: "Please upload audio",
          // TTS specific
          TTSProvider: "TTS Provider",
          SelectTTSProvider: "Select TTS Provider",
          LoadingVoices: "Loading voices...",
          VoiceGender: "Voice Gender",
          VoiceLanguage: "Voice Language",
          AllLanguages: "All Languages",
          SelectVoice: "Select Voice",
          TransparentBackground: "Transparent Background",
          ErrorNoTTSProvider: "Please select TTS provider",
          ErrorNoVoice: "Please select a voice",
          // Scene audio and preview
          SelectedAudio: "Selected Audio:",
          SceneAudio: "Scene Audio",
          Preview: "Preview:",
          NoAudioFoundInScene: "No audio found in this scene.",
          CreateFromText: "Create from Text",
          CreateFromSceneAudio: "Create from Scene Audio",
          AvatarVideoCreated: "Avatar Video Created",
          AddToScene: "Add to Scene",
          Provider: "Provider",
          // Custom Avatar
          SourceVideo: "Source Video",
          Uploading: "Uploading...",
          VideoFormats: "MP4, MOV · 10s–60s",
          RecordVideo: "Record Video",
          UseYourWebcam: "Use your webcam",
          SaveAndUseAvatar: "Create & Use Avatar",
          AvatarCreationHint:
            "Face must be clearly visible with good lighting. Saved avatars are reusable across all projects.",
          // Error messages
          PleaseSelectSceneAudio: "Please select scene audio.",
          VoiceProfileNotFound:
            "Voice profile not found. Please configure voice settings in training settings.",
          FailedToUploadVideo: "Failed to upload video",
          FailedToUploadVideoRetry: "Failed to upload video. Please try again.",
          FailedToFetchVoices: "Failed to fetch TTS voices",
          FailedToLoadVoicesRetry: "Failed to load voices. Please try again.",
          // Image to Video Guidelines
          ImageGuidelinesTitle: "Example Guidelines",
          ExamplePhoto: "Example Photo",
          GuidelinesTitle: "Photo Requirements",
          Guideline1: "Face is front-facing and clear",
          Guideline2: "Plain background without distractions",
          Guideline3: "Well-lit with good lighting",
          Guideline4: "Close-up facial shot",
          Guideline5: "Eyes open and looking at camera",
          Guideline6: "Natural expression and pose",
          Guideline7: "High-resolution photo",
        },
        ImageStyles: {
          Title: "AI Image Style Library",
          Description: "Create stunning images with pre-designed styles or your own custom prompts",
          StyleTemplates: "Style Templates",
          CustomizePrompt: "Customize Your Prompt",
          PromptPlaceholder: "Select a style above or enter your custom prompt...",
          PromptHint: "Describe the image you want to create in detail for best results.",
          AIProvider: "AI Provider",
          AutoProvider: "Auto",
          CustomProvider: "Custom",
          Orientation: "Orientation",
          Quality: "Quality",
          Square: "Square",
          Landscape: "Landscape",
          Portrait: "Portrait",
          HDQuality: "HD Quality",
          Standard: "Standard",
          GenerateImage: "Generate Image",
          Generating: "Generating...",
          GeneratedImage: "Generated Image",
          AddToCanvas: "Add to Canvas",
          Regenerate: "Regenerate",
          LoadingStyles: "Loading style library...",
          NoStylesAvailable: "No styles available",
          FailedToLoadStyles: "Failed to load style library",
          ErrorLoadingStyles: "Error loading styles",
          PleaseEnterPrompt: "Please enter a prompt.",
          PromptRequired: "Please enter a prompt.",
          PromptRequiredTitle: "Prompt Required",
          StyleRequiredTitle: "Style Required",
          PleaseSelectStyle: "Please select a style or add a reference image.",
          CustomStyleRequiredTitle: "Style Description Required",
          CustomStyleDescRequired: "Please enter a description for the custom style.",
          NarrationRequiredTitle: "Narration Required",
          NarrationTextRequired: "Please enter narration text",
          PromptEnrichEmpty: "Please enter a prompt to enrich",
          PromptEnrichFailed: "Failed to enrich prompt",
          FailedToGenerate: "Failed to generate image",
          ContentPolicyViolation:
            "Content policy violation: The AI provider blocked this request. The prompt may contain restricted content. Please modify your prompt and try again.",
          ImageAdded: "Image has been added to your canvas",
          StyleTemplate: "Style Template",
          NoDescription: "No description",
          MoreStyles: "More styles",
          ShowLess: "Show fewer",
          GeneratingImage: "Generating image...",
          AIGeneratedImage: "AI Generated Image",
          StyleLabel: "Style",
          StyleTemplateFallback: "Style {{index}}",
          CustomCardLabel: "Custom",
          CustomStyleDescription: "Custom Style Description",
          CustomStylePlaceholder:
            "Describe the visual style you want, e.g. watercolor illustration, dark cinematic, flat vector art...",
          StyleSelectionDisabled: "Style selection is disabled when a reference image is used.",
          LessStyles: "Less Styles",
          TextOverlayHeader: "Text {{index}}",
          TextOverlayPlaceholder: "Enter the text to display...",
          TextOverlayLocationLabel: "Location",
          TextOverlayLocationCustomOption: "Custom...",
          TextOverlayLocationCustomPlaceholder: "e.g. lower third center",
          TextOverlayStyleLabel: "Style",
          TextOverlayCustomStylePlaceholder: "e.g. bold red outlined",
          AddTextOverlay: "+ Add Text",
          ReferenceImageLabel: "Reference Image",
          RemoveImage: "Remove",
          ReferenceImageNote:
            "AI will use this image as a style reference · {{aspectRatio}} · {{provider}}",
          PromptBadgePrefix: "Uses",
          DescribeImage: "Describe the image you want to generate for this scene...",
          UsesBadge: "Uses",
          AdvancedSettings: "Advanced Settings",
          NegativePrompt: "Negative Prompt",
          NegativePromptPlaceholder: "What to exclude...",
          Resolution: "Resolution",
          NarrationTextRequired: "Narration text is required.",
          PromptGenerationFailed: "Failed to generate prompt from narration",
          AnimateAndAdd: "Aidea Wizard",
          ImagesGenerating: "images generating",
        },
        VideoGeneration: {
          AddedFromTray: "Added to the scene",
          AddAgain: "Add again",
          Director: {
            Tab: "Video Director",
            Loading: "Loading…",
            Start: "Start a new video",
            Prefilling: "Reading your scene…",
            Treating: "Writing the treatment and generating character and location sheets…",
            Rendering: "Rendering the final video…",
            RenderingTitle: "Rendering your video…",
            RenderNote: "You can close this window — rendering continues. Find it later in Drafts.",
            ClipsReady: "{{ready}} of {{total}} clips ready",
            EstimateMin: "about {{min}} min",
            GenerateNote:
              "You can close this window — generation continues. Find it later in Drafts.",
            ClipsGenerating: "{{count}} clip generating…",
            ClipsGenerating_plural: "{{count}} clips generating…",
            ChipReady: "Ready",
            NextNeedsApproval: "Approve every keyframe to continue",
            StepCount: "Step {{n}} of 5",
            Steps: {
              Brief: "Brief",
              Treatment: "Treatment",
              Storyboard: "Storyboard",
              Edit: "Generate & edit",
              Finish: "Finish",
            },
            Fields: {
              scenario: "Scenario",
              voiceOver: "Voice-over (optional)",
              learningGoal: "Learning goal",
              audience: "Audience",
              narration: "Narration",
              language: "Language",
              targetSec: "Target length (seconds)",
              customStyle: "Custom style",
              cast: "Cast",
              locations: "Locations",
              criticalActions: "Critical actions",
              brandPolicy: "Brand policy",
              logline: "Logline",
              look: "Look",
              name: "Name",
              description: "Description",
              durationSec: "Duration (seconds)",
              camera: "Camera",
              prompt: "Motion prompt",
              keyframePrompt: "Keyframe prompt",
            },
            StartFrom: "Start from",
            StartScene: "This scene",
            StartPrompt: "My own idea",
            Characters: "Characters",
            CastAi: "AI creates them",
            CastPhotos: "From my photos",
            CastNone: "No characters",
            ScenarioPlaceholder: "Describe your whole video — story, scenes, what happens…",
            WordsCount: "{{words}} words",
            LikenessConsent: "I have permission to use the likeness of the people in these photos.",
            PhotoName: "Name",
            PhotoRole: "Role in the video",
            PhotoRemove: "Remove photo",
            AddPhoto: "Add photo",
            PhotosRequired: "Add at least one photo and name each person.",
            FromPhoto: "From photo",
            Words: "{{words}} / 300 words",
            Required: "Required",
            NarrationTooLong: "Narration is over 300 words — shorten it to continue.",
            Next: "Next",
            Confirm: "Confirm and draw keyframes",
            Summary: "{{count}} shot · {{seconds}} s",
            Summary_plural: "{{count}} shots · {{seconds}} s",
            TargetRange: "10–120 s",
            Shot: "Shot {{n}}",
            RemoveShot: "Remove shot",
            Approve: "Approve",
            Approved: "Approved",
            ApproveAll: "Approve all",
            Regenerate: "Regenerate",
            Take: "Take {{n}}",
            InsertShotHere: "Insert shot here",
            Generated: "Generated",
            Play: "Play",
            Pause: "Pause",
            Fit: "Fit timeline to view",
            WhatNext: "What happens next? (optional)",
            WhatNextRequired: "What happens next?",
            Generate: "Generate",
            MarkIn: "Mark range start",
            RemoveRange: "Remove selection",
            CutAfter: "Cut after playhead",
            RangeHint: "Range: {{from}} → {{to}}",
            SplitHere: "Split here",
            Zoom_none: "Zoom: None",
            Zoom_in: "Zoom: Slow zoom in",
            Zoom_out: "Zoom: Slow zoom out",
            TransitionChip: "Transition",
            Transition_none: "Transition: None",
            Transition_crossfade: "Transition: Crossfade",
            Transition_fade: "Transition: Fade to black",
            TransitionFallback: "Not enough extra footage for a crossfade — fade will be used",
            TransitionSkipped: "Clip too short for a transition — it will be skipped",
            CutStart: "Cut start to playhead",
            DeleteClip: "Delete clip",
            Close: "Close",
            EditShot: "Edit shot",
            PlaySound: "Play with sound",
            ClipSound: "Clip sound",
            Mute: "Mute",
            NoClipSound: "These clips have no sound",
            NoNarration: "No narration audio on this scene",
            ShotActions: "Shot actions",
            Inspector: "Shot panel",
            BackToEdit: "Back to edit",
            ReplaceVideo: "Replace video",
            OpenLibrary: "Open in library",
            RenderAgain: "Render again",
            RenderStale: "The cut may have changed since this render — render again",
            Clips: "{{count}} clip",
            Clips_plural: "{{count}} clips",
            FinishExplain:
              "Render joins {{count}} clips into one MP4 ({{duration}}, {{aspect}}, 720p, without sound). The scene narration stays separate and plays with it. Rendering is free and takes about a minute.",
            FinishWarnEmpty: "Nothing to render: the cut has no clips.",
            FinishWarnPending: "{{count}} take is still generating and is not in the cut.",
            FinishWarnPending_plural:
              "{{count}} takes are still generating and are not in the cut.",
            FinishWarnFailed: "{{count}} failed take is not in the cut.",
            FinishWarnFailed_plural: "{{count}} failed takes are not in the cut.",
            CutPreview: "Preview of the full cut",
            StartFrame: "Start frame",
            EndFrame: "End frame",
            EndAuto: "AI decides",
            EndNext: "Next clip's first frame",
            EndPick: "Pick a frame",
            PickTake: "Take",
            PickFrame: "Frame",
            EndMarker: "→ end frame",
            Retry: "Retry",
            Render: "Render",
            AddToScene: "Add to scene",
            VideoName: "Director video",
            Drafts: "Drafts",
            DraftsEmpty:
              "No drafts yet. Start a new video or edit an existing one in the Director.",
            Untitled: "Untitled",
            Imported: "Imported",
            PolicyAdjusted: "Adjusted for safety",
            PolicyOriginal: "Your prompt",
            PolicySent: "Sent prompt",
            UseSaferPrompt: "Use safer prompt",
            OriginDirector: "Director",
            Rendered: "Rendered",
            DraftStatus: {
              prefilling: "Preparing",
              brief: "Brief",
              treating: "Writing treatment",
              treatment: "Treatment",
              storyboard: "Storyboard",
              editing: "Editing",
            },
            DraftSeconds: "{{n}} s",
            DraftShots: "{{count}} shot",
            DraftShots_plural: "{{count}} shots",
            ImportAudioWarning: "The original sound will not be kept in the edited video.",
            EditInDirector: "Edit in Director",
            Selection: "Selection",
            SelectionStart: "Selection start",
            SelectionEnd: "Selection end",
            RefSetName: "Reference set",
            RefSet: "Reference set ({{n}}/{{max}})",
            RefSetEmpty: "Grab frames from the video to reuse them in prompts and generations.",
            AddCurrentFrame: "Add current frame",
            AddToRefs: "Add to reference set",
            Preview: "Preview",
            PreviewClose: "Close preview",
            PreviewPrev: "Previous image",
            PreviewNext: "Next image",
            PreviewOf: "{{n}} of {{total}}",
            UseTake: "Use this take",
            Upload: "Upload",
            UploadImage: "Choose an image file",
            RefMenu: "Reference actions",
            RefN: "Reference {{n}}",
            UseAsEnd: "Use as end frame",
            UseAsKeyframe: "Use as keyframe for the selected shot",
            GenerateFinal: "Generate final frame…",
            UseFrameFinal: "Use this frame to generate a final frame…",
            DeleteRef: "Delete",
            FinalTitle: "Generate a final frame",
            FinalPrompt: "Describe the final frame",
            ImagesUsed: "Images used by this shot",
            KeyframeImage: "Keyframe",
            RegenRefs: "References for regenerate ({{n}}/{{max}})",
            RegenRefsEmpty: "Add frames to the reference set to use them here.",
            DeselectRef: "Deselect reference",
            DeleteFromRefs: "Delete from reference set",
            ConfirmDeleteRef: "Delete this reference from the set? It is removed for good.",
            ShotInProgress: "Shot in progress…",
            FrameAgent: {
              Direct: "Direct from here…",
              Title: "Direct from here",
              MarkCaption: "Optional: mark the element",
              ClearMark: "Clear mark",
              IntentPlaceholder:
                "What should happen from here? e.g. the character walks out of the door",
              Plan: "Plan",
              Planning: "Planning…",
              Change: "Change",
              S_continue: "I'll continue this clip from here.",
              S_bridge_next:
                "I'll continue this clip from here and land on the next clip's first frame.",
              S_endframe_then_continue:
                "First I'll create the target frame, then generate the motion to reach it.",
              S_replace_range: "I'll replace the selected part.",
              CostVideo: "Video",
              CostFrame: "Target frame",
              CostTotal: "Total",
              CreateFrame: "Create target frame",
              StillFailed: "The target frame failed. Try again.",
              FramePrompt: "Frame prompt",
              Update: "Update",
              FrameAt: "Frame {{time}}",
              RangeFromStart:
                "Replacing can't start at the first frame — the selection will be continued instead",
            },
            ShotFailed: "Generation failed",
            FromRef: "From reference",
            RemoveRefKeyframe: "Remove reference keyframe",
            ConfirmRemoveRefKeyframe:
              "Remove the reference keyframe? The shot goes back to its previous keyframe.",
            RefCancel: "Cancel",
            RegenKeyframe: "Regenerate keyframe",
            InsertNeedsPlayhead:
              "Nothing comes before the first frame, so a shot can't be inserted here. Add a shot at the start instead.",
            StoryAssets: "Story & assets",
            StoryAssetsHelper:
              "See the story, cast, locations and keyframes, and reuse any image in a new shot.",
            Tabs: {
              Story: "Story",
              Cast: "Cast",
              Locations: "Locations",
              Keyframes: "Keyframes",
              Refs: "Reference set",
            },
            Aspect: "Aspect ratio",
            ShotList: "Shot list",
            NothingHere: "Nothing here yet.",
            Cookbook: {
              Title: "From this course",
              Badge: "From course",
              Exclude: "Don't use in this video",
              Use: "Use in this video",
              NotUsed: "Not used in this video",
              Rename: "Rename",
              Save: "Save",
              Cancel: "Cancel",
              Remove: "Remove from course",
              ConfirmRemove: "Remove it from the course? Existing videos keep their own copy.",
              ConfirmYes: "Remove",
              StyleMismatch:
                "This course's characters keep their existing look; the chosen style applies to new ones.",
              UseLabel: "Course characters & places",
              UseAll: "Use all",
              UsePick: "Choose",
              UseOff: "Don't use",
              SaveNew: "Save new characters & places to the course",
            },
            SrcLibrary: "From library",
            LibrarySearch: "Search your library",
            LibraryLoadFailed: "Could not load your library.",
            UseLibraryImage: "Use image from library",
            OpenInDirector: "Open in Video Director",
            MakeVideoInDirector: "Make video in Director",
            VideoEditor: "Video editor",
            EmptyTitle: "Start your video",
            EmptyHint: "Pick how to start, or add a shot or bring in your own media.",
            NewVideo: "New video",
            StartCinematic: "Cinematic video from the scene narration",
            StartOwnPrompt: "Create with your own prompt",
            NeedsNarration: "This scene has no narration text",
            FlowSwitch: "Video type",
            FlowCinematic: "Cinematic",
            AnalysisCost: "0.5 cr",
            AnalysisCostTip: "A new analysis costs 0.5 credits",
            Reused: "Showing your earlier video for this scene — the narration hasn't changed.",
            Ld: {
              StartLd: "L&D video from the scene narration",
              FlowLd: "L&D",
              Objective: "What should this video show?",
              ObjectivePlaceholder:
                "e.g. The correct way to lift a heavy box, and what goes wrong otherwise",
              UseCase: "Type of video",
              Audience: "Audience (optional)",
              Length: "Length: {{sec}} s",
              Look: "Look",
              LookBrand: "Brand default",
              LookDefault: "{{style}} (default for this type)",
              LookChange: "Change",
              LookHide: "Hide",
              Estimate: "About {{low}}–{{high}} credits",
              EstimateDetail: "{{shots}} shots, up to {{stills}} images",
              EstimateLoading: "Estimating…",
              DraftFirst: "Draft first",
              DraftHint: "Cheap preview first; finalize the shots you keep.",
              Draft: "Draft",
              FinalNotPlaced: "Final (not placed)",
              Finalize: "Finalize",
              FinalizeShot: "Finalize this shot",
              FinalizeStrip: "{{n}} draft shots",
              FinalizeModel: "Final model",
              FinalizeAll: "Finalize {{n}} shots · {{price}}",
              UseCases: {
                safety: "Safety demonstration",
                safety_hint: "Wrong way, consequence, right way",
                process: "Process walkthrough",
                process_hint: "Step by step, close-ups on hands and tools",
                scenario: "Scenario",
                scenario_hint: "A short workplace situation",
                concept: "Concept explainer",
                concept_hint: "Animated, no people",
                product: "Product intro",
                product_hint: "Hero shots, then in use",
              },
            },
            StartingPoint: "Starting point",
            EmptyAddShot: "Add shot",
            EmptyImportVideo: "Import video from library",
            EmptyImportHint:
              "Opens a new project with that video; this empty project stays in your drafts.",
            EmptyAddImage: "Add image from library",
            OriginBlank: "Blank",
            InRefSet: "In reference set",
            UseKeyframeFor: "Use as keyframe for shot {{n}}",
            NewShotWith: "New shot with this",
            AddShot: "Add shot",
            AddShotHelper:
              "Create a new shot from a description, characters or an existing keyframe.",
            AddShotPrompt: "What happens in this shot?",
            AddShotAtStart: "Add shot at start",
            EditVideoTitle: "Edit video",
            AdvancedEditor: "Advanced editor",
            PickCast: "Characters (up to {{max}})",
            PickLocation: "Location",
            KeyframeSource: "Start frame",
            KeyframeNew: "Generate from description",
            KeyframeExisting: "From reference set",
            KeyframeFree: "Reusing a keyframe is free.",
            StartNone: "None (text-to-video)",
            EndFrameOptional: "End frame (optional)",
            EndNone: "None",
            EndRefSet: "Reference image",
            EndNeedsStart: "An end frame needs a start frame",
            GenerateKeyframe: "Generate keyframe",
            AddShotNoGen: "Add without generating",
            TextOnly: "Text only",
            Bridge: "Bridge",
            PickKeyframe: "Pick a keyframe",
            Placement: "Where does it go?",
            PlaceHere: "At playhead",
            PlaceStart: "At start",
            PlaceEnd: "At end",
            AddStartFrame: "Add start frame",
            AddEndFrame: "Add end frame",
            StartEmptyHint: "Optional — leave empty for text-to-video",
            EndEmptyHint: "Optional",
            EndEmptyHintAI: "Optional — leave empty and AI decides",
            NoEndFrame: "This model doesn't take a last frame",
            NeedsStart: "Needs a start frame",
            FrameChange: "Change",
            FrameRemove: "Remove",
            SrcRefSet: "Reference set",
            SrcKeyframes: "Keyframes",
            SrcUpload: "Upload image",
            KeyframeOf: "Keyframe · {{label}}",
            BridgeLabel: "Bridge → next clip",
            GeneratedLabel: "Generated from description",
            GeneratedPending: "The image is created when you add the shot",
            PlayheadFrame: "Playhead frame",
            GuideImages: "Guide images ({{n}}/{{max}})",
            VideoRefs: "Reference images ({{n}}/{{max}})",
            CastLocation: "Characters & location",
            NoneSelected: "None selected",
            PickerDone: "Done",
            ChooseSource: "Choose a source",
            FrameOf: "{{label}} · {{time}}",
            InsertTitle: "Insert shot",
            InsertHelper: "Generate a new clip that starts from this frame and is placed here.",
            FinalHelper:
              "Create a new reference image from this frame, for example how a shot should end.",
            EditHelper: "Change the shot's motion prompt, or redraw its keyframe from references.",
            DiscardDraft: "Discard draft",
            NewShots: "New shots",
            NewShotsWaiting: "{{count}} new shot waiting",
            NewShotsWaiting_plural: "{{count}} new shots waiting",
            NewShot: "New",
            GenerateClip: "Generate clip",
            BridgeNext: "Bridge into next clip",
            ShotDetails: "Shot details",
            PrevFrame: "Previous frame",
            NextFrame: "Next frame",
            EndRef: "From reference set",
            EndUpload: "Upload an image",
            RefPending: "Waiting for the image to finish processing…",
            PreparingImage: "Preparing image…",
            WhatHappens: "What happens next:",
            EndHelp: {
              auto: "The AI continues from the start frame and decides how the shot ends.",
              next: "The new shot ends on the first frame of the next clip, so it blends into the cut.",
              ref: "The new shot ends on the reference image you pick.",
              pick: "The new shot ends on the frame you pick from one of your clips.",
            },
            Models: {
              video: "Video model",
              image: "Image model",
              "veo-fast": "Omni",
              veo: "Omni",
              grok: "Grok",
              seedance: "Seedance",
              ltx: "LTX",
              "gemini-nano": "Nano",
              "gemini-pro-nano": "Nano Pro",
              Price: "{{n}} credits",
              PriceShort: "{{n}} cr",
              BriefRow: "AI model",
              Recommended: "Recommended",
              HintEnd: "takes a last frame",
              HintRefs: "reference images",
            },
            Credit: {
              Stills: "Cast and location images (up to)",
              Keyframes: "Keyframes",
              Takes: "Video takes",
              Take: "One video take",
            },
            Errors: {
              content_filtered:
                "This shot was blocked by the content filter. Edit the prompt and try again.",
              generic: "Something went wrong. Please try again.",
              busy: "Still working on the previous request — try again shortly.",
              conflict:
                "The project changed in the meantime. The latest version is shown — please repeat your last change.",
              stale: "This video project is no longer available.",
              flow_switch: "Couldn't switch the video type — the server may need an update.",
              next_required:
                "This shot has no prompt yet. Describe what happens next, or edit the shot first.",
              end_frame_none: "There is no next clip to end on. Choose another end frame option.",
              end_frame_invalid: "That end frame is not available. Pick another.",
              end_frame_requires_start:
                "That end frame needs a start frame. Choose a start frame first.",
              end_frame_unsupported: "This model can't end on a chosen frame — try 'AI decides'",
              edl_full:
                "The video is full: there is no room for another generated shot. Trim or remove something first.",
              project_limit:
                "This project has reached its limit (imports, shots or takes). Remove something or start a new video.",
              continue_source_gone: "The cut this shot continued from was removed.",
              import_source_invalid:
                "This video cannot be imported. Choose a video file uploaded to Aidea.",
              import_too_large: "This video is too large to import.",
              import_too_long: "This video is too long to import.",
              not_regenerable: "This shot cannot be regenerated.",
              finalize_no_draft: "That shot has no draft clip to finalize.",
              refs_full: "The reference set is full (24). Delete one first.",
              refs_source_invalid: "That frame or image cannot be used as a source.",
              refs_source_required: "Pick a source frame or image first.",
              refs_invalid: "That reference is not available any more.",
              cast_photos_consent_required:
                "Confirm you have permission to use the people in the photos.",
              cast_photos_invalid: "One of the photos is not available any more — re-add it.",
              keyframe_not_from_ref: "This keyframe no longer comes from a reference.",
              refs_too_large: "This image is too large to use as a reference.",
              shot_invalid_cast: "One of the chosen characters no longer exists. Pick again.",
              shot_invalid_location: "The chosen location no longer exists. Pick again.",
            },
          },
          Title: "Generate Video",
          NarrationText: "Narration Text",
          NarrationTextPlaceholder: "Enter the narration text for the video...",
          NarrationTextRequired: "Narration text is required.",
          NoVideo: "No videos yet",
          UploadPrompt: "Upload your own video to start.",
          UploadNow: "Upload now",
          UploadDropTitle: "Click to upload or drag and drop",
          UploadDropSubtitle: "MP4, MOV, or WEBM (max 500MB)",
          ErrorTooLarge: "File is too large. The maximum size is 500MB.",
          ErrorInvalidType: "Only MP4, MOV, or WEBM files can be uploaded.",
          ConvertNote: "Your .{{ext}} file will be converted to .mp4 during upload.",
          StyleNames: {
            photo: "Photorealistic",
            "3d": "3D Animation",
            cinema: "Cinematic",
            motion: "Motion Graphics",
            anime: "Anime",
            watercolor: "Watercolor",
            illustration: "Illustration",
            stopmotion: "Stop-motion",
            animation: "Animation",
            realistic: "Realistic",
            cartoon: "Cartoon",
            artistic: "Artistic",
            documentary: "Documentary",
            educational_explainer: "Educational Explainer",
            whiteboard_animation: "Whiteboard Animation",
            futuristic_sci_fi: "Futuristic Sci-Fi",
          },
          ContentLanguage: "Content Language",
          VideoProvider: "Video Provider",
          VideoStyle: "Video Style",
          VideoStylePlaceholder: "Select style",
          VideoDuration: "Video Duration",
          VideoDurationPlaceholder: "Duration in seconds",
          Generate: "Create Storyboard",
          Generating: "Creating storyboard...",
          Submitting: "Submitting...",
          VideoReady: "Video ready!",
          AddToEditor: "Add to Editor",
          Download: "Download",
          Close: "Close",
          Processing: "Generating video...",
          BackgroundNote:
            "The process will continue in the background even if you close the modal.",
          Failed: "Failed to generate video.",
          Optional: "(optional)",

          // AI Generate Tab
          AIModel: "AI Model",
          AspectRatio: "Aspect Ratio",
          Duration: "Duration",
          Auto: "Auto",
          AIDecides: "AI decides",
          Custom: "Custom",
          SetTotal: "Set Total",
          Seconds: "sec",
          Style: "Style",
          StyleDisabledNote: "(Disabled - style reference image is being used)",
          CustomCardLabel: "Custom",
          ChangeImage: "Change Image",
          MoreStyles: "More Styles",
          LessStyles: "Less Styles",
          OptionalEnhancements: "Optional Enhancements",
          OverlayText: "Overlay Text",
          StartingImage: "Starting Image",
          FirstFrame: "First Frame",
          Browse: "Browse",
          StyleReference: "Style Reference",
          VisualGuide: "Visual Guide",
          TextAndImageOverlays: "Text and Image Overlays",
          Text: "Text",
          Image: "Image",
          NoOverlaysYet: "No overlays yet. Add text or image overlays to show in the video.",
          Position: "Position",
          TopLeft: "Top Left",
          TopCenter: "Top Center",
          TopRight: "Top Right",
          BottomLeft: "Bottom Left",
          BottomCenter: "Bottom Center",
          BottomRight: "Bottom Right",
          Center: "Center",
          EnterTextToDisplay: "Enter the text to display",
          FontFamily: "Font Family",
          FontStyle: "Font Style",
          Normal: "Normal",
          Bold: "Bold",
          Italic: "Italic",
          BoldItalic: "Bold Italic",
          FontSize: "Font Size",
          FontColor: "Font Color",
          BGColor: "BG Color",
          BGOpacity: "BG Opacity",
          ImageURLOrUpload: "Image URL or Upload",
          Upload: "Upload",
          File: "File",
          WidthPx: "Width (px)",
          HeightPx: "Height (px)",
          Opacity: "Opacity",
          Preview: "Preview",
          SampleText: "Sample Text",
          WritePrompt: "Write Prompt",
          FromNarration: "From Narration",
          AIWillDecide: "AI will decide the number of scenes and duration",
          DescribeVideo: "Describe the video you want to create for this scene...",
          SceneNarration: "Scene Narration",
          EachSentenceOneScene: "Each sentence = one scene",
          DescribeSceneNarration: "Describe the scene narration...",
          EachSentenceBecomesScene:
            "Each sentence becomes a scene. Remove those that don't need visual support.",
          DefaultStyles: {
            photo: "Photorealistic",
            "3d": "3D Animation",
            cinema: "Cinematic",
            motion: "Motion Graphics",
            anime: "Anime",
            watercolor: "Watercolor",
            illustration: "Illustration",
            stopmotion: "Stop Motion",
          },
          Model: {
            grok: {
              Label: "Grok",
            },
            "veo-fast": {
              Label: "Omni (720p)",
            },
            "veo-lite": {
              Label: "Omni (720p)",
            },
            veo: {
              Label: "Omni",
            },
          },
          AdvancedSettings: "Advanced Settings",
          ImageUrlPlaceholder: "https://...",
          StartingImagePreviewAlt: "Starting image preview",
          StyleReferencePreviewAlt: "Style reference preview",

          // Storyboard Panel
          StoryboardCreating: "Loading storyboard...",
          Back: "Back",
          Storyboard: "Storyboard",
          ScenesCount: "scenes",
          Clear: "Clear",
          Scene: "Scene",
          Narration: "Narration",
          VideoPrompt: "Video Prompt",
          Edit: "Edit",
          Save: "Save",
          Saving: "Saving...",
          Cancel: "Cancel",
          Cancelling: "Cancelling...",
          VideoPreview: "Video Preview",
          AddToScene: "Add to Scene",
          Regenerate: "Regenerate",
          NextScene: "Create the Scene",
          PreviewImage: "Preview Image",
          GeneratePreviewImage: "Generate Preview Image",
          RegeneratePreviewImage: "Regenerate",
          GeneratingPreview: "Generating...",
          GenerateAllScenes: "Generate All Scenes",

          // Add scene
          AddScene: "Add Scene",
          AddSceneTitle: "Add New Scene",
          AddSceneNarrationLabel: "Narration Text",
          AddSceneNarrationPlaceholder:
            "What should be narrated in this scene? (at least 20 characters)",
          AddSceneDurationLabel: "Duration (seconds)",
          AddScenePromptLabel: "Video Prompt",
          AddScenePromptPlaceholder: "Describe the visuals for this scene (at least 20 characters)",
          AddScenePromptHint:
            "Narration is derived from this prompt; the provider sets the duration.",
          AddScenePromptTooShort: "Video prompt must be at least 20 characters",
          AddScenePositionLabel: "Position",
          AddScenePositionAppend: "Add to end",
          AddScenePositionBefore: "Before Scene {{n}}",
          AddSceneAfterScene: "After Scene {{n}}",
          AddSceneAdding: "Adding...",
          AddSceneTextTooShort: "Narration text must be at least 20 characters",

          // Reference image (image-to-video)
          ReferenceImageAdd: "Reference image",
          ReferenceImageUploading: "Uploading...",
          ReferenceImageSet: "Reference image ready",
          ReferenceImageRemove: "Remove",
          StartingImageAsReference: "Starting image",

          // Scene images (select as reference)
          SceneImages: "Scene images",
          SceneImagesHint: "Select an image from this scene to use as the video's starting image.",
          SceneImageSelect: "Select as reference",

          // Status labels
          StatusPending: "Pending",
          StatusGenerating: "Generating",
          StatusProcessing: "Processing",
          StatusCompleted: "Completed",
          StatusFailed: "Failed",
          StatusError: "Error",

          // Error messages
          SceneError: "Scene Error",
          ContentNotSuitable: "Content is not suitable for generation",
          ErrorOccurred: "An error occurred during video generation",
          EditSaveError: "Failed to save changes. Please try again.",
          GenerationError: "Generation Error",
          ValidationError: "Validation Error",
          SceneTextTooShort: "Scene text must be at least 20 characters for meaningful narration",
          VideoPromptTooShort:
            "Video prompt must be at least 20 characters for meaningful video generation",

          // Modal tabs
          AIGenerate: "AI Generate",
          UploadMyVideo: "Upload my video",
          BackToForm: "Back to Form",
          CustomStyleDescription: "Custom Style Description",
          CustomStylePlaceholder:
            "Describe the visual style you want, e.g. cinematic noir, retro 80s animation, stop-motion clay...",

          // Existing storyboard warning
          ExistingStoryboardTitle: "Existing Storyboard",
          ExistingStoryboardMessage:
            "There's already a storyboard in progress. Creating a new video will clear the existing storyboard. Do you want to continue?",
          ProceedAnyway: "Proceed Anyway",

          // Storyboard status messages
          OngoingStoryboard: "Ongoing Storyboard",
          ContinueFromWhere: "You can continue where you left off",
          ViewStoryboard: "View",
          SearchLibrary: "Search",
          LibraryLoadError: "Failed to load videos",

          // Language names
          Languages: {
            "tr-TR": "Turkish (tr-TR)",
            "en-US": "English (en-US)",
            "es-ES": "Spanish (es-ES)",
            "fr-FR": "French (fr-FR)",
            "de-DE": "German (de-DE)",
            "ar-SA": "Arabic (ar-SA)",
            "ja-JP": "Japanese (ja-JP)",
            "pt-BR": "Portuguese (pt-BR)",
            "az-AZ": "Azerbaijani (az-AZ)",
          },

          // Provider names
          Providers: {
            grok: "Grok",
            "veo-fast": "Omni (720p)",
            "veo-lite": "Omni (720p)",
            veo: "Omni",
          },
          EnrichTexts: "Enrich with AI",
        },
      },
      FileHandlers: {
        downloadAsFile: "Download File",
        insert: "Insert",
        import: "Import",
        embed: "Embed",
        replace: "Replace",
        replace_bckg: "Replace background",
        table: "Table",
        graph: "Graph",
        video: "Video",
        audio: "Audio",
        image: "Image",
        Animations: "Animations",
        cancel: "Cancel",
        Object3D: "Object 3D",
        custom: "Custom file",
        selectAll: "Select All",
        selected: "Selected",
        question: "Question",
        type: "Type",
        filter_questions: "Filter questions",
        no_matches: "No matches",
        feedback0: "No exercises will be added",
        feedback1s: "1 exercise will be added",
        feedback1p: "",
        feedback2p: "exercises will be added",
      },
      Title: "Import resource...",
    },
    global_config: {
      Accept: "Save changes",
      aspect_ratio: "Aspect Ratio",
      timeline_visible: "Timeline Visible",
      jobWidgetVisible: "Async Widget",
      chatbotEnabled: "Chatbot",
      anonymous: "Anonymous",
      author: "Author",
      avatar: "Avatar",
      avatar_delete_img: "Delete image",
      avatar_screenshot: "Use screenshot",
      avatar_import: "Import image",
      context: "Context",
      context_list: {
        school: "School",
        primary_school: "Elementary School",
        secondary_school: "Middle School",
        bach_school: "High School",
        high_education: "High Education",
        training: "Training",
        other: "Other",
      },
      course_title: "Lesson Title",
      course_font: "Training Font",
      course_font_none: "Not set",
      course_font_scope_scene: "This scene only",
      course_font_scope_course: "Whole training",
      course_font_note:
        "The selected font is applied to every Basic Text and Rich Text box in the whole training, replacing per-box font settings. It takes effect when you save.",
      default_score: "Default Scene Score",
      total_score: "Total Score",
      total_questions: "Total Question Number",
      required_correct_answers: "Required Correct Answers",
      require_question_evaluation: "Required Question Evaluation",
      require_question_evaluation_info:
        'The "see answer" option will be automatically enabled for this feature to work correctly.',
      description: "Description",
      description_placeholder: "Briefly describe what the document is about",
      dif: {
        null: "not specified",
        undefined: "not specified",
        "very easy": "very easy",
        easy: "easy",
        medium: "medium",
        difficult: "difficult",
        "very difficult": "very difficult",
      },
      difficulty: "Difficulty",
      Discard: "Cancel",
      hideGlobalScore: "Scene score",
      keylist: {
        Art: "Art",
        Biology: "Biology",
        Chemistry: "Chemistry",
        Citizenship: "Citizenship",
        Computerscience: "Computer Science",
        Economics: "Economics",
        Education: "Economics",
        Engineering: "Engineering",
        Foreignlanguages: "Foreign Languages",
        Generalculture: "General Culture",
        Geography: "Geography",
        Geology: "Geology",
        History: "History",
        Humanities: "Humanities",
        Literature: "Literature",
        Maths: "Maths",
        Music: "Music",
        Naturalscience: "Natural Science",
        Physics: "Physics",
        Technology: "Technology",
      },
      keywords: "Keywords",
      keyw: {
        Add_tag: "Add keyword",
      },
      language: "Language",
      minTimeProgress: "Minimum time per page",
      mode: "Course mode",
      content_language: "Training language",
      content_language_hint:
        "Question texts and generated audio, avatars and videos default to this language. It does not change the editor interface language.",
      mode_list: {
        clm: "CLM",
        infographic: "Infographic",
        html_artifact: "Interactive HTML",
        presentation: "Presentation",
        atomic_presentation: "Atomic Presentation",
        mixed: "Mixed",
      },
      no_lang: "Not specified",
      permissions: {
        title: "Permissions",
        allow_clone: "Allow Clone",
        allow_comments: "Allow Comment",
        allow_download: "Allow Download",
      },
      prompt: "Would you like to save your changes?",
      public_domain: "Public domain",
      recom_age: "Recommended age",
      rights: "License",
      rights_short_txt:
        "The Creative Commons copyright licenses are a simple, standardized way to grant copyright permissions to their creative work.",
      status: "Status",
      status_list: {
        draft: "Draft",
        public: "Public",
        final: "Final",
        revised: "Revised",
        unavailable: "Unavailable",
      },
      title: "Global Configuration",
      title_advanced: "Advanced",
      title_general: "General data",
      typicalLearningTime: "Typical learning time",
      version: "Version",
      visor_nav: {
        keybindings: "Keyboard arrows",
        player: "Button bar",
        sidebar: "Side navbar",
        title: "Preview navigation",
        fixedPlayer: "Fixed Player  ",
        timeBar: "Time bar",
      },
      group: {
        general: "General",
        geometry: "Scene geometry",
        scene_defaults: "Scene defaults",
        progress_access: "Progress & access",
        visor_navigation: "Visor navigation",
        theme: "Theme",
      },
      scene_defaults_override_warning:
        "When you save, these settings are written to every existing scene and override the mandatory settings on those scenes.",
      default_scene_duration_hint:
        "The time a non-mandatory scene needs to count as completed. If left empty, the minimum time per page ({{seconds}} s) applies.",
      wait_for_time_hint: "Wait for Slide Duration waits for the scene end time on the timeline.",
      default_scene_duration: "Default scene duration (sec)",
      default_scene_duration_placeholder: "Not set",
      default_mandatory_label: "Mandatory",
      auto_next: "Automatic next scene",
      scene_duration_placeholder: "Scene's own duration",
      scene_group: {
        standard: "Scenes",
        standard_hint:
          "Scenes without questions. When mandatory, moving on is blocked until the time is up.",
        question: "Question scenes",
        question_hint:
          "Scenes with questions. These settings are never applied to scenes without questions.",
        transition: "Scene transition",
        transition_hint: "Applies to every scene. Question scenes never advance automatically.",
      },
      cancel: "Cancel",
    },
    ratio_style: {
      standard: "Standard / Digital",
      classic: "Classic",
      square: "Square / Social",
      reels: "Reels / Shorts",
      ig_portrait: "Instagram Portrait",
    },
    ratio_reproduce: {
      menu_label: "Generate in Different Ratio",
      title: "Generate in Different Ratio",
      question:
        "{{title}} ({{ratio}}) Do you want to reproduce this training in a different screen ratio?",
      pick_ratio: "Select Target Ratio",
      desc: {
        "16_9": "Standard widescreen format",
        "4_3": "Classic TV format",
        "1_1": "Instagram feed and social media",
        "9_16": "Instagram Reels, YouTube Shorts",
        "4_5": "Instagram portrait post format",
      },
      resolution: "Resolution",
      res_1k: "1K",
      res_1k_desc: "Low cost, fast",
      res_2k: "2K (Default)",
      res_2k_desc: "Balanced quality and cost",
      res_4k: "4K",
      res_4k_desc: "Maximum quality",
      new_name: "New Training Name",
      note: "Note: This will create a new training and may take a few minutes. Photos may not stay exactly the same.",
      create: "Create",
      creating: "Creating…",
      error: "Could not start the operation. Please try again.",
      errors: {
        not_owner: "You do not own this training.",
        forbidden: "You are not authorized for this action.",
      },
      timeout: "The operation timed out.",
      toast_started_title: "Reproduction started",
      toast_done_title: "Generate in Different Ratio",
      toast_progress: "Generating... {{progress}}%",
      toast_done: "Training created. You can find the new training on your Trainings page.",
      toast_failed: "Reproduction failed.",
    },
    nav_dropdown: {
      new_training: "Create New",
      subtitles: "Subtitles",
    },
    fullscreen: "Fullscreen",
    Header: "Header",
    Height: "Height",
    Height_auto: "Height Auto",
    Height_auto_message: "This will not work unless the container has a height other than auto",
    Height_percentage: "Height (%)",
    Height_pixels: "Height (px)",
    hide: "Hide",
    atLeastOneSceneVisible: "At least one scene must stay visible",
    sceneMultiSelect: {
      title: "Delete Scenes",
      selected: "{{count}} scenes selected",
      confirm: "Delete {{count}} scenes?",
    },
    horizontal: "Horizontal subtitle",
    Images: "Images",
    importData: "Import data file...",
    importFile: {
      title: "Add Background",
      pages: {
        from: "From",
        title: "Pages",
        to: "To",
        whole_file: "Whole file",
      },
      importAs: {
        title: "Import as",
        slideBackground: "Slide background",
        images: "Drawings",
        customSize: "File size",
        PDFViewer: "PDF Viewer",
      },
      footer: {
        ok: "Accept",
        cancel: "Cancel",
      },
    },
    ZipImport: {
      drop_zip: "Drop screen recording ZIP here",
      hint: "Screen recording ZIP exported from the recorder extension",
      starting: "Starting…",
      success: "Import complete!",
      failed: "Import failed",
      invalid_file: "Not a valid ZIP file",
      try_again: "Try again",
      tab_upload: "Upload File",
      tab_screen: "Screen Training",
      select_scene: "Insert after which scene?",
      at_end: "At the end",
    },
    Importing: "Opening...",
    INDEX: "INDEX",
    index_total_duration: "Total duration",
    Indice: "Index",
    insert_plugin: "Insert content",
    joyride: {
      back: "Back",
      carrousel: "Complete and order your document by adding more pages, slides, and sections",
      canvas: "This is the edit area, use it to build you resource",
      close: "Close",
      drag: "Choose the content needed. You can click or drag",
      idealStudio_description:
        "your tool for the creation of enriched and standardized educational resources",
      index:
        "Manage your pages, slides and contained views in the index. Ah! A contained view is created by inserting marks in your resources",
      last: "Finish",
      manual:
        "If you have any doubt, you can access the help menu. You can always run this tour again or consult our ",
      manual2: " user manual",
      menu: "From the menu, you can import your PDFs and all the resources you need. Also from here you can export the document to standard formats and change the global settings",
      need_help: "Do you need help to start adding some content?",
      next: "Next",
      preview: "Preview your document as many times as you need to see how is going on",
      skip: "Skip",
      start: "Start walkthrough",
      toolbar: "You can change the settings of your views & resources in the toolbar",
      welcome: "Welcome to",
      why: "Why don't you try adding some content?",
    },
    currentLang: "en",
    marks: {
      add_mark: "Add mark",
      add_mark_to: "Add mark to ",
      create_mark:
        "You are creating a new mark that links to a contained view. What would you like to name them?",
      edit_mark_to: "Click action",
      existing_content: "Existing content",
      existing_content_label: "Link destination",
      external_url: "External content",
      external_url_label: "URL",
      hover_message: "Enlaza con ",
      link_to: "Link to",
      mark_color: "Mark color",
      mark_name: "Mark name",
      marks_list: "Marks list",
      nothing: "Do nothing",
      pause_until_clicked: "Pause timeline until clicked",
      click_action: "Click action",
      when_clicked: "When clicked",
      opt_nothing: "Continue",
      opt_nothing_hint: "Nothing happens, the scene keeps going",
      opt_sub: "Open sub-screen",
      opt_sub_hint: "Show a screen on top of this one",
      opt_back: "Back to main",
      opt_back_hint: "Close the sub-screen and resume",
      opt_next: "Next scene",
      opt_next_hint: "Jump to the scene after this one",
      opt_goto: "Go to scene...",
      opt_goto_hint: "Pick any scene or sub-screen",
      opt_external: "External link",
      opt_external_hint: "Open a web address in a new tab",
      opt_popup: "Show text",
      opt_popup_hint: "Show a text bubble",
      sub_new: "Create new",
      sub_existing: "Use existing",
      pause_hint: "The scene stops when this click appears and continues after it's clicked.",
      err_dest: "Pick a destination.",
      err_url: "Enter a URL.",
      err_url_scheme: "Only http(s) links are allowed.",
      dest_missing: "The saved destination no longer exists — pick a new one.",
      dest_missing_option: "(missing destination)",
      err_text: "Enter the text to show.",
      img_click_action: "Add click action",
      img_before: "Before click",
      img_after: "After click",
      img_after_empty: "Nothing selected",
      upload_video_hint: "Upload or drag & drop a video (MP4, WEBM)",
      err_video_file: "Please upload a video file (MP4, WEBM).",
      type_image: "Image",
      type_video: "Video",
      pause_hint_video:
        "The scene stops when this click appears and continues when the video has finished.",
      img_remove: "Remove click action",
      next_view: "Next content",
      prev_view: "Previous content",
      go_to_section: "Go to section",
      go_to_section_label: "Section",
      add_click_zone: "Add click zone",
      new_content: "New content",
      new_content_label: "Link destination",
      new_document: "Page",
      new_slide: "Slide",
      new_mark: "New click",
      popup: "Show PopUp",
      popup_label: "Click text",
      popup_placeholder: "Write the text you want to show when you click on mark",
      value: "Value",
      wrong_value: "Wrong Value",
      save_changes: "Save Changes",
      applyAllScenes: "Save as Template",
      applyAllScenesNote: "Saves this slide as a template so you can reuse it later.",
      upload_template: "Save Slide",
      TemplateName: "Template Name:",
      template_uploaded_slide: "Saved Templates",
    },
    boxPaste: {
      assetsWarning:
        "Could not copy the element's media. It still points to the original training and may not display for viewers: ",
    },
    messages: {
      add_new_mark: "Add New Mark",
      add_answer: "Add answer",
      AddBox: "Add new box",
      adjust_to_document: "Adjust to document",
      alert: "Alert",
      align_bottom: "The bottom of the element is aligned with the lowest element on the line",
      align_center: "Align center",
      align_left: "Align Left",
      align_middle: "The element is placed in the middle of the parent element",
      align_right: "Align Right",
      align_top:
        "The top of the element is aligned with the top of the tallest element on the line",
      all_fields: "You must fill in all of the fields in order to upload the file",
      Cancel: "Cancel",
      Change: "Change",
      Change_source: "Change Source",
      columns_distribution: "Columns distribution",
      confirm_delete_cv: "Confirm deletion",
      confirm_delete_CV_also_1: 'This is the only mark that links to "',
      confirm_delete_CV_also_2: '". Would you like to delete that view as well?',
      confirm_delete_cv_as_well: "Delete also contained view",
      confirm_delete_cv_not: "Delete only the mark",
      draw_borders: "Add borders to the documents",
      delete_busy_cv: "All the marks that link to this view will be deleted.",
      delete_container: "This action will erase all the content in this block.",
      delete_contained_canvas: "This action will erase this contained view",
      delete_idealStudio_document: "Delete Aideapro Studio Document",
      delete_idealStudio_document_message:
        "Are you sure you want to delete this document? You will lose all the content you have created.",
      delete_page:
        "This action will erase all the content in this page and the marks that link to it.",
      cant_delete_last_page: "The last scene cannot be deleted. There must be at least one scene.",
      delete_section:
        "This action will erase all the content in this section and its children, and the marks that link to them.",
      docs: "Read documentation",
      drag_content: "Drag content here",
      edit_text: "Edit text",
      double_click_to_edit: "Double-click to edit",
      change_icon: "Change icon",
      erase_plugin: "Delete",
      increase_text_size: "Increase text size",
      decrease_text_size: "Decrease text size",
      align_left: "Align left",
      align_center: "Align center",
      align_right: "Align right",
      align_up: "Align Up",
      align_right: "Align Right",
      align_left: "Align Left",
      align_center: "Align Center",
      align_down: "Align Down",
      align_arrows: "Align",
      erase_container: "Delete Container",
      error: "Error",
      exit: "Exit",
      exit_page: "Are you sure you want to leave this page?",
      export: "Export...",
      export_course: "Export document",
      export_to_lms: "Exporting to LMS",
      lms_overwrite_message: "This training was previously exported to LMS on {{date}}.",
      lms_overwrite_message_second: "How would you like to proceed?",
      lms_overwrite_title: "Export to LMS",
      lms_save_as: "Create New",
      lms_overwrite: "Overwrite",
      export_to_HTML: "Export to HTML",
      export_to_label: "Choose how to export the document",
      export_to_SCORM: "Export to SCORM",
      export_to: "Export to",
      forbidden: "You cannot modified the license of a resource that has already been published",
      force_page_break: "I want to insert a page break before every imported document.",
      fullscreen: "Activate full screen mode",
      global_config: "Global Config",
      go_back: "Go back",
      go_back_to: "Go back to ",
      help: "Help",
      language: "Language",
      language_english: "English",
      language_spanish: "Spanish",
      language_turkish: "Turkish",
      help_modal_text: "You can solve any doubt about Aidea Studio",
      import: "Import... ",
      import_file: "Import file ",
      instance_limit: "This plugin only allows one instance per page",
      clm_plugin_blocked: "This element type is not available in CLM presentations.",
      depth_limit: "You cannot insert this kind of content here",
      height_auto_warning:
        "The boxes inside can only have a relative height if you fix the container height",
      mark_input: "Something is wrong with your input",
      no_internet: "You need Internet connection",
      OK: "Accept",
      okay: "Okay",
      only_slides: "Only slides",
      only_pages: "Only pages",
      operation_in_progress: "Operation in progress...",
      pointer_events: "Allow to manually manipulate the content",
      popoverUrlTitle: "Change this URL",
      preview: "Show a preliminary view",
      publish_tooltip: "Makes the course available for the public",
      publish_alert_title: "Publish this document",
      publish_alert_text:
        "This action will publish your document in the public repository. It means that everybody can reuse it.",
      publish_not_allowed:
        "Add a title and a thumbnail to your resource before publishing it. In order to do this access Menu > Global Configuration.",
      redo: "Redo the last action",
      RemoveBox: "Delete one box",
      remove_answer: "Remove answer",
      move_up: "Move up",
      move_down: "Move down",
      save_changes: "Save changes",
      save_as_changes: "Save changes as",
      saving: "Saving...",
      selfContained:
        "I want to include the files that I uploaded in the exported package so I can use it when I am offline.",
      subtitlesOnByDefault: "Show subtitles automatically when the training opens.",
      slides_and_pages: "Slides and pages",
      slides_per_page: "Slides per page: ",
      undo: "Undo the last action",
      unpublish: "Makes the document unavailable for the public",
      GoogleFontsModal: {
        title: "Google Fonts Usage Consent",
        fontsNotFound: "The following fonts were not found on your system:",
        needGoogleFonts: "We need to use the Google Fonts service to use these fonts.",
        importantInfo: "Important Information:",
        connectsToGoogle: "Google Fonts connects to Google's servers to load fonts",
        ipAddressVisible: "Google can see your IP address",
        secureLoading: "Fonts are loaded securely",
        safeForViewing: "Fonts are for viewing purposes only and do not contain malicious code",
        editorAndExport:
          "In the editor, fonts will be loaded via link, while in exports, font files will be downloaded and included in the package",
        permissionQuestion: "Do you consent to the use of Google Fonts?",
        cancel: "Cancel",
        approve: "Yes, I Consent",
        success: "Font added successfully.",
        error: "Selected fonts could not be downloaded from Google Fonts service.",
        connectionError: "A connection error occurred.",
        loading: "Please wait...",
      },

      help_welcome: "Welcome to Aideapro Studio. Click for help tips.",
      help_guide:
        "If you have any questions after the help tips, you can refer to our user guide here. (This option is under development.)",
      help_documentation:
        "If you are a developer, you can have a look at the documentation here. (This option is under development.)",
      Success: "Success",
      SuccessMessage: "The e-learning has been successfully registered.",
      LmsExportSuccess: "Training exported to the LMS and added to the Content Pool.",
      RotateLeft: "Rotate Left",
      RotateRight: "Rotate Right",
      Copied: "Copied!",
      syncScene: {
        buttonLabel: "Sync Scene",
        buttonTitle: "Sync the active scene",
        syncing: "Syncing scene...",
        successTitle: "Sync",
        successMessage: "Scene synced successfully.",
        errorTitle: "Error",
        errorMessage: "Failed to sync scene.",
        saveFirst: {
          title: "Unsaved changes",
          body: "There are unsaved changes. To use Sync Scene you need to save the training. Do you want to save and sync now?",
          confirm: "Save and sync",
          cancel: "Cancel",
          saving: "Saving…",
          saveError: "Couldn't save the training. Please try again.",
        },
        aiButton: "Sync with AI",
        modal: {
          title: "Sync with AI",
          desc: "AI automatically synchronizes the visual and text elements in the scene with your audio file.",
          step1: "Audio file is analyzed",
          step2: "Timing of visual elements is aligned with audio",
          step3: "Text elements are positioned according to audio",
          extractTexts: "Extract texts in visuals",
          extractTextsPrice: "10 credits",
          busy: {
            motion: "Enriching & motionizing the scene…",
            extract: "Extracting the texts in the images…",
          },
          toast: {
            synced: "Scene sync finished",
            extracted: "Scene sync finished — the image texts were added",
            motion: "Scene enriched & motionized",
          },
          jobFailed: "The job could not be finished. No credits were charged; try again.",
          howItWorks: "How it works",
          howItWorksSoon: "Video coming soon",
          howItWorksSync:
            "Your elements are re-timed to the narration: each one enters on the words it belongs to and leaves when the next image takes over. Turn on “Extract texts in visuals” to lift the text out of the images as editable, animated text — applied to the scene by itself.",
          howItWorksMotion:
            "The scene is synced first, then the text in the images is lifted out and motion graphics are designed around the narration. The result is applied to the scene by itself; the job tray shows each step.",
          cancel: "Cancel",
          confirm: "Start Synchronization",
          modeSync: "Sync current elements",
          modeSyncDesc: "Re-time the elements already in the scene to the narration",
          modeMotion: "Enrich & Motionize",
          modeMotionDesc:
            "Sync, lift the text out of the images, add motion graphics and apply it to the scene — no approval step",
          motionConfirm: "Start motion design",
          motionPaidNote: "Paid: uses the Motion Director price.",
          motionErrors: {
            "scene-missing": "The scene was not found.",
            "no-images": "This scene has no images to animate.",
            "no-training": "Open this training from its page and try again.",
            "no-extractable":
              "No image can have its text extracted (cropped or zoomed images are skipped).",
            failed: "Motion design could not be started. Try again.",
          },
        },
      },
      previewSpeed: {
        title: "Preview speed",
        buttonTitle: "Preview speed",
        cycleTitle: "Next speed",
        normal: "normal",
        note: "For timeline preview only, it does not affect the published training.",
        youtubeLimit: "YouTube supports 2× at most.",
      },
      animationNames: {
        Pan: "Pan In",
        Fade: "Fade In",
        "Fade In": "Fade In",
        "Scale In": "Scale In",
        "Slide In Right": "Slide In Right",
        "Slide In Left": "Slide In Left",
        "Slide In Up": "Slide In Up",
        "Slide In Down": "Slide In Down",
        Rotate: "Rotate",
        Bounce: "Bounce",
        "Bounce In": "Bounce In",
        "Rotate In": "Rotate In",
        "Type Writer": "Typewriter",
        "Wavy Text": "Wavy Text",
        Flip: "Flip",
        Pinwheel: "Pinwheel",
        Roll: "Roll",
        Stretch: "Stretch",
        "Pan Out": "Pan Out",
        "Fade Out": "Fade Out",
        "Scale Out": "Scale Out",
        "Slide Out Right": "Slide Out Right",
        "Slide Out Left": "Slide Out Left",
        "Slide Out Up": "Slide Out Up",
        "Slide Out Down": "Slide Out Down",
        "Rotate Out": "Rotate Out",
        "Bounce Out": "Bounce Out",
        "Type Writer Out": "Typewriter Out",
        "Wavy Text Out": "Wavy Text Out",
      },
      animationPanel: {
        panEntryName: "Pan In",
        panExitName: "Pan Out",
        direction: "Direction",
        zoomOut: "Zoom Out",
        zoomIn: "Zoom In",
        zoomAmount: "Zoom Amount",
        startPoint: "Start Point",
      },
      trackClip: {
        repeatForScene: "Repeat for scene",
      },
    },
    ThemePalette: {
      Title: "Theme & Palette Selection",
      Select: "Select",
      Theme: "Theme",
      SelectTheme: "Select theme",
      LoadingThemes: "Loading themes...",
      Palette: "Palette",
      LoadingPalettes: "Loading palettes...",
      NoPalettes: "No palettes found for this theme.",
      ErrorSelectBoth: "Please select a theme and a palette.",
      UnknownError: "An unknown error occurred.",
      Apply: "Apply",
      Applying: "Applying...",
      NoThemesError: "Failed to load themes.",
      ThemeStyleFetchError: "Failed to load theme styles.",
      RemoveTheme: "Remove Theme",
      ApplyToAll: "Apply to all scenes",
      Custom: "Custom",
      Mode: "Mode",
      ModeImage: "Image",
      ModeHtml: "HTML / CSS",
      ModeColor: "Color",
      HtmlPlaceholder:
        '<div style="position:absolute;inset:0;background:linear-gradient(135deg,#1a1a2e,#16213e);"></div>',
      Edit: "Edit",
      Preview: "Preview",
    },
    EditButton: {
      edit_selected: "Edit selected element",
      no_selection: "Select an element to edit",
      multi_selection: "Select a single element to edit",
      container_selected: "Containers cannot be edited directly",
      unsupported_plugin: "This element type has no edit action",
      artifact_ref: "Interactive scenes are edited with AI, from the element's chat button",
      html_modal_title: "Edit HTML content",
      html_placeholder: '<div style="padding:16px;background:#fff">Hello</div>',
    },
    MoodleXML: {
      are_you_sure: "Are you sure it's MoodleXML?",
      parse_error: "Error when parsing the file",
      unrecognized: "Unrecognized exercise type",
      not_supported: "Not yet supported",
    },
    Multimedia: "Media",
    NavItem_name: "Page name",
    General_name: "General",
    NavItem_title: "Page title",
    no_results: "No results",
    Objects: "Objects",
    OK: "OK",
    Open: "Open",
    Open_Catalog: "View uploaded images",
    open_conf: "Settings",
    minTime: "Slide Duration",
    slideDuration: "Slide Duration",
    autoNext: "Auto Next Slide",
    autoNextNote: "Auto-advance happens after the whole scene has finished.",
    autoNextShowCta: "Show countdown before advancing",
    autoNextShowCtaNote:
      "Shows the next-scene card with a 5s countdown. Off, the scene advances silently.",
    sceneEndCta: "Scene-end transition card",
    sceneEndCtaNote:
      "When on, a card inviting the learner to the next scene appears once the scene finishes and its requirement (if any) is met. When off (default), the scene stays on screen and the learner advances with the Next button.",
    isMandatory: "Mandatory",
    mandatoryType: "Slide Transition Options",
    waitForAction: "Wait for Answer",
    waitForCorrectAction: "Wait for Correct Answer",
    waitForOneClick: "Wait for Click",
    waitForTime: "Wait for Slide Duration",
    // TODO: deprecated — labels below only serve retired mandatory types shown
    // disabled on legacy trainings; remove once no trainings still use them.
    waitForAnimation: "Wait for Animation",
    waitForSound: "Wait for Sound",
    waitForVideo: "Wait for Video",

    Sound: {
      Sound: "Narration Sound",
      uploadSound: "Import Sound",
      soundRecorder: "Sound Recorder",
      addSound: "Add Sound",
      demoSound: "Sample Sounds",
      slaytSounds: "Sounds on Slide",
      soundList: "Sound List",
      add_sound: "Add Sound",
      sound_name: "Sound Name",
      sound_name_holder: "Sound Name...",
      Add: "Add",
      select_sound: "Sound Selection",
      AddNewSoundFromList: "Add New Sound From List",
      AddNewSoundFromLocal: "Add New Sound From Local",
      AddAISound: "Add AI Sound",
      NoFileChosen: "Choose Voice...",
      VolumeLevel: "Sound Volume",
      DemoSound: "Sound Preview",
      Start_Time: "Start Time: ",
      End_Time: "End Time: ",
      Volume: "Volume: ",
      Edit: "Edit",
      Delete: "Delete",
      Play: "Play",
      Pause: "Pause",
      listenSounds: "Listen Sound(s)",
      FileAdded: "Sound added successfully.",
      Sounds: "Sounds",
    },
    Recorder: "Recorder Time",

    order: {
      Ahead: "Ahead",
      Behind: "Behind",
      BringtoFront: "Front",
      SendtoBack: "Back",
    },
    page: "Page",
    pages: "Pages",
    pagenumber: "Number",
    Pixels: "Pixels",
    Percentage: "Percentage",
    player: {
      First: "First",
      Previous: "Previous",
      Next: "Next",
      Last: "Last",
      Export: "Export",
    },
    plugin_config: "Configuration",
    Position: "Positioning",
    Preview: "Preview",
    Properties: "Properties",
    Publish: "Publish",
    Read_more: "Read more",
    Redo: "Redo",
    Reorder: "Reorder",
    Rotate: "Rotate (deg)",
    HorizontalFlip: "Horizontal Flip",
    VerticalFlip: "Vertical Flip",
    repeatedItemCopied: "(copy)",
    row_number: "Number of rows in col ",
    Save: "Save",
    SaveAs: "Save As",
    Score: "Score",
    Score_feedback: "Your score is",
    "SCORM Explanation":
      "A SCORM package is a collection of files which are packaged according to an agreed standard for learning objects. SCORM packages are zip files that can be integrated in any LMS (Learning Management System) that supports the standard (Moodle, Blackboard, …) and that can be used for presenting multimedia content and as assessment tools. Thus, you can integrate this document in Moodle and other LMSs by downloading it as SCORM.",
    "HTML Explanation":
      "This option exports a .zip package that contains two folders: one with the index.html file of the document, which you can open in any browser, and another with the necessary resources for its correct preview.",
    "URL Explanation":
      "This option takes a copy of the training you prepared and generates a link (url). <b>The training is saved automatically before the link is generated</b>, so your latest changes are always included. You can share and publish the generated link in other media.",
    "EDI Explanation":
      "This option exports a .edi file with the content of your document which you will be able to import in other Aideapro Studio documents, even if they are hosted in different platforms.",
    "PDF Explanation": "This option generates a PDF file.",
    Search_in_ViSH: "Search in ViSH",
    Searching: "Searching...",
    section: "Section",
    show: "Show",
    show_subtitle: "Show Subtitle",
    slide: "Slide",
    step_next: "Next step",
    step_previous: "Previous step",
    Submit: "Submit",
    subtitle: "Subtitle",
    subtitle_hide: "Hide Subtitle",
    Replay: "Replay",
    visor: {
      subtitles: "Subtitles",
      playbackSpeed: "Playback speed",
      normalSpeed: "normal",
      off: "Off",
      previous: "Previous",
      play: "Play",
      pause: "Pause",
      replay: "Replay",
      reset: "Restart",
      next: "Next",
      fullscreen: "Full screen",
      exit_fullscreen: "Exit full screen",
      remaining: "remaining",
      more: "More options",
      volume: "Volume",
      mute: "Mute",
      unmute: "Unmute",
      close: "Close",
      seek_back: "Back 10 seconds",
      seek_forward: "Forward 10 seconds",
      show_controls: "Show controls",
      hide_controls: "Hide controls",
    },
    // Visor chrome scene-end CTA (visor-ui redesign, Task 3).
    VisorCtaNextScene: "Next scene · {{n}}/{{total}}",
    VisorCtaFinish: "Complete the training",
    VisorCtaFinishInfo: "Training completed",
    VisorCtaFinishEyebrow: "All scenes completed",
    VisorCtaSingleEyebrow: "Single-scene training",
    VisorCtaReplay: "Watch this scene again",
    VisorCtaAnnounce: "Scene {{n}} completed. Next: {{next}}.",
    VisorCtaPreparing: "Scene {{n}} is being prepared…",
    VisorCtaIncompleteEyebrow: "Unwatched scenes · {{n}} left",
    VisorCtaAnnounceIncomplete: "There are unwatched scenes. Continue with: {{next}}.",
    VisorCtaReplayTraining: "Watch the training again",
    // Visor chrome scene row / scene panel / header pill (visor-ui redesign, Task 7).
    VisorRowScene: "SCENE",
    VisorRowVideo: "VIDEO",
    VisorRowQuiz: "QUIZ",
    VisorRowPage: "PAGE",
    VisorRowLockedTitle: "Scene {{n}} isn't unlocked yet",
    VisorRowLockedBody: "Finish the earlier scenes to continue.",
    VisorNoScenes: "This training has no scenes yet.",
    VisorPanelScenes: "Scenes",
    VisorPillScene: "Scene {{n}}/{{total}}",
    VisorPillProgress: "Training progress: {{pct}}%",
    // Visor chrome stage seek zones (visor-ui redesign, Task 8).
    VisorSeekFwd: "+10 SECONDS",
    VisorSeekBack: "−10 SECONDS",
    // Visor SCORM offline queue notice (visor-ui redesign, Task 10).
    VisorOfflineSaved:
      "No connection — your progress is saved on this device and will be sent when you're back online.",
    VisorVideoFailedTitle: "A video in this scene could not load",
    VisorVideoFailedBody: "The scene goes on without it.",
    VisorMediaFailedTitle: "Media could not load",
    VisorMediaFailedBody: "This content cannot load right now; the scene goes on without it.",
    // Visor chrome edge/empty states + resume card (visor-ui redesign, Task 11).
    VisorErrTitle: "Scene {{n}} failed to load",
    VisorErrBody: "The video file can't be reached. Check your connection and try again.",
    VisorErrRetry: "Try again",
    VisorErrSkip: "Skip to scene {{n}}",
    VisorNoScenesTitle: "This training doesn't have any scenes yet",
    VisorNoScenesBody:
      "Content will show up here once it's ready. You can let your training admin know.",
    VisorResumeEyebrow: "WHERE YOU LEFT OFF",
    VisorResumeContinue: "Continue",
    VisorResumeRestart: "Start over",
    // Fix (Task 11): the generating-kind CTA announce previously stitched the
    // full "preparing" sentence into VisorCtaAnnounce's {{next}} slot.
    VisorCtaAnnouncePreparing: "Scene {{n}} is being prepared.",
    success_transaction: "The operation has been successful",
    Structure: "Structure",
    Style: "Style",
    styles: {
      background_color: "Background color",
      border_color: "Border color",
      border_size: "Border Size",
      border_style: "Border Style",
      border_style_options: {
        none: "None",
        hidden: "Hidden",
        dotted: "Dotted",
        dashed: "Dashed",
        solid: "Solid",
        double: "Double",
        groove: "Groove",
        ridge: "Ridge",
        inset: "Inset",
        outset: "Outset",
        initial: "Initial",
        inherit: "Inherit",
      },
      font_weight: {
        normal: "Normal",
        bold: "Bold",
        100: "100",
        200: "200",
        300: "300",
        400: "400",
        500: "500",
        600: "600",
        700: "700",
        800: "800",
        900: "900",
      },
      box_style: "Box style",
      opacity: "Opacity",
      padding: "Padding",
      absolute: "Absolute",
      relative: "Relative",
    },
    templates: {
      scene_header_placeholder: "Scene Title",
      add_text: "Add text here",
      elements_list: "Elements List",
      ex_unique_response: "Single Response Exercise",
      ex_multiple_response: "Multiple Response Exercise",
      ex_free_response: "Free Response Exercise",
      ex_true_false: "True / False Exercise",
      ex_background_sound: "Background Audio",
      ex_matching: "Matching Exercise",
      "ex_fill-in-the-blank": "Fill İn The Blank Exercise",

      first_element: "First element",
      second_element: "Second element",
      third_element: "Third element",
      text_images: "Text and image",
      map: "Interactive map",
      video: "Interactive video",
      web: "Embedded web page",
      template1: "Image & text",
      template2: "Text blocks",
      template3: "Image blocks",
      template4: "Enrich video",
      template5: "Map",
      template6: "Embed web",
      template7: "Image & list",
      template8: "Single response",
      template9: "Multiple response",
      template10: "Open response",
      template11: "True / false",
      template12: "Background Audio",
      template13: "Matching",
      template14: "Fill in the Blank",
      templatechose: "Template Selection",
      template0: "Empty",
      tab_template: "From Template",
      tab_zip: "Screen Training",
    },
    export: {
      full_sli_doc: "Landscape orientation. One slide per page. Page elements will be included.",
      two_sli_doc: "Portrait orientation. Two slides per page. Page elements will be included.",
      full_sli: "Landscape orientation. One slide per page. Page elements will NOT be included.",
      two_sli: "Portrait orientation. Two slides per page. Page elements will NOT be included.",
      sli_comments:
        "Portrait orientation. One slide per page. A space for comments will be included below each slide. Page elements will NOT be included",
      four_sli: "Landscape orientation. Four slides per page. Page elements will NOT be included",
      full_doc: "Portrait orientation. One page per sheet. Slides will NOT be included.",
      two_doc: "Landscape orientation. Two pages per sheet. Slides will NOT be included.",
      safari_landscape:
        " You are using Safari. In order to export the document properly, remember to choose landscape orientation in the print modal. Print backgrounds option must be activated.",
      firefox_landscape:
        " You are using Firefox. In order to export the document properly, remember to choose landscape orientation in the print modal. Print Background Colors and Print Background Images options must be activated. It is recommended not to use headers or footers.",
      safari_portrait:
        " You are using Safari. In order to export the document properly, remember to choose portrait orientation in the print modal. Print backgrounds option must be activated.",
      firefox_portrait:
        " You are using Firefox. In order to export the document properly, remember to choose portrait orientation in the print modal. Print Background Colors and Images options must be activated. It is recommended not to use headers or footers.",
      print_title: "Print settings",
      warning_title: "Warning",
      null_print:
        "There is nothing to export. Please choose a print setting that includes at least an element of your document.",
      download_failed: "Download could not be completed. Please try again later.",
      sli_doc: "Slides and pages",
      sli: "Only slides",
      doc: "Only pages",
      sli_doc_explanation: "these settings include both the slides and pages of the document.",
      sli_explanation:
        "these settings include the slides but do NOT include the pages of the document.",
      doc_explanation:
        "these settings include the pages but do NOT include the slides of the document.",
      clm_desc: "CLM package",
      scorm_scenes: "Each scene as separate SCORM",
      scorm_scenes_desc: "Export each scene as a separate SCORM package",
      scene_progress: "Scene {{k}}/{{n}}",
      scorm_scene_pick: "Scene to export",
      scorm_scene_all: "All scenes (one package each)",
      scorm_scenes_failed: "Failed scenes: ",
      assets_skipped: "Package built, but these images could not be downloaded and were left out: ",
      clm_explanation:
        "Exports this presentation as a static CLM package: index.html, clm-config/config.json and one image per page. All navigation goes through your click zones.",
      clm_zip_name: "Package file name",
      clm_export_done: "Export completed with {{count}} warning(s).",
      clm_close: "Close",
      clm_check_again: "Check again",
      clm_not_checked: "The presentation has not been checked yet.",
      clm_no_problems: "Ready to export — no problems found.",
      clm_errors_title: "Fix these before exporting",
      clm_warnings_title: "Warnings (export allowed)",
      clm_problem_no_pages: "The presentation has no visible scenes.",
      clm_problem_document_scene: "{{scene}}: document scenes cannot be exported to CLM.",
      clm_problem_missing_target:
        "{{scene}}: a click zone points to a target that no longer exists.",
      clm_problem_multi_nav:
        "{{scene}}: a click zone navigates to more than one page (one click = one navigation).",
      clm_problem_unsupported_plugin:
        "{{scene}}: {{plugin}} is not exportable and will be skipped.",
      clm_problem_boundary_nav:
        "{{scene}}: a next/previous click zone has nowhere to go on this page (it will be inert).",
      clm_problem_unsupported_connect_mode:
        '{{scene}}: a click zone is set to "{{connectMode}}", which the static package cannot wire up (it will be inert).',
      clm_problem_empty_click_zone: "{{scene}}: a click zone has no target (it will be inert).",
      clm_problem_small_touch_target: "{{scene}}: a click zone is smaller than 48px (hard to tap).",
      clm_problem_furniture_occlusion:
        "{{scene}}: a click zone sits in the bottom band — check it doesn't cover the page's references/codes there.",
      clm_problem_background_not_exported:
        "{{scene}}: background images are not exported; only the background colour is used.",
      clm_problem_approx_geometry:
        "{{scene}}: an element uses px sizing; its position is approximated on the 1920×1080 stage.",
      clm_problem_external_html:
        "{{scene}}: an HTML element embedding an external URL cannot be exported offline and will be skipped.",
      clm_problem_unsafe_external_url:
        "{{scene}}: a click zone's external link is not a safe web address (only http(s)/mailto/tel are exported) and will be skipped.",
      clm_problem_theme_not_exported:
        "{{scene}}: this scene uses a theme background, which is not exported; a black page will be used instead.",
      clm_problem_missing_asset: "{{scene}}: {{plugin}} is missing its image and will be skipped.",
      clm_problem_download_failed: "{{scene}}: image could not be downloaded ({{url}}).",
      clm_problem_artifact_failed:
        "An animated HTML element could not be fetched ({{detail}}). Save and try again.",
      clm_problem_parity: "Internal error: page count mismatch ({{detail}}).",
      clm_problem_invalid_state: "Internal error: could not check the presentation ({{detail}}).",
    },
    video_export: {
      translate_confirm_title: "Generate in this language?",
      translate_confirm_replace_title: "This language already exists — regenerate it?",
      translate_confirm_text:
        "The merged video will be re-voiced in this language. It can take a few minutes depending on the video's length, and it spends credits.",
      translate_confirm_start: "Generate",
      languages_show_more: "+{{n}} more languages",
      languages_show_less: "Show less",
      title: "Video Export",
      sync_scenes: "Update Scenes",
      sync_scenes_tooltip:
        "Pull the training's current scene list and queue any scenes that haven't rendered yet or failed. Completed videos are left untouched.",
      sync_scenes_confirm:
        "The current scene list will be pulled from the training; any scenes that haven't rendered yet or failed will be queued. Already completed scene videos won't be touched. Continue?",
      recovering: "Recovering…",
      recover: "Recover Old Videos",
      stop: "Stop All",
      stop_confirm:
        "The in-progress render/merge will be cancelled. Already completed scene videos won't be deleted. Continue?",
      clear_tooltip: "Deletes all export records for this training and starts over",
      clear_confirm: "All records for this export will be permanently deleted. Continue?",
      clearing: "Starting over…",
      clear: "Start Over",
      start_modal_title: "Start Video Production",
      regenerate_modal_title: "Regenerate Scene",
      regenerate_modal_hint:
        "This scene will be regenerated. The current video stays in place until it finishes.",
      save_reminder:
        "Don't forget to save the training. Unsaved changes are not included in the video production.",
      cancel: "Cancel",
      subtitle_lang_label: "Subtitle language (optional)",
      subtitle_none: "— No subtitles —",
      subtitle_scene_count: "({{count}} scenes)",
      duration_tooltip: "Total duration",
      history_tooltip: "Previous merged videos",
      history: "History",
      merge_reselect_tooltip: "Re-merge with the new selection",
      merge_disabled_tooltip: "Enabled once every scene is ready",
      merge: "Merge",
      re_merge: "Re-merge",
      checking: "Checking for an existing job…",
      start_hint:
        "Render scenes one by one, review them, and regenerate any you don't like. When ready, press the manual merge button to produce the final video.",
      start: "Start",
      merged_label: "Merged video",
      download: "Download",
      regenerate_scene: "Regenerate This Scene",
      idle_hint: 'Click the "Start" button in the top right to begin.',
      starting: "Starting job…",
      select_scene: "Select a scene",
      merging_placeholder: "Merging…",
      merging_progress: "Merging… {{pct}}%",
      render_percent: "Render {{pct}}%",
      error_prefix: "Error: ",
      retry: "Retry",
      dont_merge_overlay: "Won't Merge",
      dont_merge_tooltip_include: "Include in merge",
      dont_merge_tooltip_exclude: "Don't merge — exclude from merge",
      dont_generate_overlay: "Won't Generate",
      dont_generate_tooltip_include: "Include in generation",
      dont_generate_tooltip_exclude: "Don't generate — exclude from this export",
      cancel_scene_tooltip: "Cancel",
      regenerate_scene_tooltip: "Regenerate",
      history_title: "Previous merges",
      history_loading: "Loading…",
      history_empty: "No merged video yet.",
      preparing_scenes: "Preparing scenes…",
      rendering_of_total: "Rendering {{count}} of {{total}} scenes",
      queued_of_total: "{{count}} of {{total}} scenes queued",
      rendering_count: "{{count}} scene(s) rendering",
      queued_count: "{{count}} scene(s) queued",
      job_on_way: "Job is on its way",
      status_queued: "Queued",
      status_rendering: "Rendering",
      status_uploading: "Uploading",
      status_completed: "Completed",
      status_failed: "Failed",
      status_cancelled: "Cancelled",
      status_merged: "Merged",
      status_merge_pending: "Awaiting merge",
      merge_cancel_confirm:
        "A merge is already in progress. To exclude this scene we need to cancel the current merge — the video will need to be merged again. Continue?",
      training_id_missing: "Training ID not found.",
      no_scenes: "This training has no scenes. Please go back to the editor and add a scene.",
      state_read_error: "Could not read the saved state",
      checking_save: "Checking save status…",
      save_required_title: "You need to save first",
      save_required_body:
        'Your current work must be saved on the server before producing a video. So that all your scene, audio, animation, and text changes render correctly, please click "Save" first and try again.',
      save_failed: "Save failed",
      saving: "Saving…",
      save_now: "Save Now",
      recheck: "Check Again",
      error_title: "Something went wrong",
      menu_label: "Video Export",
      translate_starting: "Starting…",
      translate_failed: "Couldn't start the translation.",
      recover_tooltip:
        "Search Azure Blob for previously rendered scene videos that have no database record.",
      languages_tooltip: "Generate and watch the video in other languages",
      languages: "Languages",
      watch: "Watch",
      languages_title: "Languages",
      languages_hint:
        "Dub the merged video into another language. The scenes stay the same; only the audio changes.",
      dismiss: "Close",
      languages_available: "Ready videos",
      languages_needs_merge: "Merge the video first — translation is done from the merged video.",
      variant_original: "Original",
      languages_add: "Add new language",
      translate_no_languages: "No languages are registered for dubbing.",
      translate_regenerate: "This language already exists — it will be regenerated",
      translate_start: "Generate in this language",
      translate_busy: "A translation is in progress",
      translate_disabled_tooltip: "Merge the video first",
      translate_exists: "available",
      close: "Close",
    },
    subtitles: {
      title: "Subtitles",
      available_languages: "Available Languages",
      refresh: "Refresh",
      no_subtitles: "No subtitles generated yet. Use the form below to generate subtitles.",
      delete_language: "Delete this language's subtitles",
      set_default: "Make default subtitle",
      unset_default: "Default subtitle — click to remove",
      default_hint:
        "The starred language turns on when the subtitles button is pressed in the preview.",
      default_failed: "The default subtitle couldn't be saved.",
      subtitles_for: "Subtitles for",
      not_found: "Subtitle not found for this scene",
      no_subtitle_for_scene: "No subtitle available for this scene",
      generate_title: "Generate Subtitles",
      select_language: "Select language...",
      force_regenerate: "Force regenerate",
      generating: "Generating...",
      generate_btn: "Generate",
      generating_subtitles: "Generating subtitles...",
      confirm_delete_title: "Delete Subtitles",
      confirm_delete_message:
        "Are you sure you want to delete all subtitles for this language? This action cannot be undone.",
      cancel: "Cancel",
      delete_confirm: "Delete",
    },
    Text: "Data",
    text_here: "Text goes here",
    Title: " Title",
    Title_document: "Lesson Title",
    Slide_document: "Slide Title",
    Page_document: "Page Document",
    Filter: "Filter",
    SelectAFolder: "Select a Folder...",
    Undo: "Undo",
    Units: "Units",
    Unpublish: "Unpublish",
    Uploading: "Uploading...",
    Upload_to_ViSH: "Upload to ViSH",
    Uploaded_Images: "UPLOADED IMAGES",
    Uploaded_Images_No: "You have not uploded any image",
    vertical: "Vertical subtitle",
    Vertical_align: "Vertical Alignment",
    vish_search: "VISH Search",
    vish_search_terms: "Search terms",
    vish_search_button: "Search",
    vish_search_by: "Search by",
    vish_search_by_type: "Search by type",
    vish_search_filters: {
      ranking: "Ranking",
      popularity: "Popularity",
      modification: "Modification",
      creation: "Creation",
      visits: "Visits",
      favorites: "Likes",
      quality: "Quality",
    },
    vish_search_types: {
      Picture: "Picture",
      Resource: "All",
      Audio: "Audio",
      Embed: "Embed",
      Excursion: "Excursion",
      Swf: "Flash Object",
      Link: "Link",
      Officedoc: "PDF",
      // "Scormfile": "SCORM Package",
      Video: "Video",
      Webapp: "Web Application",
      Workshop: "Workshop",
      Writing: "Writing",
      XML: "XML",
      JSON: "JSON",
      CSV: "CSV",
      OBJ: "OBJ",
      All: "All",
      Zipfile: "ZIP File",
      IdealStudioDocument: "Aideapro Studio Document",
      Arrows: "Arrows",
      Education: "Education",
    },
    vish_upload: "Upload",
    vish_upload_desc: "Description",
    vish_upload_other: "Upload pictures, videos and other resources",
    vish_upload_title: "Title",
    "Want some help?": "Want some help?",
    Weight: "Weight",
    Width: "Width",
    Width_percentage: "Width (%)",
    Width_pixels: "Width (px)",
    languages: {
      Afrikanns: "Afrikanns",
      Albanian: "Albanian",
      Arabic: "Arabic",
      Armenian: "Armenian",
      Basque: "Basque",
      Bengali: "Bengali",
      Bulgarian: "Bulgarian",
      Catalan: "Catalan",
      Cambodian: "Cambodian",
      Chinese: "Chinese",
      Azerbaijani: "Azerbaijani",
      Croation: "Croation",
      Czech: "Czech",
      Danish: "Danish",
      Dutch: "Dutch",
      English: "English",
      Estonian: "Estonian",
      Fiji: "Fiji",
      Finnish: "Finnish",
      French: "French",
      Georgian: "Georgian",
      German: "German",
      Greek: "Greek",
      Gujarati: "Gujarati",
      Hebrew: "Hebrew",
      Hindi: "Hindi",
      Hungarian: "Hungarian",
      Icelandic: "Icelandic",
      Indonesian: "Indonesian",
      Irish: "Irish",
      Italian: "Italian",
      Japanese: "Japanese",
      Javanese: "Javanese",
      Korean: "Korean",
      Latin: "Latin",
      Latvian: "Latvian",
      Lithuanian: "Lithuanian",
      Macedonian: "Macedonian",
      Malay: "Malay",
      Malayalam: "Malayalam",
      Maltese: "Maltese",
      Maori: "Maori",
      Marathi: "Marathi",
      Mongolian: "Mongolian",
      Nepali: "Nepali",
      Norwegian: "Norwegian",
      other: "Others",
      Persian: "Persian",
      Polish: "Polish",
      Portuguese: "Portuguese",
      Punjabi: "Punjabi",
      Quechua: "Quechua",
      Romanian: "Romanian",
      Russian: "Russian",
      Samoan: "Samoan",
      Serbian: "Serbian",
      Slovak: "Slovak",
      Slovenian: "Slovenian",
      Spanish: "Spanish",
      Swahili: "Swahili",
      Swedish: "Swedish",
      Tamil: "Tamil",
      Tatar: "Tatar",
      Telugu: "Telugu",
      Thai: "Thai",
      Tibetan: "Tibetan",
      Tonga: "Tonga",
      Turkish: "Turkish",
      Ukranian: "Ukranian",
      Urdu: "Urdu",
      Uzbek: "Uzbek",
      Vietnamese: "Vietnamese",
      Welsh: "Welsh",
      Xhosa: "Xhosa",
    },
    TextAnimations: {
      title: "Text Animations",
      chooseAnimation: "Choose Animation",
      preview: "Preview",
      settings: "Settings",
      duration: "Duration (seconds)",
      delay: "Delay (seconds)",
      delayDescription: "Animation will start after this delay",
      replay: "Replay",
      applyAnimation: "Apply Animation",
      deleteAnimation: "Delete Animation",
      sampleText: "Sample Text Animation",
      animations: {
        fadeIn: "Fade In",
        slideInRight: "Slide In Right",
        slideInLeft: "Slide In Left",
        slideInUp: "Slide In Up",
        slideInDown: "Slide In Down",
        scaleIn: "Scale In",
        rotateIn: "Rotate In",
        bounceIn: "Bounce In",
        typeWriter: "Type Writer",
        wavyText: "Wavy Text",
      },
    },
    BoxAnimations: {
      title: "Box Animations",
      chooseAnimation: "Choose Animation",
      preview: "Preview",
      settings: "Settings",
      duration: "Duration (seconds)",
      delay: "Delay (seconds)",
      delayDescription: "Delay before animation starts",
      replay: "Replay",
      applyAnimation: "Apply Animation",
      deleteAnimation: "Delete Animation",
      sampleText: "Sample Box",
    },
    AssessmentMenu: {
      nAnswers: "Number of answers",
      nStatements: "Number of statements",
      nItems: "Number of items",
      nPairs: "Number of pairs",
      nBlanks: "Number of blanks",
      labels: "Labels",
      shuffleAnswers: "Shuffle answers",
      shuffle: "Shuffle",
      showFeedback: "Show feedback",
      partialCredit: "Partial credit",
      points: "Points",
      minLength: "Min length",
      maxLength: "Max length",
      countCharacters: "Count characters",
      buttons: "Buttons",
      addAnswer: "Add answer",
      removeAnswer: "Remove answer",
      addOne: "Add one",
      removeOne: "Remove one",
      editQuestion: "Edit question",
      fitToScreen: "Fit to screen",
      duplicate: "Duplicate",
      preview: "Preview",
      previewThisQuestion: "Preview this question",
      moreOptions: "More options",
      styleAndColors: "Style & colors…",
      delete: "Delete",
      deleteQuestion: "Delete question",
      assessmentOptions: "Assessment options",
      questionOptions: "Question options",
      richTextEditor: "Rich text editor",
      setBlankAnswers: "Set the correct answer for each blank",
      correctAnswers: "Correct answers",
      noBlanksYet: "No blanks yet — add one with “+ fill area”.",
      blank: "Blank",
      correctValue: "correct value",
      correctAnswerPlaceholder: "correct answer",
      addFillBlank: "Add a fill-in blank",
      addDragArea: "Add a drag area",
    },
    pages: "Pages",
    doc_name: "Doc name",
    edit: "Edit",
    "Image Animator": "Image Animator",
    "Current Image": "Current Image",
    "No image selected": "No image selected",
    NoPreviewImage: "No preview image available",
    "View fullscreen": "View fullscreen",
    "Animate your static image using AI": "Animate your static image using AI",
    "Remove background from the image": "Remove background from the image",
    "Remove specific objects from the image": "Remove specific objects from the image",
    "Remove text from the image": "Remove text from the image",
    "Translate text within the image": "Translate text within the image",
    "Generate similar variations of the image": "Generate similar variations of the image",
    "Edit your image using AI": "Edit your image using AI",
    "Change text content within the image": "Change text content within the image",
    "Change the aspect ratio of the image using AI":
      "Change the aspect ratio of the image using AI",
    "Increase image resolution using AI": "Increase image resolution using AI",
    "Generate a similar infographic based on this image":
      "Generate a similar infographic based on this image",
    "Replace a garment or product using a reference image":
      "Replace a garment or product using a reference image",
    "Decompose this image into editable layers": "Decompose this image into editable layers",
    "Separate the baked-in text into editable text boxes":
      "Separate the baked-in text into editable text boxes",
    "Animated Result": "Animated Result",
    Duration: "Duration",
    Size: "Size",
    "Animation Prompt (Optional)": "Animation Prompt (Optional)",
    "Animation Prompt Placeholder":
      "Describe how you want to animate the image (e.g., 'Add smooth camera zoom and gentle movement', 'Create a subtle parallax effect with floating elements')",
    "AI Provider": "AI Provider",
    "Coming Soon": "Coming Soon",
    Reject: "Reject",
    "Starting Animation...": "Starting Animation...",
    "Start Animation": "Start Animation",
    "Please enter an animation prompt": "Please enter an animation prompt",
    "Animation generation failed. Please try again.":
      "Animation generation failed. Please try again.",
    "Failed to check job status": "Failed to check job status",
    "Failed to start animation": "Failed to start animation",
    "Failed to submit animation job": "Failed to submit animation job",
    "Failed to fetch job status": "Failed to fetch job status",
    Error: "Error",
    training: {
      completed_exit: "You have completed the training. Do you want to exit?",
      completed: "You have completed the training.",
      failed: "Training Failed",
      failed_message:
        "Because the target success rate in the evaluation questions was not reached ({{correct}} / {{required}}), the training will automatically restart.",
      yes: "Yes",
      no: "No",
      ok: "OK",
      previously_started: "You have previously worked on this training...",
      continue_from_bookmark: "Continue from where I left off",
      restart_from_beginning: "Restart Training from the Beginning",
      close: "Close",
    },

    "Image Animator": "Image Animator",
    "Merlin Image Animator": "Aidea Wizard Image Animator",
    "Image Edit": "Image Edit",
    "Resize the Image": "Resize the Image",
    "Resize the image": "Resize the Image",
    "Replace Text": "Replace Text",
    "Generate Image with Text": "Generate Image with Text",
    "Generate with Style Reference": "Generate with Style Reference",
    "Select Feature": "Select Feature",
    Yakında: "Coming Soon",
    "Animate Image": "Animate Image",
    AnimateImageNoReference: "Animate Image — unavailable: no reference image",
    ExtractText: "Extract Text",
    "Remove Background": "Remove Background",
    "Remove Object": "Remove Object",
    "Add Object": "Add Object",
    "Add Logo": "Add Logo",
    "Edit Region": "Edit with Prompt",
    "Remove Text": "Remove Text",
    "Translate Text": "Translate Text",
    "Generate Similar": "Generate Similar",
    "Change Object": "Change Object",
    "Edit Image": "Edit Image",
    "Change Image Text": "Change Image Text",
    "No image selected": "No image selected",
    NoPreviewImage: "No preview image available",
    Prompt: "Prompt",
    EnterDescriptionPlaceholder: "Enter description...",
    EditImagePromptPlaceholder:
      "Describe changes (e.g. 'Change the background to a tropical beach sunset')",
    RemoveObjectPromptPlaceholder: "What should be removed? (e.g. 'horse')",
    RemoveObjectSelectAreaLabel: "Area to Remove (Optional)",
    RemoveObjectSelectAreaButton: "Select Area",
    RemoveObjectAreaReselect: "Reselect Area",
    RemoveObjectAreaSelected: "Area selected",
    RemoveObjectSelectAreaHint:
      "Draw a box over the object to remove. If you select an area, a prompt is optional.",
    ChangeObjectPromptPlaceholder:
      "Describe the object to replace and what to replace it with (e.g. 'Replace the red car with a blue bicycle')",
    "Text Changes": "Text Changes",
    Add: "Add",
    OriginalTextPlaceholder: "Original text (e.g. Hello World)",
    NewTextPlaceholder: "New text (e.g. Hello World)",
    SelectText: "Select Text",
    DragOverTextToExtract: "Drag over the text you want to extract",
    ExtractingText: "Extracting text…",
    NoTextDetected: "No text found in the selected area",
    TextExtractionFailed: "Could not extract text",
    EnterCustomLocationPlaceholder: "Enter custom location...",
    SelectLocation: "Select location",
    "Top Left": "Top Left",
    "Top Center": "Top Center",
    "Top Right": "Top Right",
    "Middle Left": "Middle Left",
    Center: "Center",
    "Middle Right": "Middle Right",
    "Bottom Left": "Bottom Left",
    "Bottom Center": "Bottom Center",
    "Bottom Right": "Bottom Right",
    Custom: "Custom",
    "Target Language": "Target Language",
    Count: "Count",
    "AI Provider": "AI Provider",
    "Advanced Settings": "Advanced Settings",
    "Output Format": "Output Format",
    "Optimized size, good quality": "Optimized size, good quality",
    "Full quality, larger size": "Full quality, larger size",
    DurationSecondsShort: "{{count}}s",
    Loop: "Loop",
    "Play Once": "Play Once",
    "Transparent Background": "Transparent Background (Extra Cost)",
    ExtendAnimation: "Extend (+8s)",
    ExtendToSceneDuration: "Fit to scene duration (~{{sec}}s)",
    Extended: "Extended",
    "Failed to extend animation": "Failed to extend animation",
    ConvertToLoop: "Convert to Loop",
    ConvertToPlayOnce: "Convert to Play Once",
    PreviewAndEdit: "Preview & Edit",
    AnimEdit: {
      ActionsTitle: "Actions",
      AddAsMp4: "Add to scene as MP4",
      AddAsWebp: "Add to scene as WebP",
      ExtendTitle: "Extend",
      Model: "Model",
      AddPrompt: "Add prompt",
      ContinuationPromptPlaceholder:
        "Leave empty for automatic mode — the AI derives the next motion from the last frame.",
      ExtendUnavailableProvider:
        "Extend is only available for Gemini animations. This one was generated with {{provider}}; loop conversion is still available.",
      NoSourceVideo:
        "This version has no source video, so it can't be extended or converted. You can still apply it.",
      MaxDurationHint: "max. 45s",
      ReferenceImageLabel: "Continuation image (optional)",
      Upload: "Upload",
      PickFromScene: "From scene",
      PickFromLibrary: "From library",
      Applied: "Applied",
      UseFrameAsContinuation: "Use this frame as continuation image",
      FrameTimeReadout: "{{t}} / {{d}}s",
      FrameExtractFailed: "Couldn't extract that frame.",
      SummaryDuration: "Animation: {{sec}}s",
      SummarySceneWindow: "On scene: {{start}}–{{end}}s",
      InfoShownWindow: "Shown on scene between {{start}}–{{end}}s",
      InfoNeeded: "Required duration: {{sec}}s",
      Advanced: "Advanced",
      SimpleView: "Simple view",
      SummaryPrompt: "Prompt: {{prompt}}",
      NoPromptGiven: "No prompt given",
      TabDuration: "Duration",
      TabFormat: "Format",
      TabContinuation: "Continuation image",
      SceneFitRequired: "Required {{sec}}s",
      SceneFitProduced: "{{sec}}s produced",
      SceneFitShortfall: "{{sec}}s short",
      SceneFitCapNote: "Total capped at {{sec}}s",
      RangeSummary: "{{from}}s → {{to}}s · max {{cap}}s",
      ExtendSettingsLabel: "Extending with",
      NoContinuationImage: "No continuation image",
      Change: "Change",
      ModelGeminiOnlyHint: "Extending is only available for Gemini animations",
      StepSetup: "Setup",
      StepGenerate: "Generate",
      StepEdit: "Edit",
      SourceImageLabel: "Source image",
      RegenerateFromSourceHint:
        "Generate a new animation from the same image with these settings (you can change them)",
      EditSourceImageHint: "Edit the latest still image (e.g. fix its text), then animate it again",
      MotionDescriptionLabel: "Motion description",
      OptionalLabel: "optional",
      PlaybackLabel: "Playback",
      PlaybackHint: "Loop continuously in the scene?",
      SetupSceneFitBanner:
        "This element appears on the scene between {{start}}–{{end}}s. A {{sec}}s animation fills that window exactly.",
      GeneratingTitle: "Generating animation",
      GeneratingHint: "Usually takes 40–90s",
      ElapsedTime: "{{time}} elapsed",
      ContinueInBackground: "Continue in background",
      CancelJob: "Cancel",
      ResultReadyTitle: "Animation ready",
      ResultReadySummary:
        "{{sec}}s · {{playback}} · {{provider}} — fills the scene's {{windowSec}}s window",
      ResultReadySummaryNoWindow: "{{sec}}s · {{playback}} · {{provider}}",
      Regenerate: "Regenerate",
      Retry: "Try again",
      BackToSetup: "Back to setup",
      BackToResult: "Back to result",
      ApplyToScene: "Apply to scene",
      HistoryTitle: "Version history",
      HistoryFilterAll: "All",
      HistoryFilterAnimations: "Animations",
      HistoryFilterEdits: "Edits",
      HistoryFilterEmpty: "No versions match this filter",
      HistoryOnScene: "On scene",
      HistoryConfirmHint: "selected — confirming will replace the scene item with this version.",
      BackButton: "Back",
      ActivityLogTitle: "Activity Log",
      HistoryHeader: "History",
      HistoryCollapse: "Hide history",
      HistoryExpand: "Show history",
      SendToPopup: "Open in popup",
    },
    Processing: "Processing...",
    "Processing Failed": "Processing Failed",
    "Job failed": "Job failed",
    "Failed to check job status": "Failed to check job status",
    "API URL not configured": "API URL not configured",
    "The operation could not be completed. Please try again.":
      "The operation could not be completed. Please try again.",
    ImageAnimationFailedGenericMessage: "The operation could not be completed. Please try again.",
    AnimationCopyrightBlocked:
      "Google could not animate this image because it appears to contain copyrighted, trademarked, or celebrity content. Please try a different, copyright-free image.",
    AnimationSafetyBlocked:
      "Google could not animate this image because the AI service's safety policy does not allow it (e.g. photorealistic children, violence or sensitive content). Please try a different image.",
    AiProviderSafetyBlocked:
      "The AI service declined this request under its safety policy. The input (image or text) may contain restricted content, e.g. photorealistic children, violence or inappropriate language. Please try again with different content.",
    AiProviderCopyrightBlocked:
      "The AI service declined this request because the input appears to contain copyrighted, trademarked or celebrity content. Please try again with different, copyright-free content.",
    Dismiss: "Dismiss",
    "Dismiss All": "Dismiss All",
    "Result Ready": "Result Ready",
    Option: "Option",
    "Use This": "Use This",
    "Accept & Replace": "Accept & Replace",
    "Animation Result": "Animation Result",
    Start: "Start",
    "Unknown error": "Unknown error",
    "Resize Image": "Resize Image",
    "Upscale Image": "Upscale Image",
    "Generate Similar Infographic": "Generate Similar Infographic",
    GenerateFromReferencePromptPlaceholder:
      "Describe the image you want to generate based on this reference...",
    "Replace Product": "Replace Object",
    Optional: "optional",
    Remove: "Remove",
    "Failed to upload image": "Failed to upload image",
    ReplaceProduct: {
      SelectObjectLabel: "Select the object to replace",
      SelectObjectButton: "Select object on image",
      SelectObjectHint: "Draw a box around the object on the image you want to replace.",
      OptionalBadge: "optional",
      TargetObjectTitle: "Extra note",
      TargetObjectLabel: "Extra note (optional)",
      TargetObjectPlaceholder: "e.g. 'the jacket', 'the mug'",
      TargetObjectHint:
        "If the selected box contains more than one thing, say which one you mean. Leave empty to replace whatever is inside the box.",
      AdaptStyleLabel: "Adapt object to image style",
      AdaptStyleHint:
        "When on, the reference object is re-rendered to match the source image's style before it is inserted. When off, it is inserted as-is.",
      RegionSelected: "Region selected",
      RegionSelectedReselect: "Reselect region",
      DragOverObject: "Drag over the object to replace",
      ReferenceImageLabel: "Reference image (new object)",
      ReferenceSelected: "Reference image selected",
      ChangeUpload: "Change",
      ChooseFromHistory: "Choose from history",
      PickFromLibrary: "Choose from library",
      PickFromLibraryTitle: "Choose a reference image from the library",
      UploadHint: "Upload or drag & drop an image (PNG, JPG, JPEG)",
      InvalidFileType:
        "This file type is not accepted. Please upload an image only (PNG, JPG, JPEG).",
      PromptLabel: "Extra guidance",
      PromptPlaceholder: "Optional: e.g. 'replace only the jacket, keep the pose and background'",
      PickReferenceTitle: "Choose a reference image",
    },
    LogoIntro: {
      templates: "Template",
      logo: "Logo",
      upload: "Upload logo",
      remove: "Remove logo",
      from_library: "Brand library logos",
      title: "Title",
      title_ph: "e.g. Information Security Awareness",
      subtitle: "Subtitle",
      subtitle_ph: "e.g. Welcome to the course",
      primary: "Main colour",
      accent: "Accent colour",
      theme: "Background",
      light: "Light",
      dark: "Dark",
      dark_hint: "Logos with dark lettering read better on a light background.",
      preview: "Preview",
      previewing: "Preparing…",
      preview_empty: "Pick a template to preview",
      add: "Add",
      adding: "Adding…",
      seconds: "{{n}} s",
      error: "The logo intro could not be created",
      upload_failed: "The logo could not be uploaded",
      load_failed: "Templates could not be loaded",
      scene_name: "Intro",
      text_section: "Text",
      font: "Font",
      font_default: "Default",
      size: "Text size",
      text_color: "Text colour",
      text_color_auto: "Automatic",
      style: "Style",
      bold: "Bold",
      uppercase: "UPPERCASE",
      sec_template: "Template",
      sec_logo: "Logo",
      sec_text: "Text",
      sec_look: "Appearance",
      sec_output: "Output",
      sec_preview: "Preview",
      text_style: "Text style",
      look_hint: "Colours come from your brand kit",
      output_motion: "Motion",
      output_mp4: "MP4",
      output_webp: "WebP",
      output_motion_desc: "Live animation scene, editable in the editor.",
      output_mp4_desc: "Rendered to a video file and added as a video.",
      output_webp_desc: "Rendered to a looping animated image.",
      place: "Where",
      place_start: "Start of course",
      place_after: "After this scene…",
      place_scene: "Scene to insert after",
      rendering: "Rendering video…",
      rendering_webp: "Rendering animated image…",
      render_wait_hint: "This can take a minute or two.",
    },
    AreaOps: {
      Title: "Edit Image",
      TabEdit: "Edit",
      TabArea: "Area Operations",
      Intro:
        "Pick a feature, mark an area on the image, apply. Operations run in the background one after another; you stay free to keep working.",
      DrawRegionHint: "Draw a region on the image",
      ClickPointHint: "Click a point on the image",
      Empty: "No operations yet. Pick a feature above.",
      Apply: "Apply",
      RemoveLast: "Remove Last Pin",
      RevertOriginal: "Revert to Original",
      RevertToVersion: "Revert to this version",
      Working: "Working…",
      ReferenceImage: "Reference image",
      UploadReference: "Upload reference image",
      RemoveReference: "Remove",
      Remove: "Remove",
      TargetObjectPlaceholder: "e.g. 'jacket', 'mug' (optional)",
      PromptOptional: "Extra instruction (optional)",
      RemoveObjectPromptPlaceholder: "What to remove? (optional)",
      OriginalTextPlaceholder: "Original text",
      NewTextPlaceholder: "New text",
      EditRegionPromptPlaceholder: "How should I edit this area?",
      TargetLanguage: "Target language",
      SelectLanguage: "Select language",
      StatusDraft: "draft",
      StatusQueued: "queued",
      StatusRunning: "running",
      StatusDone: "done",
      StatusFailed: "failed",
      History: "History",
      OriginalVersion: "Original",
      EditRegionPromptPlaceholder:
        "How should this area be edited? (e.g. 'make it blue', 'remove the stain', 'move it right')",
      AddObjectPromptPlaceholder: "What should I add here? (e.g. a red apple)",
      LogoImage: "Logo",
      UploadLogo: "Upload logo",
      PickFromLibrary: "Choose from library",
      LibraryNoLogos: "No logos in the brand library yet",
      LibraryLoadFailed: "Couldn't load the brand library",
      ApplyLogoToAllImages: "Apply to all images in the training",
      // Batch area ops (area-ops-batch)
      AddToList: "Add to List",
      BatchLabel: "Batch Edit",
      MaxOpsReached: "At most {{max}} operations can be added",
      StatusStaged: "listed",
      BatchUnsupported: "Batch editing is not supported; operations run one by one",
      InsufficientBalance: "Insufficient balance",
      OpUnchanged:
        "No change was detected in this area. Check the result before applying it again.",
      OpMarkerInk:
        "The model drew a marker in this area. Check the result before applying it again.",
      OpLogoFailed: "The logo could not be added. Try a different logo file.",
      // Whole-image mode + the features moved in from the AI Wizard
      ApplyToWholeImage: "Apply to whole image",
      WholeImage: "Whole image",
      ResizeImage: "Resize",
      SimilarInfographic: "Similar Infographic",
      ReplaceProductCard: "Replace Object",
      RemoveObjectWholePromptPlaceholder: "What to remove? (e.g. 'the chair in the back')",
      ResizeBlockedByStaged: "The aspect ratio can't change while area operations wait in the list",
    },
    ReplaceBackground: {
      ReferenceImageLabel: "Background place (reference image)",
      ReferenceSelected: "Reference place selected",
      ChangeUpload: "Change",
      UploadHint: "Upload or drag-drop a place image (PNG, JPG, JPEG)",
      SelectAreaLabel: "Area to replace",
      SelectAreaButton: "Select area on image",
      RegionSelectedReselect: "Reselect area",
      PromptLabel: "Extra instruction",
      PromptPlaceholder: "Optional: e.g. 'golden hour lighting', 'keep it indoors'",
    },
    "Aspect Ratio": "Aspect Ratio",
    "Scale Factor": "Scale Factor",
    Language: {
      Turkish: "Turkish",
      English: "English",
      Spanish: "Spanish",
      French: "French",
      German: "German",
      Chinese: "Chinese",
      Azerbaijani: "Azerbaijani",
      Arabic: "Arabic",
      Russian: "Russian",
      Japanese: "Japanese",
      Portuguese: "Portuguese",
    },
    GuideMultiInput: {
      flow_items_title: "Flow Items",
      add_click: "Add Click",
      add_input: "Add Input",
      empty_items: "No items yet. Add click or input items using the buttons above.",
      kind_click: "Click",
      kind_input: "Input",
      label: "Label",
      label_placeholder: "Optional label",
      item_color: "Item Color",
      success_message: "Success Message",
      success_placeholder: "e.g. Great job!",
      failure_message: "Failure Message",
      failure_placeholder: "e.g. Check your spelling",
      on_click_label: "On Click",
      onClick_next_item: "Go to next item",
      onClick_step: "Go to specific scene",
      target_step_label: "Target Scene",
      pick_target: "— Pick a scene —",
      click_here: "Click here",
      tag: "Tag (optional, for later reference)",
      tag_placeholder: "e.g. firstName",
      validation_mode: "Validation Mode",
      validation_exact: "Exact match",
      validation_random: "Random length",
      expected_value: "Expected Value",
      min_chars: "Min",
      max_chars: "Max",
      move_up: "Move up",
      move_down: "Move down",
      delete_item: "Delete",
      delete: "Delete",
      expand_item: "Expand",
      collapse_item: "Collapse",
      expand_all: "Expand all",
      collapse_all: "Collapse all",
    },
    EditorShortcuts: {
      mini_preview: "Mini preview",
    },
    Original: "Original",
    Versions: "History",
    "Loading versions": "Loading history",
    Animate: "Animate",
    Replace: "Replace",
    Reference: "Reference",
    "Text to Image": "Text to Image",
    Infographic: "Infographic",
    Attempt: "Attempt",
    Version: "Version",
    "No history": "No history",
    Result: "Result",
    Failed: "Failed",
    "Result will appear here": "Result will appear here",
    Scene: "Scene",
    Scenes: "Scenes",
    Settings: "Settings",
    AnimationLabel: "Animation",
    Effect: "Effect",
    "Edit Text": "Edit Text",
    "Edit HTML": "Edit HTML",
    "Replace File": "Replace File",
    "Plugin Settings": "Plugin Settings",
    "Fit to Screen": "Fit to Screen",
    "Fit to Document": "Fit to Document",
    "Text Size": "Text Size",
    "Increase Text": "Increase Text",
    "Decrease Text": "Decrease Text",
    // === Task 44 === Workflow / Scene Interaction Workflow translations
    Workflow: {
      title: "Workflow",
      EmptyScene: "No content in this scene yet.",
      EmptySceneHint: "Workflow will appear here as you add content.",
      trigger: "Trigger",
      variable: "Variable",
      template: "Template",
      simulate: "Simulate",
      add_action: "Add action",
      delete_trigger: "Delete trigger",
      close: "Close",
      generating: "Generating workflow…",
      done: "Done",
      failed: "Generation failed",
      close_to_widget: "Close (keep running in widget)",
      suggestions: "Suggestions",
      make_suggestion: "Make Suggestion",
      no_suggestions: "No suggestions yet.",
      scope_scene: "Scope: this narration",
      scope_course: "Scope: whole course",
      insert_after: "Insert after which scene?",
      insert_beginning: "(at the beginning)",
      fab: "Open workflow",
      fab_tooltip: "Open workflow editor",
      fab_chip: "workflow",
      add_interaction: "Add Interaction",
      click_hint: "click any trigger to inspect →",
      // === Interactivity Studio (Tasks 1-28) ===
      add_trigger: "Trigger",
      add_variable: "Variable",
      add_template: "Template",
      back_to_graph: "Back to graph",
      no_suggestions_yet: "No suggestions yet for this training",
      suggestions_explainer:
        "AI can scan your scenes and suggest where adding interactivity would deepen learning.",
      generate_for_scene: "Generate for",
      generate_for_course: "For the whole course",
      suggestions_hint:
        "Per-scene is best when iterating; whole-course is a once-per-training baseline.",
      scene_has_no_content: "This scene has no content yet",
      no_workflow_yet: "No workflow yet",
      no_workflow_explainer:
        "This training doesn't have any interaction rules. We can generate a baseline that mirrors your scene order and existing assessments — you can edit it after.",
      generate_workflow: "Generate Workflow",
      fill_empties_hint: "Sections that already have workflow rules will be skipped.",
      generating_for: "Generating…",
      view_progress: "View progress",
      cancel: "Cancel",
      loading: "Loading…",
      export_title: "Export workflow as JSON",
      import_title: "Import workflow from JSON",
      presets_select_plugin_first: "Select an InteractivePlugin to apply a template.",
      use_wizard_instead: "Use wizard instead",
      review_tooltip: "Run a pedagogical review of this workflow",
      review_workflow: "Review workflow",
      translate_tooltip: "Translate the current scene's interactions",
      translate_scene: "Translate scene",
      event: "Event",
      scene: "Scene",
      no_scenes: "(no scenes)",
      plugin_box: "Interactive box",
      any_box: "Any (*)",
      create: "Create",
      scoring_mode: "Scoring mode",
      translate_picker_title: "Translate scene to…",
      translating: "Translating…",
      highlight_unreachable: "Highlight unreachable nodes",
      unreachable_count: "{{count}} unreachable node",
      unreachable_count_plural: "{{count}} unreachable nodes",
      unreachable: "unreachable",
      delete_variable: "Delete variable",
      variable_invalid_id:
        "Use lowerCamelCase (letters/digits, must start with a lowercase letter).",
      variable_duplicate_id: "A variable with this id already exists.",
      variables: "Variables",
      variable_id_placeholder: "name (e.g. score)",
      variable_initial_placeholder: "initial value",
      add: "Add",
      variables_empty: "No variables yet. Add one to use in setVar / branch actions.",
    },
    InteractivityStudio: {
      title: "Interactivity Studio",
      scene: "Scene",
      close: "Close",
      tab: {
        workflow: "Workflow",
        suggestions: "Suggestions",
        flow_viewer: "Flow Viewer",
      },
    },
    Wizard: {
      q1: "What kind of interaction?",
      q2: "When the learner does that, what happens?",
      q3_branch: "Where does the WRONG path lead?",
      q3_review: "Review your choices",
      back: "Back",
      create: "Create",
      pick_scene: "Pick a scene…",
    },
    Akis: {
      title: "FLOW ITEMS",
      empty: "No items yet. Use the buttons above to add one.",
      label: "Label",
      triggers: "triggers attached",
      remove: "Remove",
    },
    AiSuggestions: {
      button: "Suggestions",
    },
    FlowViewer: {
      title: "Flow Viewer",
      current_context: "current scene context",
      mode: {
        all: "Show All",
        scene: "Show Scene",
        storyboard: "Storyboard",
      },
    },
    LeftPanel: {
      scenes: "SCENES",
      flow_viewer: "Flow viewer",
      flow_viewer_tooltip: "Open Flow Viewer",
    },
    SkipInteractive: {
      label: "Skip Interactive",
      button: "Skip",
      help: "When checked, a Skip button appears on the right-bottom of the viewport during the interactive moment.",
    },
    // === /Task 44 ===
    layersPanel: {
      title: "Layers",
      showAll: "Show all",
      hideAll: "Hide all",
      lockAll: "Lock all",
      unlockAll: "Unlock all",
      show: "Show",
      hide: "Hide",
      lock: "Lock",
      unlock: "Unlock",
      lockedNoDrag: "Locked",
      dragToReorder: "Drag to reorder",
      dragGroup: "Drag to move the whole group",
      elements: "elements",
    },
    scenePaste: {
      copyScene: "Copy scene",
      copied: "Scene copied — paste it into any training.",
      title: "Add scene to this training?",
      contains: "Contains",
      image: "image",
      images: "images",
      video: "video",
      videos: "videos",
      sound: "sound",
      sounds: "sounds",
      narration: "narration",
      narrations: "narrations",
      mediaCopied: "Its media will be copied into this training.",
      mediaReused: "Its media will be reused.",
      addScene: "Add scene",
      copying: "Copying…",
      done: "Done — scene added.",
      error: "Failed to paste scene: ",
    },
    "Edit Image v2": "Edit Image v3",
    styles_load_error: "Failed to load style templates",
    Generated: "Generated",
    UnknownError: "Unknown error",
    SoundUploadFailed: "Sound upload failed",
    Added: "Added",
    Search: "Search",
    Storyboard: "Storyboard Videos",
    NoResults: "No images found",
    "No video selected": "No video selected",
    aiTools: "AI",
    Rotation: "Rotation",
    BoxMoveHandle: "Drag to move",
    Cancelled: "Cancelled",
    warning_title: "Warning",
    Page: "Page",
    soundList: "Sound list",
    "BoxAnimations--title": "Element Animations",
    sound_fx_delete_confirm: "Are you sure you want to delete this effect?",
    sound_fx_delete_error: "Could not delete the effect",
    "Insufficient balance": "Insufficient balance",
    "Result not ready yet": "Result not ready yet",
    "Result URL missing": "Result URL missing",
    "No handler to apply result": "No handler to apply result — please report this.",
    avatarAnimate: {
      starting: "Sending…",
      sent: "Queued",
      trigger: "Animate avatars",
      sceneNone: "No avatar to animate in this scene",
      scene: "Animate the avatar in this scene",
      none: "No avatars left to animate",
      all: "Animate avatars in all scenes",
      history: "History",
      use: "Apply",
      historyEmpty: "No history for this scene",
    },
    interactive: {
      library: "Add Element",
      library_search_placeholder: "Filter elements…",
      library_search_label: "Filter interactive elements",
      library_search_clear: "Clear filter",
      library_search_count: "Showing {{shown}} of {{total}}",
      library_search_empty: "No element matches “{{query}}”",
      moved_to_left: "Add elements from the Interactive Elements section in the left rail.",
    },
    LibraryCatalog: {
      title: "Interactive Elements Catalog",
      how_it_works: "How it works",
      live_preview: "Live preview",
      add_hint:
        "To add this element, close the catalog and click its pill in the Interactive Elements rail.",
    },
    ImageChatEdit: {
      SeedPrompt: "I want to edit this image as follows: ",
      ButtonTooltip: "Edit with chatbot",
    },
    EditorNavBar: {
      workflow_tooltip: "Open Workflow editor",
      workflow: "Workflow",
    },
    Timeline: {
      WaitingForInteractive: "The timeline is waiting for an interactive element",
      SkipInteractive: "Skip the interactive element and continue the timeline",
    },
    FlowItems: {
      selected_element: "Selected Element",
      no_selection: "Element Properties",
      click_to_select: "Select an element on the canvas to edit its properties.",
      title: "ELEMENTS",
      empty_after_move: "No items yet — use the left rail to add one.",
      remove: "Remove",
    },
    InteractivePlugin: {
      scenario: "Scenario",
    },
  },
};

export { en };
